(() => {
    /* NC GROUP · dots mecánicos recalibrados sobre 3 vistas · 2026-08-05 */
    const tag = 'machinery-explorer';
    if (customElements.get(tag)) return;

    customElements.define(tag, class extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        this.setupSectionReveal();
        this.familyKey = this.resolveFamilyKey();
        this.prepareFamilyDom();
        this.activeCategory = '1';
        this.categoryButtons = [...this.querySelectorAll('[data-category]')]
          .filter(el => el.classList.contains('mx-category-btn-ncx'));
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.stage = this.querySelector('.mx-stage-ncx');
        this.viewport = this.querySelector('.mx-viewport-ncx');
        this.hotspotPlane = this.querySelector('[data-hotspot-plane]');
        this.installPremiumViewTransition();
        if (this.familyKey === 'residuos') {
          this.installFamilyHotspotLibrary();
        } else if (this.familyKey === 'industrial') {
          this.installConstructionHotspotLibrary();
        } else {
          this.installViewHotspotLibrary();
        }
        this.hotspots = [...this.querySelectorAll('[data-hotspot]')];
        this.zone = this.querySelector('[data-zone]');
        this.description = this.querySelector('[data-description-panel]');
        this.components = this.querySelector('[data-components-panel]');
        this.brands = this.querySelector('[data-brands-panel]');
        this.detailMedia = this.querySelector('[data-detail-media]') || this.querySelector('.mx-detail-media-ncx');
        this.detailImage = this.querySelector('[data-detail-image]');
        this.detailZoneOverlay = this.querySelector('[data-detail-zone-overlay]');
        this.detailModeLabel = this.querySelector('[data-detail-mode-label]');
        this.infoSyncText = this.querySelector('[data-info-sync]');
        this.defaultDetailSource = this.detailMedia?.dataset.defaultDetail || this.detailImage?.getAttribute('src') || '';
        this.whatsapp = this.querySelector('[data-whatsapp]');
        this.quoteButton = this.querySelector('[data-quote]');
        this.infoPanel = this.querySelector('.mx-info-ncx');
        this.activeCategoryText = this.querySelector('[data-active-category]');
        this.activeViewText = this.querySelector('[data-active-view]');
        this.viewButtons = [...this.querySelectorAll('[data-view-button]')];
        this.viewSets = [...this.querySelectorAll('[data-view-set]')];
        this.installViewImageLibrary();
        this.modeToggle = this.querySelector('[data-mode-toggle]');
        this.modeToggleLabel = this.querySelector('[data-mode-toggle-label]');
        this.modeToggleEyebrow = this.querySelector('[data-mode-toggle-eyebrow]');
        this.activateGraphicButton = this.querySelector('[data-activate-graphic]');
        this.modePopup = this.querySelector('[data-mode-popup]');
        this.modePopupTitle = this.querySelector('[data-mode-popup-title]');
        this.modePopupCopy = this.querySelector('[data-mode-popup-copy]');
        this.modePopupActionLabel = this.querySelector('[data-mode-popup-action-label]');
        this.closeModePopupButton = this.querySelector('[data-close-mode-popup]');
        this.scrollToGraphicButton = this.querySelector('[data-scroll-to-graphic]');
        this.heroVisual = this.querySelector('.mx-heading-visual-ncx');
        this.heroImage = this.querySelector('.mx-heading-image-ncx');
        this.viewByCategory = {};
        this.activeView = 'front';
        this.selectedInterest = '';
        this.selectedBrand = '';
        this.activeHotspot = null;
        this.lastSelectedHotspot = null;
        this.graphicMode = false;
        this.modeTransitioning = false;
        this.viewTransitioning = false;
        this.queuedViewRequest = null;
        this.viewTransitionAnimations = [];
        this.reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches || false;
        this.imageListeners = [];
        this.brandLogoMap = new Map();

        this.querySelectorAll('[data-brand-logo-entry]').forEach(entry => {
          const name = this.normalizeText(entry.dataset.brandName || '');
          const logo = entry.dataset.brandLogo || '';
          if (name && logo) this.brandLogoMap.set(name, logo);
        });

        this.hotspots.forEach(hotspot => {
          hotspot.dataset.category = hotspot.dataset.category || '1';
        });
        this.updateVisibleHotspots();
        this.installGraphic2DMotion();

        this.categoryButtons.forEach(btn => {
          btn.addEventListener('click', () => {
            const sameCategory = btn.dataset.category === this.activeCategory;
            const compact = this.classList.contains('is-category-selected');
            const menuOpen = this.classList.contains('is-category-menu-open');

            if (sameCategory && compact && !menuOpen) {
              this.classList.add('is-category-menu-open');
              btn.setAttribute('aria-expanded', 'true');
              return;
            }

            this.setCategory(btn.dataset.category, btn.dataset.categoryName, true);
          });
        });

        this.viewButtons.forEach(btn => {
          btn.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            if (btn.dataset.category !== this.activeCategory) return;
            this.setView(btn.dataset.view || 'front', this.activeCategory);
          });
        });

        this.modeToggle?.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          this.setGraphicMode(!this.graphicMode);
        });

        this.activateGraphicButton?.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          this.setGraphicMode(!this.graphicMode, { preserveFocus: false, silent: false });
        });

        this.closeModePopupButton?.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          this.classList.remove('is-mode-popup-dismissed');
          this.closeModePopupButton.blur();
        });

        this.scrollToGraphicButton?.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          this.stage?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });



        if (this.heroVisual && this.heroImage && !this.reduceMotion) {
          this.onHeroPointerMove = event => {
            const rect = this.heroVisual.getBoundingClientRect();
            const relX = (event.clientX - rect.left) / rect.width - .5;
            const relY = (event.clientY - rect.top) / rect.height - .5;
            this.heroImage.style.setProperty('--mx-hero-rotate-y', `${(relX * 8).toFixed(2)}deg`);
            this.heroImage.style.setProperty('--mx-hero-rotate-x', `${(-relY * 5).toFixed(2)}deg`);
            this.heroImage.style.setProperty('--mx-hero-shift-x', `${(relX * 8).toFixed(2)}px`);
            this.heroImage.style.setProperty('--mx-hero-shift-y', `${(relY * 5).toFixed(2)}px`);
          };
          this.onHeroPointerLeave = () => {
            this.heroImage.style.setProperty('--mx-hero-rotate-y', '0deg');
            this.heroImage.style.setProperty('--mx-hero-rotate-x', '0deg');
            this.heroImage.style.setProperty('--mx-hero-shift-x', '0px');
            this.heroImage.style.setProperty('--mx-hero-shift-y', '0px');
          };
          this.heroVisual.addEventListener('pointermove', this.onHeroPointerMove);
          this.heroVisual.addEventListener('pointerleave', this.onHeroPointerLeave);
        }

        if (this.detailMedia && this.detailImage && !this.reduceMotion) {
          this.onDetailPointerMove = event => {
            const rect = this.detailMedia.getBoundingClientRect();
            if (!rect.width || !rect.height) return;
            const relX = (event.clientX - rect.left) / rect.width - .5;
            const relY = (event.clientY - rect.top) / rect.height - .5;
            this.detailImage.style.setProperty('--mx-detail-rotate-y', `${(relX * 1.8).toFixed(2)}deg`);
            this.detailImage.style.setProperty('--mx-detail-rotate-x', `${(-relY * 1.2).toFixed(2)}deg`);
            this.detailImage.style.setProperty('--mx-detail-shift-x', `${(relX * 1.6).toFixed(2)}px`);
            this.detailImage.style.setProperty('--mx-detail-shift-y', `${(relY * 1.0).toFixed(2)}px`);
          };

          this.onDetailPointerLeave = () => {
            this.detailImage.style.setProperty('--mx-detail-rotate-y', '0deg');
            this.detailImage.style.setProperty('--mx-detail-rotate-x', '0deg');
            this.detailImage.style.setProperty('--mx-detail-shift-x', '0px');
            this.detailImage.style.setProperty('--mx-detail-shift-y', '0px');
          };

          this.detailMedia.addEventListener('pointermove', this.onDetailPointerMove);
          this.detailMedia.addEventListener('pointerleave', this.onDetailPointerLeave);
        }

        this.hotspots.forEach(btn => {
          btn.addEventListener('click', event => {
            event.stopPropagation();
            this.openHotspot(btn);
          });
        });

        this.components?.addEventListener('click', event => {
          const interestButton = event.target.closest('[data-interest]');
          if (!interestButton) return;
          event.preventDefault();
          this.selectInterest(interestButton);
        });

        this.brands?.addEventListener('click', event => {
          const brandButton = event.target.closest('[data-brand]');
          if (!brandButton) return;
          event.preventDefault();
          this.selectBrand(brandButton);
        });

        this.querySelector('[data-close]')?.addEventListener('click', () => this.resetZoom());

        this.onViewportClick = event => {
          if (event.target.closest('[data-hotspot]')) return;
          if (this.stage?.classList.contains('is-zoomed') && this.graphicMode) this.resetZoom();
        };
        this.viewport?.addEventListener('click', this.onViewportClick);

        document.addEventListener('keydown', this.onKeydown = event => {
          if (event.key === 'Escape') this.resetZoom();
        });

        window.addEventListener('popstate', this.onPopState = () => {
          this.initializeFromUrl({ focusExplorer: false });
        });

        window.addEventListener('resize', this.onResize = () => {
          window.clearTimeout(this.resizeTimer);
          this.resizeTimer = window.setTimeout(() => {
            if (this.activeHotspot && this.graphicMode) {
              this.zoomToHotspot(this.activeHotspot);
            } else {
              this.resetZoom(true);
            }
            this.scheduleGeometryUpdate();
          }, 110);
        });

        this.querySelectorAll('.mx-image-ncx').forEach(image => {
          const onLoad = () => {
            this.scheduleGeometryUpdate();
            if (!this.activeHotspot) this.applyRestingView();
          };
          image.addEventListener('load', onLoad);
          this.imageListeners.push([image, onLoad]);
        });

        this.renderComponents(this.components?.dataset.initialComponents || '');
        this.renderBrands(this.brands?.dataset.initialBrands || '');
        this.scheduleGeometryUpdate();
        this.applyRestingView();
        this.setGraphicMode(false, { preserveFocus: false, silent: true, instant: true });

        /*
          Al llegar desde una tarjeta de categoría, la URL ya contiene
          ?categoria=...&vista=.... Se resuelve antes del primer repintado útil
          para que el explorador aparezca abierto en la opción correcta.
        */
        const openedFromRoute = this.initializeFromUrl({ focusExplorer: true });

        this.syncDetailMediaToMode({ instant: true });
        window.setTimeout(() => this.applyRestingView(), 120);
        if (!openedFromRoute) this.setWhatsApp();
      }

      disconnectedCallback() {
        this.sectionRevealObserver?.disconnect();
        document.removeEventListener('keydown', this.onKeydown);
        window.removeEventListener('popstate', this.onPopState);
        window.removeEventListener('resize', this.onResize);
        this.viewport?.removeEventListener('click', this.onViewportClick);
        this.heroVisual?.removeEventListener('pointermove', this.onHeroPointerMove);
        this.heroVisual?.removeEventListener('pointerleave', this.onHeroPointerLeave);
        this.detailMedia?.removeEventListener('pointermove', this.onDetailPointerMove);
        this.detailMedia?.removeEventListener('pointerleave', this.onDetailPointerLeave);
        this.viewport?.removeEventListener('pointermove', this.onGraphic2DPointerMove);
        this.viewport?.removeEventListener('pointerleave', this.onGraphic2DPointerLeave);
        this.viewport?.removeEventListener('pointercancel', this.onGraphic2DPointerLeave);
        this.graphic2DResetButtons?.forEach(button => button.removeEventListener('click', this.onGraphic2DControlReset, true));
        this.imageListeners?.forEach(([image, listener]) => image.removeEventListener('load', listener));
        window.cancelAnimationFrame(this.graphic2DMotionFrame);
        window.clearTimeout(this.resizeTimer);
        window.cancelAnimationFrame(this.geometryFrame);
      }

      installGraphic2DMotion() {
        if (!this.viewport || this._graphic2DMotionInstalled) return;
        this._graphic2DMotionInstalled = true;

        this.graphic2DState = {
          currentX: 0,
          currentY: 0,
          targetX: 0,
          targetY: 0
        };

        const pointerFine = window.matchMedia?.('(pointer: fine)');
        const maxX = 5.2;
        const maxY = 3.8;
        const easing = 0.105;

        const writeMotion = (x, y) => {
          if (!this.viewport) return;

          const cleanX = Math.abs(x) < 0.01 ? 0 : x;
          const cleanY = Math.abs(y) < 0.01 ? 0 : y;

          this.viewport.style.setProperty('--mx-graphic-2d-x', `${cleanX.toFixed(3)}px`);
          this.viewport.style.setProperty('--mx-graphic-2d-y', `${cleanY.toFixed(3)}px`);
          this.viewport.style.setProperty('--mx-graphic-hud-x', `${(-cleanX * .22).toFixed(3)}px`);
          this.viewport.style.setProperty('--mx-graphic-hud-y', `${(-cleanY * .22).toFixed(3)}px`);
          this.viewport.style.setProperty('--mx-graphic-light-x', `${(50 + cleanX * 1.55).toFixed(2)}%`);
          this.viewport.style.setProperty('--mx-graphic-light-y', `${(44 + cleanY * 1.75).toFixed(2)}%`);
        };

        const canMove = () => Boolean(
          !this.reduceMotion &&
          (!pointerFine || pointerFine.matches) &&
          this.graphicMode &&
          !this.modeTransitioning &&
          !this.viewTransitioning &&
          this.stage &&
          !this.stage.classList.contains('is-zoomed')
        );

        const tick = () => {
          this.graphic2DMotionFrame = null;
          const state = this.graphic2DState;
          if (!state) return;

          state.currentX += (state.targetX - state.currentX) * easing;
          state.currentY += (state.targetY - state.currentY) * easing;

          if (Math.abs(state.targetX - state.currentX) < .015) state.currentX = state.targetX;
          if (Math.abs(state.targetY - state.currentY) < .015) state.currentY = state.targetY;

          writeMotion(state.currentX, state.currentY);

          if (
            Math.abs(state.targetX - state.currentX) > .015 ||
            Math.abs(state.targetY - state.currentY) > .015
          ) {
            this.graphic2DMotionFrame = window.requestAnimationFrame(tick);
          }
        };

        const requestTick = () => {
          if (this.graphic2DMotionFrame) return;
          this.graphic2DMotionFrame = window.requestAnimationFrame(tick);
        };

        this.resetGraphic2DMotion = (immediate = false) => {
          const state = this.graphic2DState;
          if (!state) return;

          state.targetX = 0;
          state.targetY = 0;
          this.stage?.classList.remove('is-graphic-2d-active');

          if (immediate) {
            window.cancelAnimationFrame(this.graphic2DMotionFrame);
            this.graphic2DMotionFrame = null;
            state.currentX = 0;
            state.currentY = 0;
            writeMotion(0, 0);
            return;
          }

          requestTick();
        };

        this.onGraphic2DPointerMove = event => {
          if (!canMove()) {
            this.resetGraphic2DMotion(false);
            return;
          }

          const rect = this.viewport.getBoundingClientRect();
          if (!rect.width || !rect.height) return;

          const nx = Math.max(-1, Math.min(1, ((event.clientX - rect.left) / rect.width - .5) * 2));
          const ny = Math.max(-1, Math.min(1, ((event.clientY - rect.top) / rect.height - .5) * 2));

          /* Curva suave: menos movimiento en el centro y máximo sólo en los bordes. */
          const curvedX = Math.sign(nx) * Math.pow(Math.abs(nx), 1.28);
          const curvedY = Math.sign(ny) * Math.pow(Math.abs(ny), 1.34);

          this.graphic2DState.targetX = curvedX * maxX;
          this.graphic2DState.targetY = curvedY * maxY;
          this.stage?.classList.add('is-graphic-2d-active');
          requestTick();
        };

        this.onGraphic2DPointerLeave = () => this.resetGraphic2DMotion(false);
        this.onGraphic2DControlReset = () => this.resetGraphic2DMotion(true);

        this.viewport.addEventListener('pointermove', this.onGraphic2DPointerMove, { passive: true });
        this.viewport.addEventListener('pointerleave', this.onGraphic2DPointerLeave, { passive: true });
        this.viewport.addEventListener('pointercancel', this.onGraphic2DPointerLeave, { passive: true });

        this.graphic2DResetButtons = [
          ...this.categoryButtons,
          ...this.viewButtons,
          this.modeToggle,
          this.activateGraphicButton
        ].filter(Boolean);

        this.graphic2DResetButtons.forEach(button => {
          button.addEventListener('click', this.onGraphic2DControlReset, true);
        });

        writeMotion(0, 0);
      }

      resolveFamilyKey() {
        let url;
        try {
          url = new URL(window.location.href);
        } catch (_) {
          return 'industrial';
        }

        /*
          RUTAS MAESTRAS DEL EXPLORADOR
          --------------------------------
          La familia se detecta por la página real de Shopify.

          Industrial:
          /pages/categorias-maquinaria-industrial

          Equipos de recolección de residuos:
          /pages/equipos-de-recoleccion

          Se conserva ?familia=residuos únicamente como compatibilidad
          para pruebas o enlaces antiguos, pero ya no es necesario.
        */
        const pathname = (url.pathname || '').toLowerCase().replace(/\/+$/, '');
        const requested = this.slugify(url.searchParams.get('familia') || '');
        const declaredProfile = this.slugify(this.dataset.catalogProfile || '');

        if (
          pathname === '/pages/equipos-de-recoleccion' ||
          pathname.endsWith('/pages/equipos-de-recoleccion')
        ) {
          return 'residuos';
        }

        const residueAliases = new Set([
          'residuos',
          'recoleccion',
          'recoleccion-de-residuos',
          'equipos-de-recoleccion',
          'equipos-de-recoleccion-de-residuos',
          'equipos-recoleccion-residuos'
        ]);

        if (residueAliases.has(requested)) return 'residuos';

        /* El Liquid declara el perfil real de cada instancia. Esto permite que
           el mismo JS sea compartido por Construcción, Pesados, Agrícola y Livianos
           sin mezclar bibliotecas de hotspots entre familias. */
        if (['industrial', 'pesados', 'agricola', 'livianos', 'custom'].includes(declaredProfile)) {
          return declaredProfile;
        }

        /* Respaldo por si Shopify agrega prefijos de idioma a la URL. */
        const pathSlug = this.slugify(pathname);
        if (pathSlug.includes('equipos-de-recoleccion')) return 'residuos';

        return 'industrial';
      }

      getFamilyProfile() {
        if (this.familyKey !== 'residuos') return null;

        return {
          key: 'residuos',
          eyebrow: 'GESTIÓN DE RESIDUOS',
          title: 'EQUIPOS DE RECOLECCIÓN DE RESIDUOS',
          subtitle: 'Explorá equipos de recolección de residuos, seleccioná una zona y encontrá los repuestos que necesitás.',
          sidebarTitle: 'SELECCIONÁ UN EQUIPO',
          sideNote: 'Equipos para recolección, transporte, lavado, barrido y compactación de residuos.',
          defaultDescription: 'Seleccioná una zona del equipo para consultar repuestos, compatibilidades y alternativas relacionadas.',
          categories: [
            { name: 'Recolectores de carga trasera', slug: 'recolectores-de-carga-trasera' },
            { name: 'Recolectores de carga lateral', slug: 'recolectores-de-carga-lateral' },
            { name: 'Recolectores de carga frontal', slug: 'recolectores-de-carga-frontal' },
            { name: 'Mini recolectores / satélite', slug: 'mini-recolectores-satelite' },
            { name: 'Portacontenedores Hooklift', slug: 'portacontenedores-hooklift' },
            { name: 'Lavacontenedores', slug: 'lavacontenedores' },
            { name: 'Barredoras viales', slug: 'barredoras-viales' },
            { name: 'Compactadores estacionarios', slug: 'compactadores-estacionarios' }
          ]
        };
      }

      makeFamilyPlaceholder(categoryName, view = 'front', mode = 'graphic') {
        const labels = {
          top: 'VISTA SUPERIOR',
          front: 'VISTA FRONTAL',
          rear: 'VISTA TRASERA',
          hero: 'FAMILIA DE EQUIPOS'
        };
        const modeLabel = mode === 'real' ? 'IMAGEN REAL · PRUEBA' : 'MODO GRÁFICO · PRUEBA';
        const safeCategory = String(categoryName || 'Equipo').replace(/[&<>"']/g, character => ({
          '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&apos;'
        })[character]);
        const viewLabel = labels[view] || 'VISTA';

        const svg = `
          <svg xmlns="http://www.w3.org/2000/svg" width="1600" height="1000" viewBox="0 0 1600 1000">
            <rect width="1600" height="1000" fill="#020914"/>
            <g opacity="0.22" stroke="#00bfff" stroke-width="1">
              ${Array.from({ length: 21 }, (_, i) => `<path d="M0 ${i * 50}H1600"/>`).join('')}
              ${Array.from({ length: 33 }, (_, i) => `<path d="M${i * 50} 0V1000"/>`).join('')}
            </g>
            <rect x="165" y="155" width="1270" height="690" rx="34" fill="#03101c" stroke="#00bfff" stroke-opacity="0.42" stroke-width="2"/>
            <path d="M315 650h970M425 515h750M545 380h510" stroke="#00bfff" stroke-opacity="0.20" stroke-width="3" stroke-linecap="round"/>
            <circle cx="800" cy="500" r="205" fill="none" stroke="#00bfff" stroke-opacity="0.13" stroke-width="2"/>
            <circle cx="800" cy="500" r="135" fill="none" stroke="#00bfff" stroke-opacity="0.20" stroke-width="2"/>
            <text x="800" y="430" text-anchor="middle" fill="#ffffff" font-family="Arial,Helvetica,sans-serif" font-size="34" font-weight="700">${safeCategory}</text>
            <text x="800" y="495" text-anchor="middle" fill="#62ddff" font-family="Arial,Helvetica,sans-serif" font-size="21" font-weight="700" letter-spacing="3">${viewLabel}</text>
            <text x="800" y="555" text-anchor="middle" fill="#8da9b8" font-family="Arial,Helvetica,sans-serif" font-size="18" letter-spacing="2">${modeLabel}</text>
            <text x="800" y="760" text-anchor="middle" fill="#5b7787" font-family="Arial,Helvetica,sans-serif" font-size="15">Reemplazar por la imagen definitiva de este equipo</text>
          </svg>`;

        return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
      }

      prepareFamilyDom() {
        const profile = this.getFamilyProfile();
        if (!profile) return;

        this.dataset.family = profile.key;
        this.dataset.defaultDescription = profile.defaultDescription;

        const eyebrow = this.querySelector('.mx-eyebrow-ncx');
        const title = this.querySelector('.mx-title-ncx');
        const subtitle = this.querySelector('.mx-subtitle-ncx');
        const kicker = this.querySelector('.mx-kicker-ncx');
        const sideNote = this.querySelector('.mx-side-note-ncx span:last-child');
        const helperTitle = this.querySelector('.mx-helper-copy-ncx strong');
        const helperText = this.querySelector('.mx-helper-copy-ncx > span');

        if (eyebrow) eyebrow.textContent = profile.eyebrow;
        if (title) title.textContent = profile.title;
        if (subtitle) subtitle.textContent = profile.subtitle;
        if (kicker) kicker.textContent = profile.sidebarTitle;
        if (sideNote) sideNote.textContent = profile.sideNote;
        if (helperTitle) helperTitle.textContent = 'Apretá en los dots';
        if (helperText) helperText.textContent = 'y elegí tu equipo';

        /*
          Importante:
          no reemplazamos la imagen del encabezado desde JS.
          La imagen correcta viene desde Shopify/Liquid en block.settings.hero_image.
          Si JS fuerza un placeholder, se pierde la imagen cargada en el editor.
        */

        const categoryList = this.querySelector('.mx-category-list-ncx');
        const categoryTemplate = categoryList?.querySelector('.mx-category-item-ncx');
        if (categoryList && categoryTemplate) {
          categoryList.replaceChildren();
          profile.categories.forEach((category, index) => {
            const number = String(index + 1);
            const item = categoryTemplate.cloneNode(true);
            const button = item.querySelector('[data-category]');
            const name = item.querySelector('.mx-category-name-ncx');
            const icon = item.querySelector('.mx-category-icon-ncx');

            item.classList.toggle('is-active-item', index === 0);
            if (button) {
              button.dataset.category = number;
              button.dataset.categoryName = category.name;
              button.dataset.categorySlug = category.slug;
              button.classList.toggle('is-active', index === 0);
              button.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
              button.setAttribute('aria-expanded', 'false');
            }
            if (name) name.textContent = category.name;
            if (icon) {
              icon.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M3.5 8.5h10v7h-10v-7Zm10 2h3.2l3.1 3v2.8h-6.3v-5.8Z" stroke="currentColor" stroke-width="1.45" stroke-linejoin="round"/>
                  <circle cx="7" cy="17.5" r="1.6" stroke="currentColor" stroke-width="1.45"/>
                  <circle cx="17" cy="17.5" r="1.6" stroke="currentColor" stroke-width="1.45"/>
                  <path d="M6 6.2h5.2M8.6 4v4.4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" opacity=".75"/>
                </svg>`;
            }
            categoryList.appendChild(item);
          });
        }

        /*
          No reconstruimos viewsets ni slides desde JS.
          El Liquid ya entrega cada imagen desde el panel de Shopify.
          Reconstruir acá pisaba esas URLs y terminaba mostrando placeholders
          o imágenes de otra categoría/sección.
        */

        const activeCategory = this.querySelector('[data-active-category]');
        if (activeCategory) activeCategory.textContent = profile.categories[0]?.name || '';
      }

      installFamilyHotspotLibrary() {
        if (!this.hotspotPlane || this.familyKey !== 'residuos') return;
        if (this.hotspotPlane.dataset.familyLibraryReady === 'true') return;
        this.hotspotPlane.dataset.familyLibraryReady = 'true';
        this.hotspotPlane.dataset.residuosPrecisionTotalV2 = 'true';
        this.hotspotPlane.dataset.libraryReady = 'true';

        /* Eliminar dots configurados para Industrial en esta familia. */
        this.hotspotPlane.querySelectorAll('[data-hotspot]').forEach(point => point.remove());

        const brandsResiduos = 'Original, OEM, Alternativo';

        const p = (title, x, y, components, options = {}) => ({
          title,
          x,
          y,
          mobileX: options.mobileX ?? x,
          mobileY: options.mobileY ?? y,
          zoom: options.zoom ?? 1.64,
          side: options.side || 'auto',
          line: options.line ?? 58,
          labelWidth: options.labelWidth ?? 205,
          labelHeight: options.labelHeight ?? 36,
          brands: options.brands || brandsResiduos,
          components
        });

        /* DOTS ESPECIFICOS · RESIDUOS: categoria + vista + pieza + coordenada. */
        const profiles = {
          /*
            NC GROUP · RESIDUOS · PRECISIÓN TOTAL V2
            8 subcategorías × 3 vistas.
            Coordenadas reconstruidas a partir de las vistas definitivas recuperadas.
            Prioridad: precisión del anclaje > cantidad de puntos.
          */

          '1': { // RECOLECTORES DE CARGA TRASERA
            top: [
              p('Cabina y controles', 20.0, 49.0, 'Cabina, tablero, mandos, sensores, cámaras, cableado', { side:'right', zoom:1.66, line:36, labelWidth:188 }),
              p('Motor y transmisión', 35.0, 52.0, 'Motor, radiador, filtros, transmisión, soportes, mangueras', { side:'right', zoom:1.76, line:38, labelWidth:192 }),
              p('Cuerpo compactador', 58.0, 49.0, 'Caja compactadora, laterales, refuerzos, guías, soldaduras', { side:'left', zoom:1.70, line:38, labelWidth:190 }),
              p('Chasis y servicios', 55.0, 64.0, 'Chasis, travesaños, depósito, soportes, líneas hidráulicas', { side:'right', zoom:1.72, line:36, labelWidth:188 }),
              p('Ejes y rodados', 71.0, 64.0, 'Ejes, frenos, mazas, rodamientos, neumáticos, llantas', { side:'left', zoom:1.72, line:36, labelWidth:180 }),
              p('Sistema trasero de carga', 84.0, 51.0, 'Tolva trasera, elevador, brazos, cilindros, pasadores, bujes', { side:'left', zoom:1.82, line:36, labelWidth:198 })
            ],
            front: [
              p('Cabina y controles', 32.0, 43.0, 'Cabina, tablero, mandos, sensores, cámaras, cableado', { side:'right', zoom:1.66, line:36, labelWidth:188 }),
              p('Motor y refrigeración', 39.0, 57.0, 'Motor, radiador, filtros, correas, mangueras, soporte motor', { side:'right', zoom:1.78, line:38, labelWidth:192 }),
              p('Cuerpo compactador', 62.0, 44.0, 'Caja compactadora, laterales, refuerzos, guías, soldaduras', { side:'left', zoom:1.70, line:38, labelWidth:190 }),
              p('Sistema hidráulico', 75.0, 54.0, 'Bomba, válvulas, mangueras, filtros, depósito, acoples', { side:'left', zoom:1.82, line:36, labelWidth:184 }),
              p('Ejes y frenos', 73.0, 68.0, 'Ejes, frenos, mazas, rodamientos, neumáticos, llantas', { side:'left', zoom:1.74, line:34, labelWidth:178 }),
              p('Elevador trasero', 84.0, 47.0, 'Peine, brazos, cilindros, pasadores, bujes, sensores', { side:'left', zoom:1.86, line:34, labelWidth:182 })
            ],
            rear: [
              p('Boca de carga', 50.0, 31.0, 'Boca trasera, tolva, tapas, burletes, chapas de desgaste', { side:'right', zoom:1.72, line:36, labelWidth:184 }),
              p('Cilindro izquierdo', 31.0, 46.0, 'Cilindro, vástago, bujes, pasadores, retenes, mangueras', { side:'right', zoom:1.82, line:34, labelWidth:190 }),
              p('Placa compactadora', 50.0, 53.0, 'Placa, carro, guías, patines, cilindros, sellos', { side:'left', zoom:1.86, line:36, labelWidth:188 }),
              p('Cilindro derecho', 69.0, 46.0, 'Cilindro, vástago, soportes, mangueras, racores', { side:'left', zoom:1.82, line:34, labelWidth:184 }),
              p('Elevador de contenedores', 50.0, 68.0, 'Peine, brazos, cilindros, pasadores, bujes, trabas', { side:'right', zoom:1.86, line:36, labelWidth:196 }),
              p('Eje trasero y frenos', 50.0, 78.0, 'Eje, diferencial, frenos, mazas, rodamientos, neumáticos', { side:'left', zoom:1.78, line:34, labelWidth:190 })
            ]
          },

          '2': { // RECOLECTORES DE CARGA LATERAL
            top: [
              p('Cabina y controles', 82.0, 50.0, 'Cabina, tablero, joystick, sensores, cámaras, cableado', { side:'left', zoom:1.66, line:36, labelWidth:188 }),
              p('Tolva de recepción', 59.0, 48.0, 'Tolva lateral, boca de carga, guías, compuertas, protecciones', { side:'left', zoom:1.76, line:36, labelWidth:192 }),
              p('Brazo lateral y pinza', 57.0, 65.0, 'Brazo lateral, pinza, garras, pasadores, bujes, sensores', { side:'right', zoom:1.86, line:34, labelWidth:194 }),
              p('Cilindros del brazo', 65.0, 57.0, 'Cilindros, vástagos, sellos, racores, mangueras, soportes', { side:'left', zoom:1.82, line:34, labelWidth:190 }),
              p('Cuerpo compactador', 34.0, 47.0, 'Caja compactadora, placa, guías, patines, refuerzos', { side:'right', zoom:1.72, line:36, labelWidth:190 }),
              p('Ejes traseros', 27.0, 66.0, 'Ejes, frenos, mazas, rodamientos, neumáticos, suspensión', { side:'right', zoom:1.72, line:34, labelWidth:184 })
            ],
            front: [
              p('Cabina y controles', 75.0, 43.0, 'Cabina, tablero, joystick, sensores, cámaras, cableado', { side:'left', zoom:1.66, line:36, labelWidth:188 }),
              p('Brazo de carga lateral', 40.0, 61.0, 'Brazo, estructura telescópica, articulaciones, pasadores, bujes', { side:'right', zoom:1.88, line:36, labelWidth:198 }),
              p('Pinza de contenedor', 36.0, 70.0, 'Pinzas, garras, rodillos, trabas, cilindros, sensores', { side:'right', zoom:1.90, line:32, labelWidth:190 }),
              p('Cilindros hidráulicos', 42.0, 52.0, 'Cilindros, vástagos, sellos, mangueras, válvulas, racores', { side:'right', zoom:1.84, line:34, labelWidth:190 }),
              p('Cuerpo compactador', 26.0, 43.0, 'Caja compactadora, placa, guías, refuerzos, chapas de desgaste', { side:'right', zoom:1.72, line:36, labelWidth:192 }),
              p('Ejes y frenos', 19.0, 72.0, 'Ejes, frenos, mazas, rodamientos, neumáticos, suspensión', { side:'right', zoom:1.72, line:32, labelWidth:180 })
            ],
            rear: [
              p('Compuerta trasera', 50.0, 42.0, 'Compuerta, bisagras, trabas, burletes, estructura', { side:'right', zoom:1.74, line:36, labelWidth:184 }),
              p('Cilindro izquierdo', 29.0, 51.0, 'Cilindro, vástago, soporte, mangueras, racores', { side:'right', zoom:1.82, line:34, labelWidth:182 }),
              p('Cilindro derecho', 71.0, 51.0, 'Cilindro, vástago, soporte, mangueras, racores', { side:'left', zoom:1.82, line:34, labelWidth:182 }),
              p('Acoples hidráulicos', 50.0, 64.0, 'Acoples, válvulas, mangueras, conectores, soportes', { side:'right', zoom:1.84, line:34, labelWidth:184 }),
              p('Luces y señalización', 50.0, 24.0, 'Luces, balizas, sensores, cámaras, cableado', { side:'left', zoom:1.62, line:32, labelWidth:182 }),
              p('Paragolpes y eje', 50.0, 76.0, 'Paragolpes, travesaño, eje, frenos, guardabarros', { side:'left', zoom:1.72, line:32, labelWidth:184 })
            ]
          },

          '3': { // RECOLECTORES DE CARGA FRONTAL
            top: [
              p('Cabina y controles', 77.0, 50.0, 'Cabina, tablero, mandos, sensores, cámaras, cableado', { side:'left', zoom:1.66, line:36, labelWidth:188 }),
              p('Brazos de elevación', 83.0, 38.0, 'Brazos superiores, articulaciones, pasadores, bujes, soportes', { side:'left', zoom:1.86, line:34, labelWidth:192 }),
              p('Cilindros de elevación', 68.0, 50.0, 'Cilindros, vástagos, sellos, mangueras, racores', { side:'left', zoom:1.84, line:34, labelWidth:188 }),
              p('Tolva / cuerpo compactador', 38.0, 48.0, 'Tolva, caja compactadora, placa, guías, patines, refuerzos', { side:'right', zoom:1.74, line:36, labelWidth:202 }),
              p('Zona de compactación', 18.0, 50.0, 'Placa, cilindros, guías, chapas de desgaste, estructura trasera', { side:'right', zoom:1.80, line:34, labelWidth:194 }),
              p('Ejes traseros', 32.0, 68.0, 'Ejes, frenos, mazas, rodamientos, neumáticos, suspensión', { side:'right', zoom:1.72, line:32, labelWidth:182 })
            ],
            front: [
              p('Cabina y controles', 66.0, 45.0, 'Cabina, tablero, mandos, sensores, cámaras, cableado', { side:'left', zoom:1.66, line:36, labelWidth:188 }),
              p('Brazo superior izquierdo', 51.0, 30.0, 'Brazo, articulaciones, pasadores, bujes, soportes', { side:'right', zoom:1.84, line:34, labelWidth:190 }),
              p('Brazo superior derecho', 79.0, 31.0, 'Brazo, articulaciones, pasadores, bujes, soportes', { side:'left', zoom:1.84, line:34, labelWidth:190 }),
              p('Cilindros de elevación', 58.0, 51.0, 'Cilindros, vástagos, sellos, mangueras, racores', { side:'right', zoom:1.84, line:34, labelWidth:188 }),
              p('Cuerpo compactador', 30.0, 48.0, 'Caja compactadora, tolva, refuerzos, guías, chapas', { side:'right', zoom:1.74, line:36, labelWidth:188 }),
              p('Chasis y eje delantero', 57.0, 72.0, 'Chasis, eje, dirección, frenos, maza, neumático', { side:'left', zoom:1.72, line:32, labelWidth:188 })
            ],
            rear: [
              p('Compuerta / cuerpo trasero', 50.0, 40.0, 'Compuerta, caja compactadora, refuerzos, bisagras, sellos', { side:'right', zoom:1.76, line:36, labelWidth:196 }),
              p('Cilindro izquierdo', 30.0, 53.0, 'Cilindro, vástago, pasadores, mangueras, soportes', { side:'right', zoom:1.84, line:34, labelWidth:186 }),
              p('Cilindro derecho', 70.0, 53.0, 'Cilindro, vástago, pasadores, mangueras, soportes', { side:'left', zoom:1.84, line:34, labelWidth:186 }),
              p('Mecanismo compactador', 50.0, 60.0, 'Rodillo / placa, guías, cilindros, apoyos, sellos', { side:'left', zoom:1.88, line:34, labelWidth:190 }),
              p('Luces superiores', 50.0, 20.0, 'Luces, balizas, sensores, cámaras, cableado', { side:'right', zoom:1.62, line:32, labelWidth:178 }),
              p('Eje trasero', 50.0, 78.0, 'Eje, diferencial, frenos, mazas, rodamientos, neumáticos', { side:'left', zoom:1.76, line:32, labelWidth:184 })
            ]
          },

          '4': { // MINIRECOLECTORES / SATÉLITE
            top: [
              p('Cabina y controles', 24.0, 50.0, 'Cabina, tablero, mandos, sensores, cámaras, cableado', { side:'right', zoom:1.70, line:34, labelWidth:184 }),
              p('Unidad motriz', 38.0, 52.0, 'Motor eléctrico / térmico, controlador, refrigeración, cableado', { side:'right', zoom:1.80, line:34, labelWidth:190 }),
              p('Caja compactadora', 57.0, 49.0, 'Caja, placa compactadora, guías, refuerzos, chapas', { side:'left', zoom:1.76, line:34, labelWidth:188 }),
              p('Sistema hidráulico', 76.0, 50.0, 'Bomba, válvulas, cilindros, mangueras, depósito, filtros', { side:'left', zoom:1.84, line:34, labelWidth:188 }),
              p('Boca de carga trasera', 85.0, 55.0, 'Boca, elevador, compuerta, cilindros, pasadores', { side:'left', zoom:1.86, line:32, labelWidth:190 })
            ],
            front: [
              p('Cabina y controles', 31.0, 43.0, 'Cabina, tablero, mandos, sensores, cámaras, cableado', { side:'right', zoom:1.70, line:34, labelWidth:184 }),
              p('Unidad motriz', 53.0, 58.0, 'Motor eléctrico / térmico, controlador, refrigeración, cableado', { side:'right', zoom:1.80, line:34, labelWidth:190 }),
              p('Caja compactadora', 68.0, 43.0, 'Caja compactadora, refuerzos, placa, guías, chapas', { side:'left', zoom:1.76, line:34, labelWidth:188 }),
              p('Hidráulica trasera', 82.0, 53.0, 'Bomba, válvulas, cilindros, mangueras, acoples', { side:'left', zoom:1.86, line:32, labelWidth:184 }),
              p('Eje y rodado', 77.0, 72.0, 'Eje, frenos, maza, rodamiento, neumático, suspensión', { side:'left', zoom:1.74, line:32, labelWidth:180 })
            ],
            rear: [
              p('Compuerta trasera', 50.0, 43.0, 'Compuerta, bisagras, cierres, sellos, estructura', { side:'right', zoom:1.80, line:34, labelWidth:184 }),
              p('Mangueras hidráulicas', 50.0, 29.0, 'Mangueras, racores, distribuidores, soportes, acoples', { side:'left', zoom:1.82, line:32, labelWidth:188 }),
              p('Mandos de operación', 34.0, 58.0, 'Botoneras, parada de emergencia, sensores, cableado', { side:'right', zoom:1.76, line:32, labelWidth:186 }),
              p('Mecanismo de elevación', 50.0, 71.0, 'Brazos, cilindros, pasadores, bujes, plataforma', { side:'left', zoom:1.86, line:34, labelWidth:188 }),
              p('Luces y señalización', 68.0, 59.0, 'Luces, reflectivos, sensores, conectores, cableado', { side:'left', zoom:1.68, line:32, labelWidth:180 })
            ]
          },

          '5': { // PORTACONTENEDORES HOOKLIFT
            top: [
              p('Cabina y controles', 20.0, 50.0, 'Cabina, tablero, mandos, sensores, cableado', { side:'right', zoom:1.68, line:34, labelWidth:184 }),
              p('Torre y gancho', 44.0, 49.0, 'Torre, gancho, articulación principal, pasadores, bujes', { side:'right', zoom:1.88, line:34, labelWidth:190 }),
              p('Cilindros principales', 52.0, 54.0, 'Cilindros, vástagos, sellos, mangueras, racores', { side:'left', zoom:1.88, line:32, labelWidth:188 }),
              p('Bastidor deslizante', 64.0, 52.0, 'Subchasis, rieles, rodillos, guías, trabas', { side:'left', zoom:1.82, line:34, labelWidth:186 }),
              p('Ejes traseros', 80.0, 53.0, 'Ejes, suspensión, frenos, mazas, rodamientos, neumáticos', { side:'left', zoom:1.74, line:32, labelWidth:184 })
            ],
            front: [
              p('Cabina y controles', 28.0, 43.0, 'Cabina, tablero, mandos, sensores, cableado', { side:'right', zoom:1.68, line:34, labelWidth:184 }),
              p('Torre del hooklift', 53.0, 42.0, 'Torre, gancho, articulaciones, pasadores, bujes', { side:'right', zoom:1.88, line:34, labelWidth:188 }),
              p('Cilindro principal', 58.0, 55.0, 'Cilindro, vástago, sellos, mangueras, racores', { side:'left', zoom:1.88, line:32, labelWidth:184 }),
              p('Rieles y subchasis', 67.0, 61.0, 'Rieles, rodillos, guías, travesaños, bloqueos', { side:'left', zoom:1.82, line:34, labelWidth:184 }),
              p('Ejes y suspensión', 81.0, 69.0, 'Ejes, suspensión, frenos, mazas, rodamientos, neumáticos', { side:'left', zoom:1.76, line:32, labelWidth:184 })
            ],
            rear: [
              p('Torre y gancho', 50.0, 29.0, 'Torre, gancho, articulación principal, pasadores, bujes', { side:'right', zoom:1.90, line:34, labelWidth:188 }),
              p('Cilindro izquierdo', 43.0, 52.0, 'Cilindro, vástago, sellos, mangueras, anclajes', { side:'right', zoom:1.88, line:32, labelWidth:182 }),
              p('Cilindro derecho', 57.0, 52.0, 'Cilindro, vástago, sellos, mangueras, anclajes', { side:'left', zoom:1.88, line:32, labelWidth:182 }),
              p('Rieles y rodillos', 50.0, 64.0, 'Rieles, rodillos, guías, topes, bloqueos', { side:'left', zoom:1.84, line:34, labelWidth:180 }),
              p('Trabas traseras', 50.0, 75.0, 'Trabas, cierres, soportes, travesaño, pasadores', { side:'right', zoom:1.82, line:32, labelWidth:182 })
            ]
          },

          '6': { // LAVACONTENEDORES
            top: [
              p('Cabina y controles', 18.0, 50.0, 'Cabina, tablero, mandos, sensores, cámaras, cableado', { side:'right', zoom:1.68, line:34, labelWidth:184 }),
              p('Tanques de agua', 46.0, 50.0, 'Tanques, tapas, sensores de nivel, soportes, drenajes', { side:'right', zoom:1.76, line:34, labelWidth:186 }),
              p('Bombas y tuberías', 61.0, 50.0, 'Bombas, tuberías, válvulas, filtros, racores, colectores', { side:'left', zoom:1.84, line:34, labelWidth:188 }),
              p('Circuito de lavado', 72.0, 47.0, 'Colectores, tuberías, válvulas, mangueras, boquillas', { side:'left', zoom:1.84, line:32, labelWidth:188 }),
              p('Cámara de lavado', 85.0, 50.0, 'Cámara, cepillos, guías, bandejas, drenajes, protecciones', { side:'left', zoom:1.88, line:32, labelWidth:190 })
            ],
            front: [
              p('Cabina y controles', 27.0, 43.0, 'Cabina, tablero, mandos, sensores, cámaras, cableado', { side:'right', zoom:1.68, line:34, labelWidth:184 }),
              p('Tanques y depósito', 59.0, 41.0, 'Tanques, sensores de nivel, tapas, soportes, drenajes', { side:'left', zoom:1.76, line:34, labelWidth:186 }),
              p('Bombas de lavado', 54.0, 56.0, 'Bombas, filtros, válvulas, tuberías, racores', { side:'right', zoom:1.86, line:32, labelWidth:184 }),
              p('Panel de control', 60.0, 60.0, 'Panel, botoneras, parada de emergencia, relés, sensores', { side:'left', zoom:1.80, line:32, labelWidth:184 }),
              p('Mecanismo trasero', 83.0, 54.0, 'Brazos, cilindros, guías, plataforma, pasadores', { side:'left', zoom:1.88, line:32, labelWidth:186 }),
              p('Eje trasero', 78.0, 70.0, 'Eje, frenos, mazas, rodamientos, neumáticos, suspensión', { side:'left', zoom:1.74, line:30, labelWidth:178 })
            ],
            rear: [
              p('Colectores y tuberías', 50.0, 24.0, 'Tuberías, colectores, válvulas, mangueras, racores', { side:'right', zoom:1.82, line:32, labelWidth:188 }),
              p('Cepillo izquierdo', 40.0, 47.0, 'Cepillo, eje, rodamientos, motor, soportes', { side:'right', zoom:1.88, line:32, labelWidth:180 }),
              p('Cepillo derecho', 60.0, 47.0, 'Cepillo, eje, rodamientos, motor, soportes', { side:'left', zoom:1.88, line:32, labelWidth:180 }),
              p('Cilindro central', 50.0, 51.0, 'Cilindro, vástago, sellos, guías, soportes', { side:'left', zoom:1.90, line:30, labelWidth:180 }),
              p('Hidráulica de elevación', 31.0, 67.0, 'Cilindros, válvulas, mangueras, pasadores, bujes', { side:'right', zoom:1.86, line:32, labelWidth:190 }),
              p('Plataforma de carga', 50.0, 76.0, 'Plataforma, bisagras, rodillos, cierres, soportes', { side:'left', zoom:1.84, line:32, labelWidth:186 })
            ]
          },

          '7': { // BARREDORAS VIALES
            top: [
              p('Tolva de residuos', 31.0, 50.0, 'Tolva, compuerta, sensores, sellos, soportes', { side:'right', zoom:1.76, line:34, labelWidth:184 }),
              p('Turbina y filtración', 46.0, 50.0, 'Turbina, filtros, conductos, sellos, compuertas', { side:'right', zoom:1.84, line:34, labelWidth:186 }),
              p('Cepillo lateral', 51.0, 68.0, 'Cepillo, motor hidráulico, eje, soporte, faldón', { side:'left', zoom:1.90, line:32, labelWidth:180 }),
              p('Sistema de aspiración', 55.0, 59.0, 'Boca de aspiración, conductos, mangueras, sellos', { side:'left', zoom:1.88, line:32, labelWidth:186 }),
              p('Cabina y controles', 82.0, 50.0, 'Cabina, tablero, mandos, sensores, cámaras, cableado', { side:'left', zoom:1.68, line:34, labelWidth:184 }),
              p('Sistema de agua', 62.0, 46.0, 'Tanques, bombas, boquillas, válvulas, filtros, tuberías', { side:'left', zoom:1.82, line:32, labelWidth:184 })
            ],
            front: [
              p('Cabina y controles', 72.0, 42.0, 'Cabina, tablero, mandos, sensores, cámaras, cableado', { side:'left', zoom:1.68, line:34, labelWidth:184 }),
              p('Tolva de residuos', 31.0, 42.0, 'Tolva, compuerta, sensores, sellos, soportes', { side:'right', zoom:1.76, line:34, labelWidth:184 }),
              p('Turbina y filtros', 36.0, 55.0, 'Turbina, filtros, conductos, sellos, compuertas', { side:'right', zoom:1.84, line:32, labelWidth:184 }),
              p('Cepillo lateral', 30.0, 73.0, 'Cepillo, motor, eje, soporte, faldón, rodamientos', { side:'right', zoom:1.90, line:30, labelWidth:180 }),
              p('Sistema de aspiración', 40.0, 66.0, 'Boca de aspiración, conductos, mangueras, sellos', { side:'left', zoom:1.88, line:32, labelWidth:186 }),
              p('Eje delantero y frenos', 59.0, 72.0, 'Eje, dirección, frenos, maza, rodamiento, neumático', { side:'left', zoom:1.76, line:30, labelWidth:186 })
            ],
            rear: [
              p('Tolva trasera', 50.0, 38.0, 'Tolva, compuerta, cerraduras, sensores, sellos', { side:'right', zoom:1.78, line:34, labelWidth:182 }),
              p('Conducto de aspiración', 50.0, 66.0, 'Conducto, manguera, abrazaderas, sellos, uniones', { side:'left', zoom:1.88, line:32, labelWidth:188 }),
              p('Turbina / distribuidor', 50.0, 73.0, 'Turbina, distribuidor, motores, válvulas, soportes', { side:'right', zoom:1.90, line:30, labelWidth:186 }),
              p('Cepillo izquierdo', 28.0, 73.0, 'Cepillo, motor, eje, soporte, faldón', { side:'right', zoom:1.88, line:30, labelWidth:178 }),
              p('Cepillo derecho', 72.0, 73.0, 'Cepillo, motor, eje, soporte, faldón', { side:'left', zoom:1.88, line:30, labelWidth:178 }),
              p('Luces y cámara', 50.0, 20.0, 'Luces, baliza, cámara, sensores, cableado', { side:'left', zoom:1.64, line:30, labelWidth:178 })
            ]
          },

          '8': { // COMPACTADORES ESTACIONARIOS · 5 PUNTOS REALES POR VISTA
            top: [
              p('Tolva de carga', 28.0, 49.0, 'Tolva, boca de carga, laterales, protecciones, guías', { side:'right', zoom:1.82, line:34, labelWidth:180 }),
              p('Tablero de control', 70.0, 48.0, 'Tablero, botoneras, parada de emergencia, relés, sensores', { side:'left', zoom:1.82, line:32, labelWidth:188 }),
              p('Cilindro hidráulico', 47.0, 54.0, 'Cilindro principal, vástago, sellos, mangueras, soportes', { side:'right', zoom:1.90, line:32, labelWidth:190 }),
              p('Caja de compactación', 59.0, 49.0, 'Caja, canal, placa, guías, chapas de desgaste', { side:'left', zoom:1.84, line:34, labelWidth:190 }),
              p('Puerta trasera', 80.0, 50.0, 'Puerta, bisagras, cierres, sellos, estructura', { side:'left', zoom:1.84, line:32, labelWidth:180 })
            ],
            front: [
              p('Tolva de carga', 35.0, 39.0, 'Tolva, boca de carga, laterales, protecciones, guías', { side:'right', zoom:1.82, line:34, labelWidth:180 }),
              p('Tablero de control', 68.0, 55.0, 'Tablero, botoneras, parada de emergencia, relés, sensores', { side:'left', zoom:1.82, line:32, labelWidth:188 }),
              p('Cilindro principal', 63.0, 67.0, 'Cilindro, vástago, sellos, mangueras, anclajes', { side:'left', zoom:1.90, line:32, labelWidth:184 }),
              p('Bastidor / estructura', 50.0, 75.0, 'Bastidor, patas, travesaños, soportes, protecciones', { side:'right', zoom:1.78, line:30, labelWidth:188 }),
              p('Caja de compactación', 58.0, 42.0, 'Caja, canal, placa, guías, chapas de desgaste', { side:'left', zoom:1.84, line:34, labelWidth:190 })
            ],
            rear: [
              p('Puerta trasera', 50.0, 46.0, 'Puerta, panel, bisagras, cierres, sellos', { side:'right', zoom:1.84, line:34, labelWidth:180 }),
              p('Unidad hidráulica', 73.0, 56.0, 'Bomba, motor, depósito, filtros, válvulas, acoples', { side:'left', zoom:1.88, line:32, labelWidth:186 }),
              p('Cierres de seguridad', 50.0, 67.0, 'Cierres, trabas, pasadores, soportes, sensores', { side:'right', zoom:1.86, line:32, labelWidth:186 }),
              p('Mangueras hidráulicas', 28.0, 52.0, 'Mangueras, racores, abrazaderas, colectores, protecciones', { side:'right', zoom:1.88, line:32, labelWidth:190 }),
              p('Luces de señalización', 50.0, 27.0, 'Luces, balizas, sensores, cableado, conectores', { side:'left', zoom:1.70, line:30, labelWidth:184 })
            ]
          }
        };

        Object.entries(profiles).forEach(([category, views]) => {
          Object.entries(views).forEach(([view, points]) => {
            points.forEach((data, index) => {
              const rawX = Number(data.x);
              const rawY = Number(data.y);
              const rawMobileX = Number(data.mobileX ?? rawX);
              const rawMobileY = Number(data.mobileY ?? rawY);

              /*
                Guard rail de Residuos: ningún hotspot puede terminar en los márgenes
                vacíos del lienzo por un valor accidental o una configuración vieja.
              */
              const x = Math.max(15, Math.min(85, rawX));
              const y = Math.max(18, Math.min(80, rawY));
              const mobileX = Math.max(15, Math.min(85, rawMobileX));
              const mobileY = Math.max(18, Math.min(80, rawMobileY));
              const button = document.createElement('button');

              button.type = 'button';
              button.className = 'mx-hotspot-ncx';
              button.dataset.hotspot = '';
              button.dataset.autoHotspot = 'true';
              button.dataset.autoPriority = 'specific';
              button.dataset.autoVisible = 'false';
              button.dataset.priority = String(index + 1);
              button.dataset.calloutSide = data.side || (index % 2 ? 'left' : 'right');
              button.dataset.category = category;
              button.dataset.view = view;
              button.dataset.title = data.title;
              button.dataset.description = 'Repuestos y componentes para ' + String(data.title || '').toLowerCase() + '.';
              button.dataset.components = data.components || '';
              button.dataset.brands = data.brands || brandsResiduos;
              button.dataset.x = String(x);
              button.dataset.y = String(y);
              button.dataset.mobileX = String(mobileX);
              button.dataset.mobileY = String(mobileY);
              button.dataset.zoom = String(data.zoom || 1.64);
              button.dataset.detail = '';
              button.dataset.baseLineLength = String(data.line || 58);
              button.dataset.baseLabelWidth = String(data.labelWidth || 205);
              button.dataset.baseLabelHeight = String(data.labelHeight || 36);
              button.style.setProperty('--x', x + '%');
              button.style.setProperty('--y', y + '%');
              button.style.setProperty('--mobile-x', mobileX + '%');
              button.style.setProperty('--mobile-y', mobileY + '%');
              button.style.setProperty('--callout-delay', (index * 72) + 'ms');
              button.style.setProperty('--mx-hotspot-line-length', (data.line || 58) + 'px');
              button.style.setProperty('--mx-label-max-width', (data.labelWidth || 205) + 'px');
              button.style.setProperty('--mx-label-min-height', (data.labelHeight || 36) + 'px');
              button.setAttribute('aria-label', 'Explorar ' + data.title);

              const callout = document.createElement('span');
              callout.className = 'mx-hotspot-callout-ncx';
              callout.setAttribute('aria-hidden', 'true');

              const line = document.createElement('span');
              line.className = 'mx-hotspot-line-ncx';

              const label = document.createElement('span');
              label.className = 'mx-hotspot-label-ncx';
              label.textContent = data.title;

              const orbit = document.createElement('span');
              orbit.className = 'mx-hotspot-orbit-ncx';
              orbit.setAttribute('aria-hidden', 'true');

              const dot = document.createElement('span');
              dot.className = 'mx-hotspot-dot-ncx';

              callout.append(line, label);
              button.append(callout, orbit, dot);
              this.hotspotPlane.appendChild(button);
            });
          });
        });
      }

      setupSectionReveal() {
        if (this.hasAttribute('data-reveal-initialized')) return;
        this.setAttribute('data-reveal-initialized', 'true');

        const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
        if (reduceMotion || !('IntersectionObserver' in window)) {
          this.setAttribute('data-reveal-ready', 'true');
          this.classList.add('is-section-visible');
          return;
        }

        this.setAttribute('data-reveal-ready', 'true');
        this.sectionRevealObserver = new IntersectionObserver(entries => {
          const entry = entries[0];
          if (!entry?.isIntersecting) return;
          requestAnimationFrame(() => this.classList.add('is-section-visible'));
          this.sectionRevealObserver?.disconnect();
        }, {
          threshold: 0.12,
          rootMargin: '0px 0px -6% 0px'
        });
        this.sectionRevealObserver.observe(this);
      }

      installPremiumViewTransition() {
        if (!this.stage || this.stage.dataset.premiumViewReady === 'true') return;
        this.stage.dataset.premiumViewReady = 'true';
if (!this.stage.querySelector('.mx-view-transition-depth-ncx')) {
          const depth = document.createElement('span');
          depth.className = 'mx-view-transition-depth-ncx';
          depth.setAttribute('aria-hidden', 'true');
          this.stage.appendChild(depth);
          this.viewTransitionDepth = depth;
        } else {
          this.viewTransitionDepth = this.stage.querySelector('.mx-view-transition-depth-ncx');
        }

        if (!this.stage.querySelector('.mx-view-transition-sheen-ncx')) {
          const sheen = document.createElement('span');
          sheen.className = 'mx-view-transition-sheen-ncx';
          sheen.setAttribute('aria-hidden', 'true');
          this.stage.appendChild(sheen);
          this.viewTransitionSheen = sheen;
        } else {
          this.viewTransitionSheen = this.stage.querySelector('.mx-view-transition-sheen-ncx');
        }
      }

      installViewImageLibrary() {
        /*
          Las imágenes salen del panel de Shopify.
          No imponemos rutas /cdn/shop/files desde el código porque eso puede
          mostrar una categoría equivocada cuando varias secciones comparten
          este mismo explorador universal.
        */
        this.graphicViewImageCandidates = {};
        this.realViewImageCandidates = {};

        this.graphicImageResolutionCache = new Map();
        this.graphicImageResolutionPromises = new Map();
        this.realImageResolutionCache = new Map();
        this.realImageResolutionPromises = new Map();
        this.viewImageRequestId = 0;

        /*
          Nunca sobrescribir una URL generada por Liquid antes de comprobarla.
          Cada botón conserva la URL versionada del editor y suma como respaldo:
          Shopify Files, Assets del tema y las rutas históricas conocidas.
        */
        this.viewButtons.forEach(button => {
          const category = String(button.dataset.category || '');
          const view = String(button.dataset.view || 'front');

          /*
            Guardar las URLs originales de ESTE botón y ESTA perspectiva.
            Estas fuentes no se vuelven a reemplazar al cambiar de vista.
          */
          if (!button.dataset.configuredGraphicImage) {
            button.dataset.configuredGraphicImage = button.dataset.image || '';
          }
          if (!button.dataset.configuredRealImage) {
            button.dataset.configuredRealImage = button.dataset.realImage || '';
          }

          button._mxGraphicImageCandidates = this.buildGraphicImageCandidates(
            category,
            view,
            button
          );
          button._mxRealImageCandidates = this.buildRealImageCandidates(
            category,
            view,
            button
          );
        });

        /*
          Reparar también las miniaturas. Antes sólo se resolvía la imagen grande,
          por eso un error de ruta dejaba rotas las tres tarjetas de vista.
        */
        window.setTimeout(() => {
          this.viewButtons.forEach((button, index) => {
            window.setTimeout(() => {
              this.repairViewButtonSources(button).catch(() => undefined);
            }, index * 28);
          });
        }, 0);
      }

      normalizeImageSource(source) {
        const value = String(source || '').trim();
        if (!value) return '';

        try {
          if (value.startsWith('//')) return `${window.location.protocol}${value}`;
          if (/^(data:|blob:|https?:)/i.test(value)) return value;
          return new URL(value, window.location.origin).href;
        } catch (_) {
          return value;
        }
      }

      parseImageCandidateList(value) {
        return String(value || '')
          .split('||')
          .map(source => this.normalizeImageSource(source))
          .filter(Boolean);
      }

      syncViewThumbnail(button, source) {
        const normalized = this.normalizeImageSource(source);
        const thumb = button?.querySelector('.mx-view-thumb-ncx');
        if (!thumb || !normalized) return;

        let image = thumb.querySelector('img');
        if (!image) {
          image = document.createElement('img');
          image.alt = '';
          image.width = 320;
          image.height = 180;
          image.loading = 'lazy';
          image.decoding = 'async';
          thumb.replaceChildren(image);
        }

        const current = this.normalizeImageSource(
          image.currentSrc || image.getAttribute('src') || ''
        );

        if (current !== normalized) {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = normalized;
        }

        image.dataset.mxResolved = 'true';
      }

      async repairViewButtonSources(button) {
        if (!button) return;

        const category = String(button.dataset.category || '');
        const view = String(button.dataset.view || 'front');
        const [graphicSource, realSource] = await Promise.all([
          this.resolveGraphicImageSource(category, view, button).catch(() => ''),
          this.resolveRealImageSource(category, view, button).catch(() => '')
        ]);

        if (graphicSource) this.syncViewThumbnail(button, graphicSource);

        if (
          category !== String(this.activeCategory || '') ||
          view !== String(this.activeView || '')
        ) return;

        const slide = this.getActiveSlide();
        const graphicImage = slide?.querySelector('[data-view-image]');
        const realImage = slide?.querySelector('[data-real-image]');
        const alt = button.dataset.alt || '';

        const applyResolvedSource = (image, source, datasetKey) => {
          const normalized = this.normalizeImageSource(source);
          if (!image || !normalized) return;

          const current = this.normalizeImageSource(
            image.currentSrc || image.getAttribute('src') || ''
          );

          if (current !== normalized) {
            image.removeAttribute('srcset');
            image.removeAttribute('sizes');
            image.src = normalized;
          }

          image.dataset[datasetKey] = normalized;
          if (alt) image.alt = alt;
        };

        applyResolvedSource(graphicImage, graphicSource, 'graphicSrc');
        applyResolvedSource(realImage, realSource, 'realSrc');
        this.scheduleGeometryUpdate();
        this.syncDetailMediaToMode({ instant: true });
      }

      getViewButton(category = this.activeCategory, view = this.activeView) {
        const normalizedCategory = String(category || '1');
        const normalizedView = String(view || 'front');
        return this.viewButtons?.find(button =>
          String(button.dataset.category || '') === normalizedCategory &&
          String(button.dataset.view || 'front') === normalizedView
        ) || null;
      }

      isGraphicSourceForCategory(source, category) {
        const normalized = this.normalizeImageSource(source);
        if (!normalized) return false;

        return this.viewButtons?.some(button => {
          if (String(button.dataset.category || '') !== String(category || '1')) return false;
          return this.normalizeImageSource(button.dataset.image || '') === normalized;
        }) || false;
      }

      buildGraphicImageCandidates(category, view, button = null) {
        const currentButton = button || this.getViewButton(category, view);
        const configuredSource = this.normalizeImageSource(
          currentButton?.dataset.configuredGraphicImage ||
          currentButton?.dataset.image ||
          ''
        );
        const declaredCandidates = this.parseImageCandidateList(
          currentButton?.dataset.graphicCandidates || ''
        );
        const customCandidates =
          this.graphicViewImageCandidates?.[String(category)]?.[String(view)] || [];

        /*
          Sólo fuentes pertenecientes al botón seleccionado.
          No sumar la imagen que esté visible actualmente, porque pertenece
          a la perspectiva anterior y era la causa de que las vistas se repitieran.
        */
        return [...new Set([
          configuredSource,
          ...declaredCandidates,
          ...customCandidates.map(source => this.normalizeImageSource(source))
        ].filter(Boolean))];
      }

      resolveGraphicImageSource(category, view, button = null) {
        const normalizedCategory = String(category || '1');
        const normalizedView = String(view || 'front');
        const key = `${normalizedCategory}:${normalizedView}`;

        if (this.graphicImageResolutionCache?.has(key)) {
          return Promise.resolve(
            this.graphicImageResolutionCache.get(key) || ''
          );
        }

        if (this.graphicImageResolutionPromises?.has(key)) {
          return this.graphicImageResolutionPromises.get(key);
        }

        const currentButton =
          button || this.getViewButton(normalizedCategory, normalizedView);
        const candidates = currentButton?._mxGraphicImageCandidates?.length
          ? currentButton._mxGraphicImageCandidates
          : this.buildGraphicImageCandidates(
              normalizedCategory,
              normalizedView,
              currentButton
            );

        const resolution = Promise.all(
          candidates.map(async source => ({
            source,
            valid: await this.testImageSource(source)
          }))
        ).then(results => {
          const resolved = results.find(result => result.valid)?.source || '';
          this.graphicImageResolutionCache.set(key, resolved);

          if (currentButton && resolved) {
            currentButton.dataset.graphicImageResolved = resolved;
            this.syncViewThumbnail(currentButton, resolved);
          }

          return resolved;
        }).catch(() => {
          this.graphicImageResolutionCache.set(key, '');
          return '';
        }).finally(() => {
          this.graphicImageResolutionPromises.delete(key);
        });

        this.graphicImageResolutionPromises.set(key, resolution);
        return resolution;
      }

      buildRealImageCandidates(category, view, button = null) {
        const currentButton = button || this.getViewButton(category, view);
        const configuredSource = this.normalizeImageSource(
          currentButton?.dataset.configuredRealImage ||
          currentButton?.dataset.realImage ||
          ''
        );
        const declaredCandidates = this.parseImageCandidateList(
          currentButton?.dataset.realCandidates || ''
        );
        const customCandidates =
          this.realViewImageCandidates?.[String(category)]?.[String(view)] || [];

        /*
          IMPORTANTE:
          esta lista contiene solamente fotografías reales.
          La imagen gráfica jamás se utiliza como respaldo del modo imagen.
        */
        return [...new Set([
          configuredSource,
          ...declaredCandidates,
          ...customCandidates.map(source => this.normalizeImageSource(source))
        ].filter(Boolean))];
      }

      testImageSource(source, timeout = 7000) {
        const normalized = this.normalizeImageSource(source);
        if (!normalized) return Promise.resolve(false);

        return new Promise(resolve => {
          const probe = new Image();
          let settled = false;

          const finish = success => {
            if (settled) return;
            settled = true;
            window.clearTimeout(timer);
            probe.onload = null;
            probe.onerror = null;
            resolve(Boolean(success));
          };

          const timer = window.setTimeout(() => finish(false), timeout);
          probe.onload = () => finish(probe.naturalWidth > 0 && probe.naturalHeight > 0);
          probe.onerror = () => finish(false);
          probe.decoding = 'async';
          probe.src = normalized;

          if (probe.complete) {
            window.requestAnimationFrame(() => {
              finish(probe.naturalWidth > 0 && probe.naturalHeight > 0);
            });
          }
        });
      }

      resolveRealImageSource(category, view, button = null) {
        const normalizedCategory = String(category || '1');
        const normalizedView = String(view || 'front');
        const key = `${normalizedCategory}:${normalizedView}`;

        if (this.realImageResolutionCache?.has(key)) {
          return Promise.resolve(this.realImageResolutionCache.get(key) || '');
        }

        if (this.realImageResolutionPromises?.has(key)) {
          return this.realImageResolutionPromises.get(key);
        }

        const currentButton =
          button || this.getViewButton(normalizedCategory, normalizedView);

        const candidates = currentButton?._mxRealImageCandidates?.length
          ? currentButton._mxRealImageCandidates
          : this.buildRealImageCandidates(
              normalizedCategory,
              normalizedView,
              currentButton
            );

        /*
          Resolver en ORDEN de prioridad.
          1) foto real configurada para ESTA vista en Shopify
          2) candidatos declarados por Liquid
          3) rutas históricas como último respaldo

          No se ejecutan en carrera: así una ruta vieja que cargue más rápido
          nunca puede pisar la fotografía correcta de superior/frontal/trasera.
        */
        const resolution = (async () => {
          for (const source of candidates) {
            const normalizedSource = this.normalizeImageSource(source);
            if (!normalizedSource) continue;

            try {
              const valid = await this.testImageSource(normalizedSource, 7000);
              if (valid) return normalizedSource;
            } catch (_) {}
          }

          return '';
        })().then(realSource => {
          this.realImageResolutionCache.set(key, realSource || '');

          if (currentButton && realSource) {
            currentButton.dataset.realImageResolved = realSource;
          }

          return realSource || '';
        }).catch(() => '').finally(() => {
          this.realImageResolutionPromises.delete(key);
        });

        this.realImageResolutionPromises.set(key, resolution);
        return resolution;
      }

      ensureActiveRealImage(afterChange = null) {
        const category = String(this.activeCategory || '1');
        const view = String(this.activeView || 'front');
        const button = this.getViewButton(category, view);
        const slide = this.getActiveSlide();
        const realImage = slide?.querySelector('[data-real-image]');

        if (!realImage) {
          if (typeof afterChange === 'function') afterChange();
          return;
        }

        const currentSource = this.normalizeImageSource(
          realImage.currentSrc || realImage.getAttribute('src') || ''
        );
        const alt = button?.dataset.alt || '';

        this.resolveRealImageSource(category, view, button)
          .then(source => {
            const emptyRealImage =
              'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
            const nextSource = source || emptyRealImage;

            if (nextSource === currentSource) {
              if (typeof afterChange === 'function') afterChange();
              return;
            }

            realImage.dataset.realSrc = nextSource;
            this.swapStageImage(realImage, nextSource, alt, afterChange, currentSource);
          })
          .catch(() => {
            if (typeof afterChange === 'function') afterChange();
          });
      }

      installConstructionHotspotLibrary() {
        if (!this.hotspotPlane || this.familyKey !== 'industrial') return;
        if (this.hotspotPlane.dataset.libraryReady === 'true') return;
        this.hotspotPlane.dataset.libraryReady = 'true';
        this.hotspotPlane.dataset.constructionLibraryReady = 'true';

        const brands = {
          motor: 'Fleetguard, Donaldson, Bosch, Perkins, Cummins, Caterpillar',
          hidraulica: 'Parker, Rexroth, Eaton, Danfoss, Hydac',
          transmision: 'ZF, Dana, Carraro, Spicer, Eaton',
          electrico: 'Bosch, Hella, Denso, Delco Remy, Valeo',
          rodados: 'BKT, Michelin, Goodyear, Bridgestone, Trelleborg',
          estructura: 'Original, OEM, Alternativo',
          cabina: 'Denso, Sanden, Bosch, Hella, Grammer',
          frenos: 'Knorr-Bremse, Wabco, Meritor, Bendix, Bosch',
          corte: 'Original, OEM, Hardox, Esco, Black Cat',
          izaje: 'Original, OEM, Parker, Rexroth, Eaton'
        };

        const point = (title, x, y, zoom, brandList, components, mobileX = x, mobileY = y, options = {}) => ({
          title, x, y, mobileX, mobileY, zoom,
          brands: brandList,
          components,
          priority: Number(options.priority || 4),
          side: options.side || 'auto',
          lift: Number(options.lift || 0),
          line: Number(options.line || 54)
        });

        /*
          MAQUINARIA DE CONSTRUCCIÓN · HOTSPOTS ESPECÍFICOS
          -------------------------------------------------
          Categorías visibles del Liquid actual:
          1 Excavadoras · 2 Retroexcavadoras · 3 Bulldozer · 4 Montacargas
          5 Pavimentadoras · 6 Compactadoras · 7 Grúas · 8 Motoniveladoras

          Cada perspectiva tiene 6 zonas mecánicas propias. En móvil el motor de
          visibilidad conserva las 5 de mayor prioridad para evitar superposición.
        */
        const profiles = {
          '1': { // EXCAVADORAS
            top: [
              /*
                EXCAVADORA · VISTA SUPERIOR
                Recalibrada contra la captura real del stage: la máquina está orientada
                verticalmente, por lo que se eliminan las antiguas coordenadas horizontales.
              */
              point('Pluma y cilindros hidráulicos', 52.7, 28.0, 1.72, brands.hidraulica, 'Pluma, Brazo, Cilindros, Vástagos, Sellos, Retenes, Mangueras, Pasadores, Bujes', 52.7, 28.0, {priority:1, side:'right', lift:-10, line:44}),
              point('Cabina y sistema eléctrico', 69.0, 40.0, 1.64, brands.electrico, 'Cabina, Joysticks, Tablero, Sensores, Relés, Fusibles, Arnés, Climatización', 69.0, 40.0, {priority:2, side:'left', lift:-12, line:42}),
              point('Motor y refrigeración', 39.8, 51.5, 1.76, brands.motor, 'Motor, Radiador, Ventilador, Bomba de agua, Filtros, Correas, Mangueras, Enfriadores', 39.8, 51.5, {priority:3, side:'right', lift:-8, line:44}),
              point('Bombas y sistema hidráulico', 48.4, 57.0, 1.80, brands.hidraulica, 'Bombas hidráulicas, Válvulas, Distribuidores, Mangueras, Filtros, Sellos, Retenes, Acoples', 48.4, 57.0, {priority:4, side:'left', lift:8, line:42}),
              point('Corona y reductor de giro', 53.0, 67.0, 1.82, brands.transmision, 'Corona de giro, Motor de giro, Reductor, Rodamientos, Retenes, Pernos, Engranajes', 53.0, 67.0, {priority:5, side:'right', lift:10, line:42}),
              point('Tren de rodaje', 71.7, 77.0, 1.72, brands.rodados, 'Cadenas, Rodillos, Rueda guía, Tensor, Zapatas, Piñón, Pernos, Bastidor inferior', 71.7, 77.0, {priority:6, side:'left', lift:10, line:40})
            ],
            front: [
              /*
                EXCAVADORA · FRONTAL GRÁFICA
                Coordenadas recalibradas contra la imagen real mostrada en el stage.
                Se usan sólo zonas claramente visibles: ningún dot queda en fondo vacío.
              */
              point('Pluma y cilindros hidráulicos', 48.9, 29.0, 1.72, brands.hidraulica, 'Pluma, Cilindros, Vástagos, Sellos, Retenes, Mangueras, Pasadores, Bujes', 48.9, 29.0, {priority:1, side:'right', lift:-10, line:46}),
              point('Cabina y controles', 69.3, 51.7, 1.66, brands.cabina, 'Asiento, Joysticks, Tablero, Pedales, Cristales, Climatización, Limpiaparabrisas', 69.3, 51.7, {priority:2, side:'left', lift:-12, line:42}),
              point('Motor y refrigeración', 77.8, 66.5, 1.78, brands.motor, 'Motor, Radiador, Ventilador, Bomba de agua, Filtros, Correas, Mangueras, Enfriadores', 77.8, 66.5, {priority:3, side:'left', lift:-8, line:44}),
              point('Bombas y sistema de giro', 60.3, 71.3, 1.82, brands.hidraulica, 'Bombas hidráulicas, Válvulas, Distribuidores, Corona de giro, Motor de giro, Reductor, Rodamientos, Retenes', 60.3, 71.3, {priority:4, side:'right', lift:8, line:44}),
              point('Tren de rodaje', 66.1, 87.1, 1.74, brands.rodados, 'Cadenas, Rodillos, Rueda guía, Tensor, Zapatas, Piñón, Pernos, Bastidor inferior', 66.1, 87.1, {priority:5, side:'left', lift:10, line:42})
            ],
            rear: [
              point('Motor y refrigeración', 47, 40, 1.66, brands.motor, 'Motor, Radiador, Ventilador, Filtros, Bombas, Correas, Mangueras, Enfriadores', 47, 40, {priority:1, side:'right', lift:-12}),
              point('Cabina y sistema eléctrico', 68, 40, 1.56, brands.electrico, 'Cabina, Tablero, Sensores, Relés, Fusibles, Arnés, Baterías, Iluminación', 68, 40, {priority:2, side:'left', lift:-12}),
              point('Contrapeso y estructura', 50, 54, 1.54, brands.estructura, 'Contrapeso, Capot, Puertas, Soportes, Bisagras, Cerraduras, Tornillería', 50, 54, {priority:3, side:'right', lift:6}),
              point('Bombas y sistema hidráulico', 33, 56, 1.72, brands.hidraulica, 'Bombas, Distribuidores, Mangueras, Válvulas, Filtros, Sellos, Retenes', 33, 56, {priority:4, side:'right', lift:12}),
              point('Corona y reductor de giro', 50, 66, 1.74, brands.transmision, 'Corona, Motor de giro, Reductor, Rodamientos, Retenes, Pernos, Engranajes', 50, 66, {priority:5, side:'left', lift:12}),
              point('Tren de rodaje', 50, 80, 1.62, brands.rodados, 'Cadenas, Rodillos, Rueda guía, Tensor, Zapatas, Piñón, Bastidor inferior', 50, 79, {priority:6, side:'left', lift:10})
            ]
          },
          '2': { // RETROEXCAVADORAS
            top: [
              point('Cucharón delantero', 11, 50, 1.56, brands.corte, 'Cucharón, Dientes, Cuchillas, Laterales, Pasadores, Bujes, Acople', 12, 50, {priority:1, side:'right'}),
              point('Motor y cargador frontal', 32, 50, 1.66, brands.motor, 'Motor, Radiador, Filtros, Brazos de cargador, Cilindros, Mangueras, Pasadores', 32, 50, {priority:2, side:'right', lift:-12}),
              point('Cabina y controles', 51, 49, 1.56, brands.cabina, 'Asiento, Tablero, Joysticks, Pedales, Cristales, Climatización, Comandos', 51, 49, {priority:3, side:'left', lift:-12}),
              point('Transmisión y eje trasero', 62, 59, 1.72, brands.transmision, 'Caja, Convertidor, Cardanes, Diferencial, Palieres, Frenos, Rodamientos', 62, 59, {priority:4, side:'left', lift:8}),
              point('Brazo retro y cucharón', 79, 46, 1.64, brands.hidraulica, 'Pluma, Brazo, Cilindros, Cucharón, Dientes, Pasadores, Bujes, Mangueras', 78, 46, {priority:5, side:'left', lift:-8}),
              point('Estabilizadores', 67, 76, 1.58, brands.estructura, 'Patas estabilizadoras, Cilindros, Zapatas, Pasadores, Bujes, Mangueras, Soportes', 67, 74, {priority:6, side:'left', lift:10})
            ],
            front: [
              point('Cucharón delantero', 16, 72, 1.58, brands.corte, 'Cucharón, Dientes, Cuchillas, Laterales, Pasadores, Bujes, Acople', 17, 71, {priority:1, side:'right', lift:10}),
              point('Hidráulica del cargador', 32, 57, 1.66, brands.hidraulica, 'Brazos, Cilindros, Mangueras, Válvulas, Pasadores, Bujes, Sellos', 32, 57, {priority:2, side:'right', lift:-8}),
              point('Motor y refrigeración', 40, 45, 1.68, brands.motor, 'Motor, Radiador, Ventilador, Filtros, Correas, Bomba de agua, Mangueras', 40, 45, {priority:3, side:'right', lift:-12}),
              point('Cabina y sistema eléctrico', 55, 35, 1.56, brands.electrico, 'Cabina, Tablero, Sensores, Faros, Relés, Fusibles, Arnés, Climatización', 55, 35, {priority:4, side:'left', lift:-12}),
              point('Transmisión, ejes y rodados', 65, 66, 1.70, brands.transmision, 'Caja, Convertidor, Cardanes, Diferenciales, Semiejes, Frenos, Neumáticos, Llantas', 65, 65, {priority:5, side:'left', lift:10}),
              point('Brazo retro y cucharón', 85, 45, 1.64, brands.hidraulica, 'Pluma, Brazo, Cilindros, Cucharón, Dientes, Pasadores, Bujes, Mangueras', 84, 45, {priority:6, side:'left', lift:-8})
            ],
            rear: [
              point('Brazo retro y cilindros', 59, 34, 1.66, brands.hidraulica, 'Pluma, Brazo, Cilindros, Vástagos, Sellos, Mangueras, Pasadores, Bujes', 59, 35, {priority:1, side:'left', lift:-12}),
              point('Cabina y controles', 47, 29, 1.56, brands.cabina, 'Asiento, Tablero, Joysticks, Cristales, Climatización, Limpiaparabrisas', 47, 30, {priority:2, side:'right', lift:-12}),
              point('Distribuidor hidráulico', 50, 58, 1.72, brands.hidraulica, 'Distribuidor, Válvulas, Mangueras, Acoples, Filtros, Sellos, Retenes', 50, 58, {priority:3, side:'right', lift:-8}),
              point('Eje y diferencial trasero', 50, 72, 1.72, brands.transmision, 'Diferencial, Palieres, Frenos, Rodamientos, Retenes, Mazas', 50, 71, {priority:4, side:'left', lift:8}),
              point('Estabilizadores', 28, 78, 1.58, brands.estructura, 'Patas, Cilindros, Zapatas, Pasadores, Bujes, Mangueras, Soportes', 29, 76, {priority:5, side:'right', lift:10}),
              point('Luces y sistema eléctrico', 34, 46, 1.54, brands.electrico, 'Faros, Balizas, Sensores, Arnés, Relés, Fusibles, Conectores', 34, 46, {priority:6, side:'right', lift:-8})
            ]
          },
          '3': { // BULLDOZER
            front: [
              point('Hoja y cuchillas', 22, 72, 1.58, brands.corte, 'Hoja topadora, Cuchillas, Cantoneras, Pernos, Soportes, Refuerzos', 23, 71, {priority:1, side:'right', lift:10}),
              point('Cilindros de levante', 34, 43, 1.66, brands.hidraulica, 'Cilindros de levante, Vástagos, Sellos, Mangueras, Pasadores, Bujes', 35, 44, {priority:2, side:'right', lift:-12}),
              point('Motor y refrigeración', 49, 49, 1.72, brands.motor, 'Motor, Radiador, Ventilador, Turbo, Filtros, Correas, Bombas, Mangueras', 49, 49, {priority:3, side:'right', lift:8}),
              point('Cabina y controles', 62, 31, 1.56, brands.cabina, 'Cabina, Asiento, Joysticks, Tablero, Sensores, Climatización, Cristales', 62, 31, {priority:4, side:'left', lift:-12}),
              point('Transmisión y mando final', 64, 59, 1.72, brands.transmision, 'Convertidor, Caja, Embragues, Mandos finales, Engranajes, Rodamientos, Retenes', 64, 59, {priority:5, side:'left', lift:8}),
              point('Tren de rodaje', 66, 76, 1.64, brands.rodados, 'Cadenas, Zapatas, Rodillos, Rueda guía, Tensor, Piñón, Bastidor', 66, 75, {priority:6, side:'left', lift:12})
            ],
            top: [
              point('Hoja y bastidor C', 14, 50, 1.58, brands.corte, 'Hoja, Bastidor, Brazos, Cuchillas, Cantoneras, Pasadores, Bujes', 15, 50, {priority:1, side:'right'}),
              point('Hidráulica de implementos', 30, 50, 1.68, brands.hidraulica, 'Cilindros, Válvulas, Mangueras, Bombas, Distribuidores, Sellos', 30, 50, {priority:2, side:'right', lift:-12}),
              point('Motor y refrigeración', 44, 50, 1.72, brands.motor, 'Motor, Radiador, Ventilador, Filtros, Turbo, Bombas, Enfriadores', 44, 50, {priority:3, side:'right', lift:10}),
              point('Cabina y mandos', 61, 50, 1.56, brands.cabina, 'Cabina, Asiento, Controles, Tablero, Sensores, Climatización', 61, 50, {priority:4, side:'left', lift:-12}),
              point('Transmisión y mandos finales', 72, 50, 1.72, brands.transmision, 'Caja, Convertidor, Diferencial de dirección, Mandos finales, Retenes', 72, 50, {priority:5, side:'left', lift:10}),
              point('Orugas y rodillos', 78, 72, 1.62, brands.rodados, 'Cadenas, Zapatas, Rodillos, Piñón, Rueda guía, Tensor, Bastidor', 77, 70, {priority:6, side:'left', lift:12})
            ],
            rear: [
              point('Cabina y sistema eléctrico', 50, 28, 1.56, brands.electrico, 'Cabina, Tablero, Sensores, Luces, Arnés, Relés, Fusibles', 50, 29, {priority:1, side:'right', lift:-12}),
              point('Motor y refrigeración', 50, 47, 1.72, brands.motor, 'Motor, Radiador, Ventilador, Filtros, Turbo, Bombas, Enfriadores', 50, 47, {priority:2, side:'left', lift:-10}),
              point('Hidráulica trasera', 50, 59, 1.68, brands.hidraulica, 'Cilindros, Válvulas, Mangueras, Distribuidores, Sellos, Pasadores', 50, 59, {priority:3, side:'right', lift:8}),
              point('Mando final izquierdo', 32, 68, 1.70, brands.transmision, 'Mando final, Engranajes, Rodamientos, Retenes, Eje, Carcasa', 33, 67, {priority:4, side:'right', lift:10}),
              point('Mando final y orugas', 69, 68, 1.68, brands.rodados, 'Mando final, Piñón, Cadenas, Zapatas, Rodillos, Rodamientos', 68, 67, {priority:5, side:'left', lift:10}),
              point('Ripper / escarificador', 50, 82, 1.60, brands.corte, 'Ripper, Dientes, Vástagos, Porta dientes, Pasadores, Bujes, Cilindros', 50, 80, {priority:6, side:'left', lift:12})
            ]
          },
          '4': { // MONTACARGAS
            /*
              Recalibrado contra las tres vistas definitivas del montacargas:
              frontal 3/4, superior cenital y trasera centrada.
            */
            front: [
              point('Horquillas y carro', 31.5, 79.0, 1.64, brands.estructura, 'Horquillas, Carro portahorquillas, Rodillos, Seguros, Pasadores', 31.5, 78.0, {priority:1, side:'right', lift:10, line:40}),
              point('Mástil y cadenas', 39.5, 39.5, 1.68, brands.izaje, 'Mástil, Perfiles, Cadenas, Poleas, Rodillos, Guías, Anclajes', 39.5, 40.0, {priority:2, side:'right', lift:-12, line:42}),
              point('Cilindros de elevación', 43.5, 55.0, 1.72, brands.hidraulica, 'Cilindros, Vástagos, Sellos, Mangueras, Válvulas, Racores', 43.5, 55.0, {priority:3, side:'right', lift:8, line:40}),
              point('Cabina y controles', 61.0, 43.0, 1.64, brands.cabina, 'Asiento, Volante, Pedales, Palancas, Tablero, Sensores, Techo protector', 61.0, 43.0, {priority:4, side:'left', lift:-12, line:42}),
              point('Unidad motriz y transmisión', 75.0, 60.0, 1.76, brands.transmision, 'Motor o batería, Controlador, Caja, Convertidor, Diferencial, Filtros', 75.0, 60.0, {priority:5, side:'left', lift:-6, line:42}),
              point('Eje motriz y ruedas', 61.5, 76.0, 1.70, brands.rodados, 'Eje motriz, Diferencial, Mazas, Rodamientos, Frenos, Neumáticos, Llantas', 61.5, 75.0, {priority:6, side:'left', lift:12, line:40})
            ],
            top: [
              point('Horquillas', 17.0, 50.0, 1.62, brands.estructura, 'Horquillas, Talones, Seguros, Pasadores', 17.0, 50.0, {priority:1, side:'right', lift:-8, line:38}),
              point('Carro y mástil', 32.5, 50.0, 1.68, brands.izaje, 'Carro, Mástil, Cadenas, Poleas, Guías, Rodillos', 32.5, 50.0, {priority:2, side:'right', lift:10, line:40}),
              point('Hidráulica de elevación', 39.5, 57.5, 1.72, brands.hidraulica, 'Cilindros, Bomba, Distribuidor, Mangueras, Válvulas, Racores', 39.5, 57.5, {priority:3, side:'right', lift:12, line:40}),
              point('Cabina y controles', 57.0, 51.0, 1.64, brands.cabina, 'Volante, Pedales, Palancas, Tablero, Asiento, Sensores', 57.0, 51.0, {priority:4, side:'left', lift:-12, line:40}),
              point('Motor / batería y control', 74.0, 51.0, 1.74, brands.motor, 'Motor, Batería, Controlador, Radiador, Filtros, Cableado, Relés', 74.0, 51.0, {priority:5, side:'left', lift:-6, line:42}),
              point('Contrapeso y eje trasero', 84.0, 50.0, 1.66, brands.estructura, 'Contrapeso, Eje trasero, Manguetas, Rótulas, Bujes, Soportes', 83.0, 50.0, {priority:6, side:'left', lift:12, line:40})
            ],
            rear: [
              point('Cabina y sistema eléctrico', 50.0, 31.5, 1.64, brands.electrico, 'Asiento, Tablero, Sensores, Luces, Arnés, Fusibles, Relés', 50.0, 32.0, {priority:1, side:'right', lift:-12, line:42}),
              point('Motor / batería', 50.0, 58.0, 1.76, brands.motor, 'Motor, Batería, Radiador, Controlador, Filtros, Ventilador, Cableado', 50.0, 58.0, {priority:2, side:'left', lift:-10, line:40}),
              point('Contrapeso y estructura', 50.0, 66.0, 1.66, brands.estructura, 'Contrapeso, Parrilla, Tapas, Soportes, Bisagras, Tornillería', 50.0, 65.0, {priority:3, side:'right', lift:10, line:40}),
              point('Sistema hidráulico', 43.0, 63.0, 1.72, brands.hidraulica, 'Bomba, Distribuidor, Depósito, Filtros, Mangueras, Válvulas', 43.0, 63.0, {priority:4, side:'right', lift:-8, line:40}),
              point('Eje de dirección', 50.0, 79.0, 1.70, brands.transmision, 'Eje trasero, Manguetas, Rótulas, Bujes, Cilindro de dirección', 50.0, 78.0, {priority:5, side:'left', lift:10, line:40}),
              point('Frenos y ruedas', 66.0, 78.0, 1.66, brands.rodados, 'Neumáticos, Llantas, Mazas, Rodamientos, Frenos, Tuercas', 65.0, 77.0, {priority:6, side:'left', lift:12, line:38})
            ]
          },
          '5': { // PAVIMENTADORAS
            front: [
              point('Tolva de recepción', 20, 61, 1.58, brands.estructura, 'Tolva, Alas, Rodillos de empuje, Chapas, Bisagras, Cilindros', 21, 61, {priority:1, side:'right', lift:10}),
              point('Transportadores de material', 38, 62, 1.68, brands.transmision, 'Cadenas transportadoras, Barras, Ejes, Rodamientos, Reductores, Tensores', 38, 62, {priority:2, side:'right', lift:-10}),
              point('Motor y refrigeración', 50, 47, 1.70, brands.motor, 'Motor, Radiador, Ventilador, Filtros, Bombas, Correas, Enfriadores', 50, 47, {priority:3, side:'right', lift:-12}),
              point('Puesto del operador', 59, 33, 1.56, brands.cabina, 'Asientos, Consola, Controles, Sensores, Pantalla, Cableado, Techo', 59, 33, {priority:4, side:'left', lift:-12}),
              point('Tren de rodaje', 62, 72, 1.62, brands.rodados, 'Orugas, Rodillos, Piñones, Tensores, Reductores, Bastidor', 62, 71, {priority:5, side:'left', lift:10}),
              point('Regla / screed', 82, 68, 1.66, brands.hidraulica, 'Regla, Placas, Vibradores, Calefacción, Cilindros, Sensores de nivel', 81, 67, {priority:6, side:'left', lift:12})
            ],
            top: [
              point('Tolva de recepción', 14, 50, 1.58, brands.estructura, 'Tolva, Alas, Rodillos de empuje, Cilindros, Chapas', 15, 50, {priority:1, side:'right'}),
              point('Cadenas transportadoras', 33, 50, 1.68, brands.transmision, 'Cadenas, Barras transportadoras, Ejes, Rodamientos, Reductores, Tensores', 33, 50, {priority:2, side:'right', lift:-12}),
              point('Motor y bombas', 50, 42, 1.72, brands.motor, 'Motor, Bombas hidráulicas, Radiador, Filtros, Enfriadores, Mangueras', 50, 42, {priority:3, side:'right', lift:10}),
              point('Puesto de operación', 60, 58, 1.56, brands.cabina, 'Consolas, Asientos, Controles, Sensores, Pantallas, Cableado', 60, 58, {priority:4, side:'left', lift:-10}),
              point('Orugas y reductores', 64, 75, 1.62, brands.rodados, 'Orugas, Rodillos, Piñones, Reductores, Tensores, Bastidores', 64, 73, {priority:5, side:'left', lift:10}),
              point('Sinfines y regla', 84, 50, 1.68, brands.hidraulica, 'Sinfines, Motores, Reductores, Regla, Vibradores, Cilindros, Sensores', 83, 50, {priority:6, side:'left', lift:12})
            ],
            rear: [
              point('Regla de extendido', 50, 79, 1.68, brands.estructura, 'Regla, Placas de desgaste, Extensiones, Calefacción, Vibradores, Tamper', 50, 77, {priority:1, side:'right', lift:12}),
              point('Sinfines distribuidores', 50, 66, 1.70, brands.transmision, 'Sinfines, Paletas, Ejes, Rodamientos, Reductores, Motores', 50, 65, {priority:2, side:'left', lift:10}),
              point('Hidráulica de la regla', 34, 58, 1.68, brands.hidraulica, 'Cilindros, Válvulas, Mangueras, Sensores de nivel, Acoples', 34, 58, {priority:3, side:'right', lift:-10}),
              point('Motor y refrigeración', 50, 42, 1.70, brands.motor, 'Motor, Radiador, Ventilador, Filtros, Bombas, Enfriadores', 50, 42, {priority:4, side:'right', lift:-12}),
              point('Puesto del operador', 50, 27, 1.56, brands.cabina, 'Asientos, Consolas, Controles, Sensores, Pantallas, Cableado', 50, 28, {priority:5, side:'left', lift:-12}),
              point('Orugas y mando final', 70, 70, 1.62, brands.rodados, 'Orugas, Rodillos, Piñones, Reductores, Tensores, Rodamientos', 69, 69, {priority:6, side:'left', lift:12})
            ]
          },
          '6': { // COMPACTADORAS
            front: [
              point('Tambor compactador', 24, 69, 1.62, brands.estructura, 'Tambor, Bandas, Rascadores, Soportes, Rodamientos, Soldaduras', 25, 68, {priority:1, side:'right', lift:10}),
              point('Sistema vibratorio', 35, 59, 1.72, brands.transmision, 'Excéntricos, Motor vibratorio, Rodamientos, Ejes, Acoples, Amortiguadores', 35, 59, {priority:2, side:'right', lift:-10}),
              point('Hidráulica de tracción', 47, 54, 1.70, brands.hidraulica, 'Bombas, Motores hidráulicos, Válvulas, Mangueras, Filtros, Enfriador', 47, 54, {priority:3, side:'right', lift:10}),
              point('Cabina y controles', 57, 33, 1.56, brands.cabina, 'Asiento, Volante, Joystick, Tablero, Sensores, Climatización', 57, 33, {priority:4, side:'left', lift:-12}),
              point('Motor y refrigeración', 68, 50, 1.70, brands.motor, 'Motor, Radiador, Ventilador, Filtros, Bombas, Correas, Enfriadores', 68, 50, {priority:5, side:'left', lift:-8}),
              point('Eje trasero y neumáticos', 84.0, 62.5, 1.68, brands.rodados, 'Eje, Diferencial, Mazas, Rodamientos, Frenos, Neumáticos, Llantas', 82.0, 63.0, {priority:6, side:'left', lift:8, line:38})
            ],
            top: [
              point('Tambor y rascadores', 15, 50, 1.62, brands.estructura, 'Tambor, Rascadores, Soportes, Rodamientos, Amortiguadores', 16, 50, {priority:1, side:'right'}),
              point('Vibración y excéntricos', 29, 50, 1.72, brands.transmision, 'Excéntricos, Ejes, Rodamientos, Motor vibratorio, Acoples', 29, 50, {priority:2, side:'right', lift:-12}),
              point('Articulación y dirección', 46, 50, 1.68, brands.hidraulica, 'Articulación, Cilindros de dirección, Pasadores, Bujes, Mangueras', 46, 50, {priority:3, side:'right', lift:10}),
              point('Cabina y controles', 58, 48, 1.56, brands.cabina, 'Asiento, Controles, Tablero, Sensores, Volante, Climatización', 58, 48, {priority:4, side:'left', lift:-12}),
              point('Motor e hidráulica', 72, 50, 1.70, brands.motor, 'Motor, Bombas, Radiador, Filtros, Enfriadores, Válvulas, Mangueras', 72, 50, {priority:5, side:'left', lift:8}),
              point('Eje y rodado trasero', 84, 55, 1.62, brands.rodados, 'Eje, Diferencial, Mazas, Rodamientos, Frenos, Neumáticos', 83, 55, {priority:6, side:'left', lift:12})
            ],
            rear: [
              point('Motor y refrigeración', 50, 43, 1.70, brands.motor, 'Motor, Radiador, Ventilador, Filtros, Bombas, Correas, Enfriadores', 50, 43, {priority:1, side:'right', lift:-12}),
              point('Bombas hidráulicas', 35, 55, 1.70, brands.hidraulica, 'Bombas, Válvulas, Filtros, Mangueras, Depósito, Enfriador', 35, 55, {priority:2, side:'right', lift:8}),
              point('Cabina y eléctrico', 50, 28, 1.56, brands.electrico, 'Cabina, Tablero, Sensores, Luces, Arnés, Fusibles, Relés', 50, 29, {priority:3, side:'left', lift:-12}),
              point('Eje y diferencial', 50, 65, 1.68, brands.transmision, 'Diferencial, Semiejes, Reductores, Rodamientos, Retenes, Mazas', 50, 65, {priority:4, side:'right', lift:10}),
              point('Frenos', 33, 72, 1.62, brands.frenos, 'Discos, Pastillas, Tambores, Bombines, Líneas, Sensores', 34, 70, {priority:5, side:'right', lift:12}),
              point('Neumáticos y mazas', 72, 72, 1.60, brands.rodados, 'Neumáticos, Llantas, Mazas, Rodamientos, Tuercas, Retenes', 71, 70, {priority:6, side:'left', lift:12})
            ]
          },
          '7': { // GRÚAS
            front: [
              point('Gancho y bloque de poleas', 29.0, 73.0, 1.62, brands.izaje, 'Gancho, Bloque, Poleas, Rodamientos, Seguros, Cable de acero', 29.0, 72.0, {priority:1, side:'right', lift:10, line:40}),
              point('Pluma telescópica', 47.0, 23.5, 1.68, brands.estructura, 'Secciones de pluma, Patines, Pasadores, Cilindros telescópicos, Guías', 47.0, 24.0, {priority:2, side:'right', lift:-12, line:42}),
              point('Cabina y controles', 67.0, 36.0, 1.64, brands.cabina, 'Cabina, Joysticks, Pantallas, Sensores, Pedales, Climatización', 67.0, 36.0, {priority:3, side:'left', lift:-12, line:40}),
              point('Corona y sistema de giro', 63.0, 50.5, 1.76, brands.transmision, 'Corona, Piñón, Reductor, Motor de giro, Rodamientos, Pernos', 63.0, 50.5, {priority:4, side:'right', lift:8, line:40}),
              point('Motor, bombas y contrapeso', 79.0, 42.0, 1.74, brands.motor, 'Motor, Bombas hidráulicas, Radiador, Filtros, Contrapesos, Enfriadores', 78.0, 42.0, {priority:5, side:'left', lift:-8, line:42}),
              point('Chasis, ejes y estabilizadores', 65.0, 74.0, 1.68, brands.rodados, 'Ejes, Diferenciales, Suspensión, Neumáticos, Estabilizadores, Cilindros', 65.0, 72.0, {priority:6, side:'left', lift:12, line:40})
            ],
            top: [
              point('Cabezal y poleas', 15, 50, 1.58, brands.izaje, 'Poleas, Cabezal, Rodamientos, Pasadores, Cable, Limitadores', 16, 50, {priority:1, side:'right'}),
              point('Pluma telescópica', 38, 50, 1.66, brands.estructura, 'Secciones, Patines, Cilindros, Guías, Pasadores, Cableado', 38, 50, {priority:2, side:'right', lift:-12}),
              point('Corona de giro', 61, 50, 1.72, brands.transmision, 'Corona, Piñón, Motor, Reductor, Rodamientos, Pernos', 61, 50, {priority:3, side:'left', lift:10}),
              point('Cabina del operador', 69, 35, 1.56, brands.cabina, 'Cabina, Joysticks, Pantallas, Sensores, Climatización', 69, 36, {priority:4, side:'left', lift:-12}),
              point('Cabrestante y sistema hidráulico', 79, 51, 1.70, brands.hidraulica, 'Cabrestante, Tambor, Motor hidráulico, Válvulas, Bombas, Mangueras', 78, 51, {priority:5, side:'left', lift:8}),
              point('Estabilizadores y chasis', 70, 72, 1.62, brands.estructura, 'Estabilizadores, Vigas telescópicas, Cilindros, Chasis, Soportes', 69, 70, {priority:6, side:'left', lift:12})
            ],
            rear: [
              point('Cabrestante principal', 50, 31, 1.68, brands.izaje, 'Cabrestante, Tambor, Cable, Motor, Reductor, Freno, Rodamientos', 50, 32, {priority:1, side:'right', lift:-12}),
              point('Contrapeso', 50, 43, 1.58, brands.estructura, 'Contrapesos, Bastidor, Pasadores, Seguros, Soportes', 50, 43, {priority:2, side:'left', lift:-10}),
              point('Motor e hidráulica', 36, 51, 1.70, brands.motor, 'Motor, Bombas, Radiador, Filtros, Válvulas, Enfriadores', 36, 51, {priority:3, side:'right', lift:8}),
              point('Corona y giro', 64, 53, 1.72, brands.transmision, 'Corona, Piñón, Motor de giro, Reductor, Rodamientos, Pernos', 64, 53, {priority:4, side:'left', lift:8}),
              point('Ejes, suspensión y frenos', 50, 69, 1.64, brands.frenos, 'Ejes, Diferenciales, Suspensión, Frenos, Mazas, Rodamientos', 50, 68, {priority:5, side:'right', lift:12}),
              point('Estabilizadores traseros', 73, 65, 1.62, brands.hidraulica, 'Vigas, Cilindros, Zapatas, Válvulas, Mangueras, Pasadores', 72, 64, {priority:6, side:'left', lift:12})
            ]
          },
          '8': { // MOTONIVELADORAS
            front: [
              /*
                MOTONIVELADORA · FRONTAL 3/4
                Recalibrada contra la vista definitiva mostrada en la web.
                Frente/eje delantero: derecha. Motor y tándem: izquierda.
              */
              point('Eje delantero y dirección', 80.0, 57.5, 1.72, brands.hidraulica, 'Eje delantero, Manguetas, Barras, Rótulas, Cilindros, Bujes, Mazas', 79.0, 58.0, {priority:1, side:'left', lift:8, line:40}),
              point('Círculo y giro de hoja', 41.5, 63.0, 1.78, brands.transmision, 'Corona circular, Piñón, Motor de giro, Guías, Patines, Pernos', 42.0, 63.0, {priority:2, side:'right', lift:-10, line:40}),
              point('Hoja niveladora', 39.5, 67.5, 1.68, brands.corte, 'Hoja, Cuchilla, Cantoneras, Porta hoja, Pernos, Deslizaderas', 40.0, 67.0, {priority:3, side:'right', lift:10, line:40}),
              point('Cilindros de elevación', 46.5, 52.5, 1.74, brands.hidraulica, 'Cilindros, Vástagos, Sellos, Mangueras, Válvulas, Pasadores', 47.0, 52.5, {priority:4, side:'left', lift:-12, line:40}),
              point('Cabina y controles', 39.5, 34.0, 1.64, brands.cabina, 'Cabina, Volante, Joysticks, Tablero, Sensores, Climatización', 40.0, 34.0, {priority:5, side:'right', lift:-12, line:42}),
              point('Motor y transmisión', 27.5, 50.0, 1.76, brands.motor, 'Motor, Radiador, Filtros, Caja, Convertidor, Bombas, Enfriadores', 28.0, 50.0, {priority:6, side:'right', lift:6, line:42})
            ],
            top: [
              point('Eje delantero y dirección', 50, 18, 1.64, brands.hidraulica, 'Eje delantero, Manguetas, Barras, Rótulas, Cilindros, Mazas', 50, 19, {priority:1, side:'right', lift:-10}),
              point('Barra de tiro', 48, 36, 1.62, brands.estructura, 'Barra de tiro, Rótula, Bastidor, Pasadores, Bujes, Soportes', 48, 36, {priority:2, side:'right', lift:-12}),
              point('Círculo y hoja', 48, 52, 1.72, brands.corte, 'Círculo, Corona, Hoja, Cuchillas, Motor de giro, Guías, Patines', 48, 52, {priority:3, side:'right', lift:10}),
              point('Cabina y controles', 50, 66, 1.56, brands.cabina, 'Cabina, Controles, Tablero, Sensores, Asiento, Climatización', 50, 65, {priority:4, side:'left', lift:-10}),
              point('Motor y refrigeración', 50, 82, 1.70, brands.motor, 'Motor, Radiador, Ventilador, Filtros, Bombas, Correas, Enfriadores', 50, 80, {priority:5, side:'left', lift:8}),
              point('Tándem y transmisión final', 72, 79, 1.68, brands.transmision, 'Tándem, Cadenas internas, Ejes, Reductores, Rodamientos, Retenes', 71, 77, {priority:6, side:'left', lift:12})
            ],
            rear: [
              point('Cabina y sistema eléctrico', 50, 28, 1.56, brands.electrico, 'Cabina, Tablero, Sensores, Luces, Arnés, Fusibles, Relés', 50, 29, {priority:1, side:'right', lift:-12}),
              point('Motor y refrigeración', 50, 46, 1.72, brands.motor, 'Motor, Radiador, Ventilador, Filtros, Bombas, Correas, Enfriadores', 50, 46, {priority:2, side:'left', lift:-10}),
              point('Transmisión y diferencial', 50, 59, 1.72, brands.transmision, 'Caja, Diferencial, Ejes, Engranajes, Rodamientos, Retenes', 50, 59, {priority:3, side:'right', lift:8}),
              point('Hidráulica trasera', 50, 68, 1.68, brands.hidraulica, 'Válvulas, Mangueras, Cilindros, Bombas, Filtros, Acoples', 50, 67, {priority:4, side:'left', lift:10}),
              point('Tándem y ruedas traseras', 73, 68, 1.64, brands.rodados, 'Tándem, Ejes, Mazas, Rodamientos, Neumáticos, Llantas, Frenos', 72, 67, {priority:5, side:'left', lift:12}),
              point('Ripper / escarificador', 50, 82, 1.60, brands.corte, 'Ripper, Dientes, Porta dientes, Vástagos, Pasadores, Bujes, Cilindros', 50, 80, {priority:6, side:'right', lift:12})
            ]
          }
        };

        const appendPoint = (category, view, data, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'mx-hotspot-ncx';
          button.dataset.hotspot = '';
          button.dataset.autoHotspot = 'true';
          button.dataset.autoPriority = 'specific';
          button.dataset.autoVisible = 'false';
          button.dataset.priority = String(data.priority || index + 1);
          button.dataset.calloutSide = data.side || 'auto';
          button.dataset.category = String(category);
          button.dataset.view = view;
          button.dataset.title = data.title;
          button.dataset.description = `Consultá repuestos, compatibilidades y alternativas para ${data.title.toLowerCase()}.`;
          button.dataset.components = data.components;
          button.dataset.brands = data.brands;
          button.dataset.x = String(data.x);
          button.dataset.y = String(data.y);
          button.dataset.mobileX = String(data.mobileX ?? data.x);
          button.dataset.mobileY = String(data.mobileY ?? data.y);
          button.dataset.zoom = String(data.zoom || 1.64);
          button.dataset.detail = '';
          button.style.setProperty('--x', `${data.x}%`);
          button.style.setProperty('--y', `${data.y}%`);
          button.style.setProperty('--mobile-x', `${data.mobileX ?? data.x}%`);
          button.style.setProperty('--mobile-y', `${data.mobileY ?? data.y}%`);
          button.style.setProperty('--callout-delay', `${index * 74}ms`);
          button.style.setProperty('--mx-label-lift', `${Number(data.lift || 0)}px`);

          const titleLength = String(data.title || '').trim().length;
          const adaptiveLine = Number(data.line || 0) || (titleLength >= 25 ? 78 : titleLength >= 18 ? 68 : 56);
          const adaptiveLabelWidth = titleLength >= 25 ? 220 : titleLength >= 18 ? 198 : 172;
          button.dataset.baseLineLength = String(adaptiveLine);
          button.dataset.baseLabelWidth = String(adaptiveLabelWidth);
          button.dataset.baseLabelHeight = String(titleLength >= 19 ? 36 : 34);
          button.style.setProperty('--mx-hotspot-line-length', `${adaptiveLine}px`);
          button.style.setProperty('--mx-label-max-width', `${adaptiveLabelWidth}px`);
          button.style.setProperty('--mx-label-min-height', `${titleLength >= 19 ? 36 : 34}px`);
          button.setAttribute('aria-label', `Explorar ${data.title}`);

          const callout = document.createElement('span');
          callout.className = 'mx-hotspot-callout-ncx';
          callout.setAttribute('aria-hidden', 'true');
          const line = document.createElement('span');
          line.className = 'mx-hotspot-line-ncx';
          const label = document.createElement('span');
          label.className = 'mx-hotspot-label-ncx';
          label.textContent = data.title;
          const orbit = document.createElement('span');
          orbit.className = 'mx-hotspot-orbit-ncx';
          orbit.setAttribute('aria-hidden', 'true');
          const dot = document.createElement('span');
          dot.className = 'mx-hotspot-dot-ncx';
          callout.append(line, label);
          button.append(callout, orbit, dot);
          this.hotspotPlane.appendChild(button);
        };

        Object.entries(profiles).forEach(([category, views]) => {
          Object.entries(views).forEach(([view, points]) => {
            points.forEach((data, index) => appendPoint(category, view, data, index));
          });
        });
      }

      installViewHotspotLibrary() {
        if (!this.hotspotPlane || this.hotspotPlane.dataset.libraryReady === 'true') return;
        this.hotspotPlane.dataset.libraryReady = 'true';

        const brands = {
          motor: 'Fleetguard, Donaldson, Bosch, Perkins, Cummins, Caterpillar',
          hidraulica: 'Parker, Rexroth, Eaton, Danfoss, Hydac',
          transmision: 'ZF, Dana, Carraro, Spicer, Eaton',
          electrico: 'Bosch, Hella, Denso, Delco Remy, Valeo',
          rodados: 'BKT, Michelin, Goodyear, Bridgestone, Trelleborg',
          estructura: 'Original, Alternativo, Nacional, Importado',
          cabina: 'Denso, Sanden, Bosch, Hella, Grammer',
          frenos: 'Knorr-Bremse, Wabco, Meritor, Bendix, Bosch',
          neumatica: 'Wabco, Knorr-Bremse, Parker, SMC, Festo',
          corte: 'Original, Alternativo, Hardox, Esco, Black Cat',
          implementos: 'Original, Alternativo, Nacional, Importado, Esco'
        };

        const point = (
          title,
          x,
          y,
          zoom,
          brandList,
          components,
          mobileX = x,
          mobileY = y,
          options = {}
        ) => ({
          title,
          x,
          y,
          mobileX,
          mobileY,
          zoom,
          brands: brandList,
          components,
          priority: Number(options.priority || 4),
          side: options.side || 'auto',
          lift: Number(options.lift || 0),
          line: Number(options.line || 58)
        });

        /*
          PERFILES DE DOTS POR CATEGORÍA Y PERSPECTIVA
          --------------------------------------------------
          Cada perfil reemplaza por completo los dots genéricos de esa vista.
          Se muestran únicamente las zonas mecánicas realmente visibles desde
          el ángulo seleccionado. Las coordenadas son porcentajes de la imagen.

          Categorías:
          1 Tractores · 2 Excavadoras · 3 Retroexcavadoras · 4 Camiones
          5 Maquinaria forestal · 6 Maquinaria agrícola · 7 Repuestos
        */
        const profiles = {
          '1': {
            /* Tractor — vista superior real suministrada. */
            top: [
              point('Motor y refrigeración', 31, 49, 1.64, brands.motor, 'Motor, Radiador, Bomba de agua, Termostato, Correas, Ventilador, Mangueras, Enfriador de aceite'),
              point('Cabina y controles', 60, 47, 1.56, brands.cabina, 'Asiento, Tablero, Comandos, Pedalera, Columna de dirección, Climatización, Cristales'),
              point('Dirección y eje delantero', 24, 59, 1.66, brands.hidraulica, 'Orbitrol, Rótulas, Barras, Cilindro de dirección, Bujes, Pernos, Terminales, Eje delantero'),
              point('Transmisión central', 48, 57, 1.72, brands.transmision, 'Caja, Embrague, Sincronizadores, Ejes, Engranajes, Retenes, Cardanes'),
              point('Eje y rodado trasero', 77, 59, 1.66, brands.rodados, 'Diferencial, Semiejes, Rodamientos, Retenes, Neumáticos, Llantas, Pesas, Frenos'),
              point('Hidráulica, enganche y PTO', 88, 50, 1.66, brands.hidraulica, 'Distribuidores, Acoples rápidos, Mangueras, Toma de fuerza, Brazos, Tercer punto, Pasadores, Tensores')
            ],

            /*
              Tractor — vista frontal/3⁄4 del ejemplo suministrado.
              El dot MOTOR queda exactamente sobre el bloque del motor visible.
            */
            front: [
              point('Motor', 15.5, 49.5, 1.72, brands.motor, 'Bloque de motor, Pistones, Camisas, Culata, Inyectores, Turbo, Bomba de combustible, Juntas'),
              point('Cabina y sistema eléctrico', 62.2, 24.5, 1.56, brands.electrico, 'Cabina, Tablero, Sensores, Faros, Relés, Fusibles, Arnés, Batería, Climatización'),
              point('Sistema hidráulico', 82.2, 46.0, 1.68, brands.hidraulica, 'Bombas, Distribuidores, Mangueras, Cilindros, Filtros, Sellos, Retenes, Acoples'),
              point('Dirección y suspensión', 93.8, 65.0, 1.62, brands.hidraulica, 'Orbitrol, Rótulas, Barras, Cilindro de dirección, Bujes, Pernos, Terminales'),
              point('Transmisión', 47.0, 77.0, 1.74, brands.transmision, 'Caja, Embrague, Cardanes, Crucetas, Diferenciales, Semiejes, Rodamientos, Retenes'),
              point('Ruedas y ejes', 87.0, 78.0, 1.60, brands.rodados, 'Neumáticos, Llantas, Mazas, Rodamientos, Semiejes, Diferenciales, Tuercas, Bulones')
            ],

            /* Tractor — vista trasera real suministrada. */
            rear: [
              point('Cabina y climatización', 50, 34, 1.56, brands.cabina, 'Cristal trasero, Cerraduras, Burletes, Limpiaparabrisas, Filtros, Ventilación, Asiento'),
              point('Luces y sistema eléctrico', 50, 44, 1.54, brands.electrico, 'Faros, Balizas, Ópticas, Sensores, Relés, Fusibles, Arnés, Conectores'),
              point('Hidráulica trasera', 56, 58, 1.70, brands.hidraulica, 'Distribuidores, Acoples rápidos, Mangueras, Cilindros, Válvulas, Sellos y retenes'),
              point('Eje y diferencial trasero', 50, 62, 1.76, brands.transmision, 'Diferencial, Piñón y corona, Palieres, Rodamientos, Retenes, Carcasa'),
              point('Toma de fuerza y enganche', 50, 73, 1.72, brands.estructura, 'Eje PTO, Embrague PTO, Brazos inferiores, Tercer punto, Estabilizadores, Rótulas, Pasadores, Tensores'),
              point('Frenos y rodado trasero', 70, 68, 1.60, brands.rodados, 'Frenos, Neumáticos, Llantas, Cámaras, Válvulas, Pesas, Tuercas, Bulones, Mazas')
            ]
          },

          '2': {
            top: [
              point('Cucharón y acople', 15, 50, 1.60, brands.corte, 'Cucharón, Dientes, Portadientes, Cuchillas, Laterales, Pasadores, Bujes, Acople rápido'),
              point('Brazo, pluma y cilindros', 39, 50, 1.66, brands.hidraulica, 'Pluma, Brazo, Cilindros, Vástagos, Sellos, Retenes, Mangueras, Pasadores, Bujes'),
              point('Corona y sistema de giro', 61, 52, 1.74, brands.transmision, 'Corona de giro, Motor de giro, Reductor, Rodamientos, Retenes, Pernos, Engranajes'),
              point('Motor y refrigeración', 81, 36, 1.68, brands.motor, 'Motor, Radiador, Ventilador, Bomba de agua, Filtros, Correas, Mangueras, Enfriadores'),
              point('Cabina y controles', 72, 65, 1.58, brands.cabina, 'Asiento, Joysticks, Tablero, Pedales, Cristales, Climatización, Limpiaparabrisas'),
              point('Tren de rodaje', 80, 22, 1.62, brands.rodados, 'Cadenas, Rodillos, Rueda guía, Tensor, Zapatas, Piñón, Pernos, Bastidor inferior')
            ],
            front: [
              point('Pluma y cilindros hidráulicos', 49, 27, 1.62, brands.hidraulica, 'Pluma, Cilindros, Vástagos, Sellos, Retenes, Mangueras, Pasadores, Bujes'),
              point('Cabina y controles', 61, 43, 1.58, brands.cabina, 'Asiento, Joysticks, Tablero, Pedales, Cristales, Climatización, Limpiaparabrisas'),
              point('Motor y refrigeración', 38, 49, 1.68, brands.motor, 'Motor, Radiador, Ventilador, Bomba de agua, Filtros, Correas, Mangueras, Enfriadores'),
              point('Bombas y sistema de giro', 49, 58, 1.74, brands.hidraulica, 'Bombas hidráulicas, Válvulas, Distribuidores, Corona de giro, Motor de giro, Reductor, Rodamientos, Retenes'),
              point('Tren de rodaje', 50, 75, 1.64, brands.rodados, 'Cadenas, Rodillos, Rueda guía, Tensor, Zapatas, Piñón, Pernos, Bastidor inferior'),
              point('Cucharón y acople', 50, 86, 1.58, brands.corte, 'Cucharón, Dientes, Portadientes, Cuchillas, Pasadores, Bujes, Acople rápido, Laterales')
            ],
            rear: [
              point('Motor y refrigeración', 47, 40, 1.66, brands.motor, 'Motor, Radiador, Ventilador, Filtros, Bombas, Correas, Mangueras, Enfriadores'),
              point('Cabina y sistema eléctrico', 68, 40, 1.56, brands.electrico, 'Cabina, Tablero, Sensores, Relés, Fusibles, Arnés, Baterías, Iluminación'),
              point('Contrapeso y estructura', 50, 54, 1.54, brands.estructura, 'Contrapeso, Capot, Puertas, Soportes, Bisagras, Cerraduras, Tornillería'),
              point('Bombas y sistema hidráulico', 33, 56, 1.72, brands.hidraulica, 'Bombas, Distribuidores, Mangueras, Válvulas, Filtros, Sellos, Retenes'),
              point('Corona y reductor de giro', 50, 66, 1.74, brands.transmision, 'Corona, Motor de giro, Reductor, Rodamientos, Retenes, Pernos, Engranajes'),
              point('Tren de rodaje', 50, 80, 1.62, brands.rodados, 'Cadenas, Rodillos, Rueda guía, Tensor, Zapatas, Piñón, Bastidor inferior')
            ]
          },

          '3': {
            top: [
              point('Cucharón delantero', 11, 50, 1.56, brands.corte, 'Cucharón, Dientes, Cuchillas, Laterales, Pasadores, Bujes, Acople'),
              point('Motor y cargador frontal', 32, 50, 1.66, brands.motor, 'Motor, Radiador, Filtros, Brazos de cargador, Cilindros, Mangueras, Pasadores'),
              point('Cabina y controles', 51, 49, 1.56, brands.cabina, 'Asiento, Tablero, Joysticks, Pedales, Cristales, Climatización, Comandos'),
              point('Transmisión y eje trasero', 62, 59, 1.72, brands.transmision, 'Caja, Convertidor, Cardanes, Diferencial, Palieres, Frenos, Rodamientos'),
              point('Brazo retro y cucharón', 79, 46, 1.64, brands.hidraulica, 'Pluma, Brazo, Cilindros, Cucharón, Dientes, Pasadores, Bujes, Mangueras'),
              point('Estabilizadores', 67, 76, 1.58, brands.estructura, 'Patas estabilizadoras, Cilindros, Zapatas, Pasadores, Bujes, Mangueras, Soportes')
            ],
            front: [
              point('Cucharón delantero', 16, 72, 1.58, brands.corte, 'Cucharón, Dientes, Cuchillas, Laterales, Pasadores, Bujes, Acople'),
              point('Brazos y sistema hidráulico frontal', 32, 57, 1.66, brands.hidraulica, 'Brazos, Cilindros, Mangueras, Válvulas, Pasadores, Bujes, Sellos'),
              point('Motor y refrigeración', 40, 45, 1.68, brands.motor, 'Motor, Radiador, Ventilador, Filtros, Correas, Bomba de agua, Mangueras'),
              point('Cabina y sistema eléctrico', 55, 35, 1.56, brands.electrico, 'Cabina, Tablero, Sensores, Faros, Relés, Fusibles, Arnés, Climatización'),
              point('Transmisión, ejes y rodados', 65, 66, 1.70, brands.transmision, 'Caja, Convertidor, Cardanes, Diferenciales, Semiejes, Frenos, Neumáticos, Llantas'),
              point('Brazo retro y cucharón', 85, 45, 1.64, brands.hidraulica, 'Pluma, Brazo, Cilindros, Cucharón, Dientes, Pasadores, Bujes, Mangueras')
            ],
            rear: [
              point('Brazo retro y cilindros', 59, 34, 1.66, brands.hidraulica, 'Pluma, Brazo, Cilindros, Vástagos, Sellos, Mangueras, Pasadores, Bujes'),
              point('Cabina y controles', 47, 29, 1.56, brands.cabina, 'Asiento, Tablero, Joysticks, Cristales, Climatización, Limpiaparabrisas'),
              point('Distribuidor hidráulico', 50, 58, 1.72, brands.hidraulica, 'Distribuidor, Válvulas, Mangueras, Acoples, Filtros, Sellos, Retenes'),
              point('Eje y diferencial trasero', 50, 72, 1.72, brands.transmision, 'Diferencial, Palieres, Frenos, Rodamientos, Retenes, Mazas'),
              point('Estabilizadores', 28, 78, 1.58, brands.estructura, 'Patas, Cilindros, Zapatas, Pasadores, Bujes, Mangueras, Soportes'),
              point('Luces y sistema eléctrico', 34, 46, 1.54, brands.electrico, 'Faros, Balizas, Sensores, Arnés, Relés, Fusibles, Conectores')
            ]
          },

          '4': {
            top: [
              point('Motor y refrigeración', 34, 30, 1.68, brands.motor, 'Motor, Radiador, Intercooler, Ventilador, Bombas, Filtros, Correas, Mangueras'),
              point('Cabina y sistema eléctrico', 50, 28, 1.56, brands.electrico, 'Cabina, Tablero, Sensores, Faros, Relés, Fusibles, Arnés, Climatización'),
              point('Caja y transmisión', 48, 48, 1.72, brands.transmision, 'Caja, Embrague, Retarder, Cardán, Crucetas, Soportes, Retenes'),
              point('Combustible, escape y neumática', 63, 54, 1.64, brands.neumatica, 'Tanques, Bomba de combustible, Escape, Compresor, Secador, Válvulas, Depósitos'),
              point('Chasis y suspensión', 51, 62, 1.62, brands.estructura, 'Chasis, Travesaños, Ballestas, Amortiguadores, Bujes, Soportes, Silentblocks'),
              point('Ejes y rodado trasero', 67, 74, 1.66, brands.rodados, 'Diferenciales, Semiejes, Mazas, Rodamientos, Frenos, Neumáticos, Llantas')
            ],
            front: [
              point('Cabina y sistema eléctrico', 50, 31, 1.56, brands.electrico, 'Cabina, Tablero, Sensores, Faros, Relés, Fusibles, Arnés, Climatización'),
              point('Motor y refrigeración', 50, 51, 1.70, brands.motor, 'Motor, Radiador, Intercooler, Ventilador, Bombas, Filtros, Correas, Mangueras'),
              point('Dirección y eje delantero', 31, 69, 1.66, brands.hidraulica, 'Caja de dirección, Bomba, Barras, Rótulas, Pernos, Eje, Mazas, Rodamientos'),
              point('Frenos y neumática', 72, 69, 1.64, brands.frenos, 'Pulmones, Discos, Pastillas, Tambores, Válvulas, Compresor, Mangueras, Sensores ABS'),
              point('Caja y transmisión', 50, 67, 1.72, brands.transmision, 'Caja, Embrague, Retarder, Cardán, Crucetas, Soportes, Retenes'),
              point('Chasis y suspensión', 50, 82, 1.60, brands.estructura, 'Chasis, Travesaños, Ballestas, Amortiguadores, Bujes, Soportes, Silentblocks')
            ],
            rear: [
              point('Luces y sistema eléctrico', 50, 31, 1.54, brands.electrico, 'Ópticas, Lámparas, Sensores, Conectores, Arnés, Relés, Fusibles'),
              point('Chasis y quinta rueda', 50, 48, 1.62, brands.estructura, 'Chasis, Quinta rueda, Travesaños, Soportes, Bulones, Bujes'),
              point('Diferencial y transmisión', 50, 62, 1.72, brands.transmision, 'Diferencial, Piñón y corona, Semiejes, Cardán, Crucetas, Retenes'),
              point('Frenos traseros', 34, 69, 1.64, brands.frenos, 'Pulmones, Discos, Pastillas, Tambores, Válvulas, Sensores ABS, Mangueras'),
              point('Suspensión neumática', 68, 66, 1.64, brands.neumatica, 'Pulmones, Válvulas niveladoras, Amortiguadores, Bujes, Barras, Soportes'),
              point('Ejes y rodados', 50, 79, 1.62, brands.rodados, 'Ejes, Mazas, Rodamientos, Neumáticos, Llantas, Tuercas, Retenes')
            ]
          },

          '5': {
            top: [
              point('Cabezal de corte', 13, 50, 1.60, brands.corte, 'Rodillos, Cuchillas, Sierra, Motores, Sensores, Mangueras, Pasadores, Carcasa'),
              point('Pluma y sistema hidráulico', 36, 48, 1.68, brands.hidraulica, 'Pluma, Cilindros, Válvulas, Mangueras, Bombas, Pasadores, Bujes, Acoples'),
              point('Cabina y controles', 55, 42, 1.56, brands.cabina, 'Cabina, Asiento, Joysticks, Computadora, Sensores, Cristales, Climatización'),
              point('Motor y refrigeración', 73, 44, 1.68, brands.motor, 'Motor, Radiador, Ventilador, Filtros, Bombas, Correas, Mangueras, Enfriadores'),
              point('Articulación y transmisión', 61, 59, 1.72, brands.transmision, 'Articulación central, Cardanes, Diferenciales, Reductores, Rodamientos, Bujes'),
              point('Ejes, ruedas y bogies', 79, 70, 1.62, brands.rodados, 'Ejes, Bogies, Neumáticos, Cadenas, Mazas, Rodamientos, Frenos')
            ],
            front: [
              point('Cabezal de corte', 20, 55, 1.60, brands.corte, 'Rodillos, Cuchillas, Sierra, Motores, Sensores, Mangueras, Pasadores, Carcasa'),
              point('Pluma y sistema hidráulico', 40, 43, 1.68, brands.hidraulica, 'Pluma, Cilindros, Válvulas, Mangueras, Bombas, Pasadores, Bujes, Acoples'),
              point('Cabina y controles', 56, 35, 1.56, brands.cabina, 'Cabina, Asiento, Joysticks, Computadora, Sensores, Cristales, Climatización'),
              point('Motor y refrigeración', 72, 45, 1.68, brands.motor, 'Motor, Radiador, Ventilador, Filtros, Bombas, Correas, Mangueras, Enfriadores'),
              point('Articulación y transmisión', 58, 65, 1.72, brands.transmision, 'Articulación central, Cardanes, Diferenciales, Reductores, Rodamientos, Bujes'),
              point('Ejes y rodados', 76, 78, 1.62, brands.rodados, 'Ejes, Bogies, Neumáticos, Cadenas, Mazas, Rodamientos, Frenos')
            ],
            rear: [
              point('Motor y refrigeración', 50, 42, 1.68, brands.motor, 'Motor, Radiador, Ventilador, Filtros, Bombas, Correas, Mangueras, Enfriadores'),
              point('Cabina y sistema eléctrico', 40, 31, 1.56, brands.electrico, 'Cabina, Computadora, Sensores, Relés, Fusibles, Arnés, Iluminación'),
              point('Grúa y sistema hidráulico', 69, 36, 1.68, brands.hidraulica, 'Pluma, Cilindros, Válvulas, Mangueras, Bombas, Pasadores, Bujes'),
              point('Chasis y protecciones', 50, 53, 1.58, brands.estructura, 'Chasis, Protectores, Rejillas, Soportes, Puertas, Bisagras, Tornillería'),
              point('Articulación y transmisión', 50, 62, 1.72, brands.transmision, 'Articulación, Cardanes, Diferenciales, Reductores, Rodamientos, Bujes'),
              point('Eje y rodado trasero', 50, 75, 1.62, brands.rodados, 'Ejes, Bogies, Neumáticos, Cadenas, Mazas, Rodamientos, Frenos')
            ]
          },

          '6': {
            top: [
              point('Plataforma de corte', 16, 50, 1.60, brands.corte, 'Molinete, Cuchillas, Sinfín, Dedos, Correas, Cadenas, Rodamientos, Divisores'),
              point('Embocador y alimentación', 37, 50, 1.66, brands.transmision, 'Cadena elevadora, Rodillos, Ejes, Correas, Embragues, Rodamientos, Tensores'),
              point('Trilla y separación', 54, 50, 1.72, brands.transmision, 'Rotor, Cilindro, Cóncavos, Sacapajas, Rodamientos, Correas, Cadenas'),
              point('Tolva y sistema de granos', 66, 42, 1.62, brands.estructura, 'Tolva, Elevadores, Sinfines, Cadenas, Sensores, Tapas, Actuadores'),
              point('Motor y refrigeración', 77, 51, 1.68, brands.motor, 'Motor, Radiador, Ventilador, Filtros, Bombas, Correas, Mangueras, Enfriadores'),
              point('Tubo de descarga', 81, 28, 1.58, brands.hidraulica, 'Tubo, Sinfín, Caja angular, Cilindros, Mangueras, Rodamientos, Acoples')
            ],
            front: [
              point('Cabina y controles', 55, 30, 1.56, brands.cabina, 'Cabina, Asiento, Joysticks, Pantalla, Sensores, Cristales, Climatización'),
              point('Motor y refrigeración', 72, 41, 1.68, brands.motor, 'Motor, Radiador, Ventilador, Filtros, Bombas, Correas, Mangueras, Enfriadores'),
              point('Trilla y separación', 50, 52, 1.72, brands.transmision, 'Rotor, Cilindro, Cóncavos, Sacapajas, Rodamientos, Correas, Cadenas'),
              point('Embocador', 50, 62, 1.64, brands.transmision, 'Cadena elevadora, Rodillos, Ejes, Correas, Embragues, Rodamientos, Tensores'),
              point('Plataforma de corte', 50, 79, 1.60, brands.corte, 'Molinete, Cuchillas, Sinfín, Dedos, Correas, Cadenas, Rodamientos, Divisores'),
              point('Ejes y rodados', 76, 75, 1.62, brands.rodados, 'Ejes, Reductores, Neumáticos, Llantas, Mazas, Rodamientos, Frenos')
            ],
            rear: [
              point('Tolva y sistema de granos', 50, 38, 1.62, brands.estructura, 'Tolva, Elevadores, Sinfines, Cadenas, Sensores, Tapas, Actuadores'),
              point('Motor y refrigeración', 70, 45, 1.68, brands.motor, 'Motor, Radiador, Ventilador, Filtros, Bombas, Correas, Mangueras, Enfriadores'),
              point('Sistema eléctrico', 34, 39, 1.54, brands.electrico, 'Sensores, Relés, Fusibles, Arnés, Baterías, Iluminación, Actuadores'),
              point('Limpieza y zarandas', 50, 59, 1.70, brands.transmision, 'Zarandas, Ventilador, Excéntricos, Ejes, Rodamientos, Correas, Sensores'),
              point('Picador y esparcidor', 50, 76, 1.62, brands.corte, 'Picador, Cuchillas, Contracuchillas, Esparcidores, Correas, Rodamientos'),
              point('Eje y rodado trasero', 68, 73, 1.60, brands.rodados, 'Eje, Dirección, Mazas, Rodamientos, Neumáticos, Llantas, Frenos')
            ]
          },

          '7': {
            top: [
              point('Motor y componentes internos', 34, 38, 1.72, brands.motor, 'Pistones, Camisas, Aros, Culata, Válvulas, Cigüeñal, Bielas, Juntas'),
              point('Bombas y sistema hidráulico', 59, 40, 1.70, brands.hidraulica, 'Bombas, Válvulas, Distribuidores, Mangueras, Filtros, Sellos, Retenes'),
              point('Caja y transmisión', 48, 58, 1.72, brands.transmision, 'Caja, Embrague, Convertidor, Engranajes, Ejes, Rodamientos, Retenes'),
              point('Diferenciales y ejes', 68, 64, 1.68, brands.transmision, 'Diferenciales, Piñón y corona, Semiejes, Crucetas, Palieres, Rodamientos'),
              point('Filtros y mantenimiento', 24, 60, 1.58, brands.motor, 'Filtros de aire, Aceite, Combustible, Hidráulicos, Correas, Mangueras, Kits')
            ],
            front: [
              point('Motor y refrigeración', 31, 42, 1.72, brands.motor, 'Motor, Radiador, Ventilador, Bombas, Filtros, Correas, Mangueras, Juntas'),
              point('Bombas y válvulas hidráulicas', 55, 42, 1.70, brands.hidraulica, 'Bombas, Válvulas, Distribuidores, Mangueras, Filtros, Sellos, Retenes'),
              point('Caja y transmisión', 45, 62, 1.72, brands.transmision, 'Caja, Embrague, Convertidor, Engranajes, Ejes, Rodamientos, Retenes'),
              point('Sistema eléctrico', 70, 35, 1.56, brands.electrico, 'Alternador, Arranque, Sensores, Relés, Fusibles, Arnés, Batería, Iluminación'),
              point('Frenos, ejes y rodados', 68, 68, 1.64, brands.frenos, 'Discos, Pastillas, Tambores, Mazas, Rodamientos, Semiejes, Neumáticos, Llantas'),
              point('Filtros y mantenimiento', 24, 66, 1.58, brands.motor, 'Filtros de aire, Aceite, Combustible, Hidráulicos, Correas, Mangueras, Kits')
            ],
            rear: [
              point('Caja y reductor', 42, 48, 1.72, brands.transmision, 'Caja, Reductor, Engranajes, Ejes, Rodamientos, Retenes, Carcasas'),
              point('Diferencial y semiejes', 59, 56, 1.70, brands.transmision, 'Diferencial, Piñón y corona, Semiejes, Palieres, Rodamientos, Retenes'),
              point('Toma de fuerza y acoples', 50, 72, 1.66, brands.estructura, 'Eje PTO, Acoples, Horquillas, Engranajes, Rodamientos, Retenes, Protectores'),
              point('Frenos y mazas', 30, 66, 1.64, brands.frenos, 'Discos, Pastillas, Tambores, Bombines, Mazas, Rodamientos, Resortes'),
              point('Sistema eléctrico y sensores', 70, 36, 1.56, brands.electrico, 'Sensores, Relés, Fusibles, Arnés, Conectores, Actuadores, Iluminación')
            ]
          }
        };


        /*
          COORDENADAS CALCULADAS SOBRE LAS TRES IMÁGENES DE TRACTOR
          ---------------------------------------------------------
          Estos tres perfiles reemplazan al perfil anterior. Los anclajes están
          puestos sobre la pieza visible y no sobre espacios vacíos del plano.
          El orden también define prioridad: 1 es el punto más importante.
        */
        
        profiles['1'] = {
          top: [
            point('Motor y refrigeración', 21.9, 51.8, 1.66, brands.motor, 'Motor, Radiador, Bomba de agua, Termostato, Correas, Ventilador, Mangueras, Enfriador de aceite', 22.0, 52.0, { priority: 1, side: 'right', lift: -8, line: 54 }),
            point('Filtración y escape', 31.5, 48.9, 1.60, brands.motor, 'Filtro de aire, Filtro de aceite, Filtro de combustible, Prefiltro, Escape, Silenciador, Sensores', 31.5, 49.0, { priority: 2, side: 'right', lift: -14, line: 48 }),
            point('Dirección y eje delantero', 24.0, 67.9, 1.64, brands.hidraulica, 'Orbitrol, Rótulas, Barras, Cilindro de dirección, Bujes, Pernos, Terminales, Eje delantero', 24.0, 68.0, { priority: 3, side: 'right', lift: 12, line: 52 }),
            point('Transmisión central', 45.1, 64.0, 1.72, brands.transmision, 'Caja, Embrague, Sincronizadores, Ejes, Engranajes, Retenes, Cardanes', 45.0, 64.0, { priority: 4, side: 'right', lift: 10, line: 52 }),
            point('Cabina y controles', 66.9, 48.7, 1.56, brands.cabina, 'Asiento, Tablero, Comandos, Pedalera, Columna de dirección, Climatización, Cristales', 67.0, 49.0, { priority: 5, side: 'left', lift: -10, line: 52 }),
            point('Sistema hidráulico', 78.9, 52.8, 1.66, brands.hidraulica, 'Distribuidores, Acoples rápidos, Mangueras, Toma de fuerza, Cilindros auxiliares, Válvulas, Filtros, Sellos', 79.0, 53.0, { priority: 6, side: 'left', lift: -6, line: 48 }),
            point('Eje y rodado trasero', 73.9, 66.9, 1.64, brands.rodados, 'Diferencial, Semiejes, Rodamientos, Retenes, Neumáticos, Llantas, Pesas, Frenos', 74.0, 67.0, { priority: 7, side: 'left', lift: 12, line: 48 })
          ],

          front: [
            point('Filtración y escape', 28.9, 35.5, 1.60, brands.motor, 'Filtro de aire, Filtro de aceite, Filtro de combustible, Prefiltro, Escape, Silenciador, Sensores', 29.0, 35.5, { priority: 1, side: 'right', lift: -14, line: 48 }),
            point('Motor y refrigeración', 34.9, 66.4, 1.72, brands.motor, 'Bloque de motor, Pistones, Camisas, Culata, Inyectores, Turbo, Radiador, Ventilador, Juntas', 35.0, 66.5, { priority: 2, side: 'right', lift: -8, line: 54 }),
            point('Dirección y eje delantero', 28.4, 81.9, 1.64, brands.hidraulica, 'Orbitrol, Rótulas, Barras, Cilindro de dirección, Bujes, Pernos, Terminales, Eje delantero', 28.5, 82.0, { priority: 3, side: 'right', lift: -6, line: 50 }),
            point('Transmisión', 48.4, 83.0, 1.74, brands.transmision, 'Caja, Embrague, Cardanes, Crucetas, Diferenciales, Semiejes, Rodamientos, Retenes', 48.5, 83.0, { priority: 4, side: 'right', lift: 10, line: 52 }),
            point('Sistema hidráulico', 63.7, 57.5, 1.68, brands.hidraulica, 'Bombas, Distribuidores, Mangueras, Cilindros, Filtros, Sellos, Retenes, Acoples', 63.8, 57.5, { priority: 5, side: 'left', lift: 2, line: 50 }),
            point('Cabina y sistema eléctrico', 71.9, 24.0, 1.56, brands.electrico, 'Cabina, Tablero, Sensores, Faros, Relés, Fusibles, Arnés, Batería, Climatización', 72.0, 24.0, { priority: 6, side: 'left', lift: -8, line: 52 }),
            point('Eje y rodado trasero', 79.9, 72.5, 1.60, brands.rodados, 'Neumáticos, Llantas, Mazas, Rodamientos, Semiejes, Diferenciales, Tuercas, Bulones, Frenos', 80.0, 72.5, { priority: 7, side: 'left', lift: 10, line: 48 })
          ],

          rear: [
            point('Cabina y climatización', 50.8, 37.5, 1.56, brands.cabina, 'Cristal trasero, Cerraduras, Burletes, Limpiaparabrisas, Filtros, Ventilación, Asiento', 50.8, 37.5, { priority: 1, side: 'left', lift: -12, line: 50 }),
            point('Luces y sistema eléctrico', 50.8, 51.1, 1.54, brands.electrico, 'Faros, Balizas, Ópticas, Sensores, Relés, Fusibles, Arnés, Conectores', 50.8, 51.1, { priority: 2, side: 'right', lift: 10, line: 48 }),
            point('Hidráulica trasera', 59.2, 70.7, 1.70, brands.hidraulica, 'Distribuidores, Acoples rápidos, Mangueras, Cilindros, Válvulas, Sellos y retenes', 59.2, 70.7, { priority: 3, side: 'left', lift: -12, line: 48 }),
            point('Eje y diferencial trasero', 50.8, 76.6, 1.76, brands.transmision, 'Diferencial, Piñón y corona, Palieres, Rodamientos, Retenes, Carcasa', 50.8, 76.6, { priority: 4, side: 'right', lift: 8, line: 50 }),
            point('Enganche de tres puntos', 41.5, 81.9, 1.66, brands.estructura, 'Brazos inferiores, Tercer punto, Estabilizadores, Rótulas, Pasadores, Tensores', 41.5, 81.9, { priority: 5, side: 'right', lift: -12, line: 44 }),
            point('Toma de fuerza', 50.8, 90.9, 1.70, brands.transmision, 'Eje PTO, Embrague PTO, Retenes, Rodamientos, Horquillas, Engranajes, Protectores', 50.8, 90.9, { priority: 6, side: 'left', lift: 14, line: 44 }),
            point('Frenos y rodado trasero', 79.0, 84.8, 1.60, brands.rodados, 'Frenos, Neumáticos, Llantas, Cámaras, Válvulas, Pesas, Tuercas, Bulones, Mazas', 79.0, 84.8, { priority: 7, side: 'left', lift: 8, line: 46 })
          ]
        };

        /*
          UN PUNTO COMPLEMENTARIO POR PERSPECTIVA
          ---------------------------------------
          Los perfiles existentes ya tenían seis zonas. Se agrega una séptima
          zona general y útil para consulta, evitando subdividir en piezas
          demasiado específicas. En la categoría de repuestos se agregan dos
          porque algunas vistas tenían solamente cinco.
        */
        const supplementalProfiles = {
          '2': {
            top: [point('Chasis superior y contrapeso', 69, 51, 1.56, brands.estructura, 'Chasis superior, Contrapeso, Capot, Puertas, Soportes, Bisagras, Tornillería', 69, 51, { priority: 7, side: 'left', lift: 12, line: 48 })],
            front: [point('Sistema eléctrico y sensores', 69, 38, 1.55, brands.electrico, 'Sensores, Relés, Fusibles, Arnés, Baterías, Iluminación, Conectores, Actuadores', 68, 39, { priority: 7, side: 'left', lift: -14, line: 46 })],
            rear: [point('Capot y accesos de servicio', 58, 48, 1.54, brands.estructura, 'Capot, Puertas de servicio, Cerraduras, Bisagras, Rejillas, Soportes, Tornillería', 58, 48, { priority: 7, side: 'left', lift: -10, line: 46 })]
          },
          '3': {
            top: [point('Ejes, frenos y rodados', 52, 72, 1.64, brands.rodados, 'Ejes, Diferenciales, Frenos, Mazas, Rodamientos, Neumáticos, Llantas, Retenes', 52, 70, { priority: 7, side: 'left', lift: 13, line: 46 })],
            front: [point('Dirección y eje delantero', 44, 74, 1.64, brands.hidraulica, 'Orbitrol, Cilindro de dirección, Barras, Rótulas, Pernos, Bujes, Eje, Mazas', 44, 72, { priority: 7, side: 'right', lift: 12, line: 46 })],
            rear: [point('Frenos y rodados', 72, 72, 1.60, brands.rodados, 'Frenos, Mazas, Rodamientos, Neumáticos, Llantas, Semiejes, Retenes', 70, 70, { priority: 7, side: 'left', lift: 12, line: 46 })]
          },
          '4': {
            top: [point('Sistema eléctrico y baterías', 42, 37, 1.55, brands.electrico, 'Alternador, Arranque, Baterías, Sensores, Relés, Fusibles, Arnés, Iluminación', 42, 38, { priority: 7, side: 'right', lift: -12, line: 46 })],
            front: [point('Filtración y combustible', 63, 54, 1.60, brands.motor, 'Filtros de aire, Aceite y combustible, Bomba, Inyectores, Tanques, Tuberías, Separador de agua', 63, 54, { priority: 7, side: 'left', lift: -8, line: 46 })],
            rear: [point('Tanques y sistema neumático', 30, 53, 1.62, brands.neumatica, 'Tanques, Compresor, Secador, Válvulas, Depósitos, Mangueras, Racores', 31, 53, { priority: 7, side: 'right', lift: -10, line: 46 })]
          },
          '5': {
            top: [point('Sistema eléctrico y sensores', 52, 31, 1.55, brands.electrico, 'Sensores, Computadora, Relés, Fusibles, Arnés, Cámaras, Iluminación, Actuadores', 52, 32, { priority: 7, side: 'right', lift: -12, line: 46 })],
            front: [point('Frenos y sistema eléctrico', 43, 72, 1.60, brands.frenos, 'Frenos, Sensores, Arnés, Relés, Fusibles, Mazas, Rodamientos, Actuadores', 44, 70, { priority: 7, side: 'right', lift: 12, line: 46 })],
            rear: [point('Hidráulica y articulación', 34, 59, 1.68, brands.hidraulica, 'Bombas, Válvulas, Mangueras, Articulación, Cilindros, Pasadores, Bujes, Sellos', 35, 59, { priority: 7, side: 'right', lift: -10, line: 46 })]
          },
          '6': {
            top: [point('Sistema eléctrico y sensores', 52, 34, 1.55, brands.electrico, 'Sensores, Computadora, Relés, Fusibles, Arnés, Cámaras, Iluminación, Actuadores', 52, 35, { priority: 7, side: 'right', lift: -12, line: 46 })],
            front: [point('Sistema hidráulico', 31, 61, 1.66, brands.hidraulica, 'Bombas, Distribuidores, Cilindros, Mangueras, Válvulas, Filtros, Sellos, Acoples', 32, 61, { priority: 7, side: 'right', lift: 10, line: 46 })],
            rear: [point('Transmisión y ejes', 35, 68, 1.70, brands.transmision, 'Caja, Reductores, Cardanes, Diferenciales, Semiejes, Rodamientos, Retenes', 36, 67, { priority: 7, side: 'right', lift: 10, line: 46 })]
          },
          '7': {
            top: [
              point('Sistema eléctrico y arranque', 76, 36, 1.56, brands.electrico, 'Alternador, Arranque, Sensores, Relés, Fusibles, Arnés, Batería, Iluminación', 75, 37, { priority: 6, side: 'left', lift: -12, line: 46 }),
              point('Frenos y rodados', 76, 68, 1.62, brands.frenos, 'Discos, Pastillas, Tambores, Mazas, Rodamientos, Neumáticos, Llantas, Retenes', 74, 67, { priority: 7, side: 'left', lift: 12, line: 46 })
            ],
            front: [point('Dirección y suspensión', 82, 55, 1.62, brands.hidraulica, 'Orbitrol, Rótulas, Barras, Cilindros, Bujes, Pernos, Terminales, Amortiguadores', 80, 55, { priority: 7, side: 'left', lift: -8, line: 46 })],
            rear: [
              point('Motor y refrigeración', 28, 40, 1.68, brands.motor, 'Motor, Radiador, Ventilador, Bombas, Filtros, Correas, Mangueras, Juntas', 29, 41, { priority: 6, side: 'right', lift: -12, line: 46 }),
              point('Hidráulica y válvulas', 71, 52, 1.68, brands.hidraulica, 'Bombas, Distribuidores, Válvulas, Mangueras, Filtros, Sellos, Retenes, Acoples', 69, 52, { priority: 7, side: 'left', lift: -8, line: 46 })
            ]
          }
        };

        Object.entries(supplementalProfiles).forEach(([category, views]) => {
          Object.entries(views).forEach(([view, extraPoints]) => {
            profiles[category] ||= {};
            profiles[category][view] ||= [];
            profiles[category][view].push(...extraPoints);
          });
        });

        /* Exactamente siete zonas en escritorio: suficiente variedad sin ruido. */
        Object.values(profiles).forEach(views => {
          Object.values(views).forEach(points => {
            if (points.length > 7) points.splice(7);
          });
        });

        const appendPoint = (category, view, data, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'mx-hotspot-ncx';
          button.dataset.hotspot = '';
          button.dataset.autoHotspot = 'true';
          button.dataset.autoPriority = 'specific';
          button.dataset.autoVisible = 'false';
          button.dataset.priority = String(data.priority || Math.min(index + 1, 7));
          button.dataset.calloutSide = data.side || 'auto';
          button.dataset.category = String(category);
          button.dataset.view = view;
          button.dataset.title = data.title;
          button.dataset.description = `Consultá repuestos, compatibilidades y alternativas para ${data.title.toLowerCase()}.`;
          button.dataset.components = data.components;
          button.dataset.brands = data.brands;
          button.dataset.x = String(data.x);
          button.dataset.y = String(data.y);
          button.dataset.mobileX = String(data.mobileX ?? data.x);
          button.dataset.mobileY = String(data.mobileY ?? data.y);
          button.dataset.zoom = String(data.zoom || 1.6);
          button.dataset.detail = '';
          button.style.setProperty('--x', `${data.x}%`);
          button.style.setProperty('--y', `${data.y}%`);
          button.style.setProperty('--mobile-x', `${data.mobileX ?? data.x}%`);
          button.style.setProperty('--mobile-y', `${data.mobileY ?? data.y}%`);
          button.style.setProperty('--callout-delay', `${index * 82}ms`);
          button.style.setProperty('--mx-label-lift', `${Number(data.lift || 0)}px`);

          /*
            El largo de la línea y el ancho de la placa se adaptan al texto.
            Los valores base se guardan para recalcularlos sin acumular recortes
            cuando cambia el tamaño de la pantalla o se hace zoom.
          */
          const titleLength = String(data.title || '').trim().length;
          const configuredLine = Number(data.line || 0);
          const adaptiveLine = configuredLine > 0
            ? configuredLine
            : titleLength >= 25
              ? 82
              : titleLength >= 19
                ? 74
                : titleLength >= 14
                  ? 66
                  : 58;

          const adaptiveLabelWidth = titleLength >= 25
            ? 230
            : titleLength >= 19
              ? 208
              : titleLength >= 14
                ? 186
                : 164;

          const adaptiveLabelHeight = titleLength >= 19 ? 36 : 34;

          button.dataset.baseLineLength = String(adaptiveLine);
          button.dataset.baseLabelWidth = String(adaptiveLabelWidth);
          button.dataset.baseLabelHeight = String(adaptiveLabelHeight);
          button.style.setProperty('--mx-hotspot-line-length', `${adaptiveLine}px`);
          button.style.setProperty('--mx-label-max-width', `${adaptiveLabelWidth}px`);
          button.style.setProperty('--mx-label-min-height', `${adaptiveLabelHeight}px`);
          button.setAttribute('aria-label', `Explorar ${data.title}`);

          const callout = document.createElement('span');
          callout.className = 'mx-hotspot-callout-ncx';
          callout.setAttribute('aria-hidden', 'true');

          const line = document.createElement('span');
          line.className = 'mx-hotspot-line-ncx';

          const label = document.createElement('span');
          label.className = 'mx-hotspot-label-ncx';
          label.textContent = data.title;

          const orbit = document.createElement('span');
          orbit.className = 'mx-hotspot-orbit-ncx';
          orbit.setAttribute('aria-hidden', 'true');

          const dot = document.createElement('span');
          dot.className = 'mx-hotspot-dot-ncx';

          callout.append(line, label);
          button.append(callout, orbit, dot);
          this.hotspotPlane.appendChild(button);
        };

        Object.entries(profiles).forEach(([category, views]) => {
          Object.entries(views).forEach(([view, points]) => {
            points.forEach((data, index) => appendPoint(category, view, data, index));
          });
        });
      }

      getActiveImageElement() {
        return this.getActiveSlide()?.querySelector('[data-view-image]') || null;
      }

      swapStageImage(image, source, alt = '', afterChange = null, fallbackSource = '') {
        if (!image || !source) {
          if (typeof afterChange === 'function') afterChange();
          return;
        }

        const currentSource = image.getAttribute('src') || '';
        if (currentSource === source) {
          if (alt) image.alt = alt;
          if (typeof afterChange === 'function') afterChange();
          return;
        }

        image.classList.add('is-view-changing');
        let settled = false;

        const cleanup = () => {
          image.removeEventListener('load', handleLoad);
          image.removeEventListener('error', handleError);
        };

        const finishChange = () => {
          if (settled) return;
          settled = true;
          cleanup();
          image.classList.remove('is-view-changing');
          if (alt) image.alt = alt;
          this.scheduleGeometryUpdate();
          if (typeof afterChange === 'function') afterChange();
        };

        const handleLoad = () => finishChange();
        const handleError = () => {
          cleanup();
          const safeFallback = fallbackSource || currentSource;
          if (safeFallback && safeFallback !== source) {
            image.addEventListener('load', finishChange, { once: true });
            image.addEventListener('error', finishChange, { once: true });
            image.src = safeFallback;
            return;
          }
          finishChange();
        };

        image.addEventListener('load', handleLoad, { once: true });
        image.addEventListener('error', handleError, { once: true });
        image.src = source;
      }

      refreshStageImageForMode(afterChange = null) {
        const slide = this.getActiveSlide();
        const images = [
          slide?.querySelector('[data-real-image]'),
          slide?.querySelector('[data-view-image]')
        ].filter(Boolean);

        if (!images.length) {
          if (typeof afterChange === 'function') afterChange();
          return;
        }

        let pending = images.filter(image => !image.complete || !image.naturalWidth).length;
        if (!pending) {
          window.requestAnimationFrame(() => {
            this.scheduleGeometryUpdate();
            if (typeof afterChange === 'function') afterChange();
          });
          return;
        }

        let finished = false;
        const finish = () => {
          if (finished) return;
          pending -= 1;
          if (pending > 0) return;
          finished = true;
          this.scheduleGeometryUpdate();
          if (typeof afterChange === 'function') afterChange();
        };

        images.forEach(image => {
          if (image.complete && image.naturalWidth) return;
          image.addEventListener('load', finish, { once: true });
          image.addEventListener('error', finish, { once: true });
        });
      }

      syncStageViewState() {
        if (!this.stage) return;
        this.stage.classList.remove('is-view-top', 'is-view-front', 'is-view-rear');
        this.stage.classList.add(`is-view-${this.activeView || 'front'}`);
      }

      isHotspotMatch(hotspot) {
        if (!hotspot) return false;
        if (hotspot.dataset.autoHotspot === 'true') {
          return hotspot.dataset.autoVisible === 'true';
        }
        if (hotspot.dataset.profileSuppressed === 'true') return false;
        const categoryMatch = (hotspot.dataset.category || '1') === String(this.activeCategory || '1');
        const hotspotView = hotspot.dataset.view || 'front';
        const viewMatch = hotspotView === 'all' || hotspotView === String(this.activeView || 'front');
        return categoryMatch && viewMatch;
      }

      updateVisibleHotspots() {
        const activeView = String(this.activeView || 'front');
        const activeCategory = String(this.activeCategory || '1');
        const maxFallbackDots = 6;

        const autoHotspots = this.hotspots.filter(hotspot => hotspot.dataset.autoHotspot === 'true');
        const customMatches = this.hotspots.filter(hotspot => {
          if (hotspot.dataset.autoHotspot === 'true') return false;
          const categoryMatch = (hotspot.dataset.category || '1') === activeCategory;
          const view = hotspot.dataset.view || 'front';
          return categoryMatch && (view === 'all' || view === activeView);
        });

        const specificPool = autoHotspots.filter(hotspot =>
          (hotspot.dataset.category || '*') === activeCategory &&
          (hotspot.dataset.view || 'front') === activeView &&
          hotspot.dataset.autoPriority === 'specific'
        );

        const fallbackPool = autoHotspots.filter(hotspot =>
          (hotspot.dataset.category || '*') === '*' &&
          (hotspot.dataset.view || 'front') === activeView
        );

        autoHotspots.forEach(hotspot => {
          hotspot.dataset.autoVisible = 'false';
        });

        /*
          Cuando existe un perfil calculado para la fotografía activa, ese perfil
          reemplaza por completo a los dots antiguos. Así no se duplican zonas ni
          aparecen puntos pertenecientes a otro ángulo de la máquina.
        */
        const hasImageProfile = specificPool.length > 0;
        customMatches.forEach((hotspot, index) => {
          hotspot.dataset.profileSuppressed = hasImageProfile || index >= maxFallbackDots ? 'true' : 'false';
        });

        /* Limpiar la supresión de dots personalizados que no pertenecen a la vista activa. */
        this.hotspots.forEach(hotspot => {
          if (hotspot.dataset.autoHotspot === 'true') return;
          if (!customMatches.includes(hotspot)) hotspot.dataset.profileSuppressed = 'true';
        });

        const mobileView = window.matchMedia('(max-width: 820px)').matches;
        /*
          Construcción: priorizamos precisión y lectura limpia.
          Cinco zonas mecánicas por perspectiva como base premium.
          Otras familias conservan su límite anterior.
        */
        const constructionProfile = this.familyKey === 'industrial'
          && this.hotspotPlane?.dataset?.constructionLibraryReady === 'true';
        const maxProfileDots = constructionProfile ? (mobileView ? 5 : 6) : (mobileView ? 5 : 7);
        const byPriority = (a, b) => Number(a.dataset.priority || 99) - Number(b.dataset.priority || 99);

        let selectedAutoHotspots = [];
        if (hasImageProfile) {
          selectedAutoHotspots = [...specificPool].sort(byPriority).slice(0, maxProfileDots);
        } else if (!customMatches.length) {
          selectedAutoHotspots = [...fallbackPool].sort(byPriority).slice(0, mobileView ? 5 : maxFallbackDots);
        }

        selectedAutoHotspots.forEach(hotspot => {
          hotspot.dataset.autoVisible = 'true';
        });

        this.hotspots.forEach(hotspot => {
          const visible = this.isHotspotMatch(hotspot);
          hotspot.classList.remove('is-active', 'is-callout-ready', 'is-cropped-out');
          hotspot.classList.toggle('is-visible', visible);
          hotspot.style.display = visible ? 'grid' : 'none';
          hotspot.style.placeItems = visible ? 'center' : '';
          hotspot.style.visibility = visible ? 'visible' : '';
          hotspot.style.pointerEvents = visible ? '' : 'none';
        });
      }

      getViewTransitionVisualTargets() {
        const slide = this.getActiveSlide();
        if (!slide) return [];

        const layers = [...slide.querySelectorAll('.mx-image-layer-ncx')];
        if (layers.length) return layers;

        const images = [...slide.querySelectorAll('.mx-image-ncx')];
        return images.length ? images : [slide];
      }

      getViewTransitionMotion(fromView = 'front', toView = 'front') {
        const from = ['top', 'front', 'rear'].includes(fromView) ? fromView : 'front';
        const to = ['top', 'front', 'rear'].includes(toView) ? toView : 'front';

        /*
          Movimiento corto y controlado: conserva profundidad sin deformar la
          maquinaria. La dirección acompaña el cambio real de perspectiva.
        */
        if (from === to) {
          return {
            out: { rx: 0, ry: -3, tx: -.8, ty: 0, scale: 1.014 },
            incoming: { rx: 0, ry: 3, tx: .8, ty: 0, scale: 1.014 }
          };
        }

        if (from === 'front' && to === 'top') {
          return {
            out: { rx: 9, ry: 0, tx: 0, ty: 1.2, scale: 1.028 },
            incoming: { rx: -10, ry: 0, tx: 0, ty: -1.6, scale: 1.032 }
          };
        }

        if (from === 'top' && to === 'front') {
          return {
            out: { rx: -9, ry: 0, tx: 0, ty: -1.2, scale: 1.028 },
            incoming: { rx: 10, ry: 0, tx: 0, ty: 1.6, scale: 1.032 }
          };
        }

        if (from === 'front' && to === 'rear') {
          return {
            out: { rx: 0, ry: -12, tx: -1.8, ty: 0, scale: 1.030 },
            incoming: { rx: 0, ry: 13, tx: 2.0, ty: 0, scale: 1.034 }
          };
        }

        if (from === 'rear' && to === 'front') {
          return {
            out: { rx: 0, ry: 12, tx: 1.8, ty: 0, scale: 1.030 },
            incoming: { rx: 0, ry: -13, tx: -2.0, ty: 0, scale: 1.034 }
          };
        }

        if (from === 'top' && to === 'rear') {
          return {
            out: { rx: -7, ry: -9, tx: -1.4, ty: -.8, scale: 1.031 },
            incoming: { rx: 8, ry: 10, tx: 1.6, ty: 1.0, scale: 1.035 }
          };
        }

        return {
          out: { rx: 7, ry: 9, tx: 1.4, ty: .8, scale: 1.031 },
          incoming: { rx: -8, ry: -10, tx: -1.6, ty: -1.0, scale: 1.035 }
        };
      }

      buildViewTransform({ rx = 0, ry = 0, tx = 0, ty = 0, scale = 1 } = {}) {
        return `perspective(1500px) translate3d(${tx}%, ${ty}%, 0) rotateX(${rx}deg) rotateY(${ry}deg) scale(${scale})`;
      }

      animateViewElements(elements, keyframes, options) {
        const validElements = elements.filter(Boolean);
        if (!validElements.length || typeof validElements[0]?.animate !== 'function') {
          return Promise.resolve();
        }

        const animations = validElements.map((element, index) => {
          element.style.willChange = 'transform, opacity, clip-path';
          const animation = element.animate(keyframes, {
            ...options,
            delay: Number(options.delay || 0) + index * 14
          });
          return animation;
        });

        this.viewTransitionAnimations = [
          ...(this.viewTransitionAnimations || []),
          ...animations
        ];

        return Promise.all(animations.map(animation => animation.finished.catch(() => undefined)));
      }

      animateViewTransitionAtmosphere() {
        const animations = [];

        if (this.viewTransitionDepth?.animate) {
          animations.push(this.viewTransitionDepth.animate([
            { opacity: 0, transform: 'scale(.985)' },
            { opacity: .62, transform: 'scale(1)', offset: .34 },
            { opacity: .36, transform: 'scale(1.012)', offset: .66 },
            { opacity: 0, transform: 'scale(1.02)' }
          ], {
            duration: 760,
            easing: 'cubic-bezier(.22,.61,.36,1)',
            fill: 'both'
          }));
        }

        if (this.viewTransitionSheen?.animate) {
          animations.push(this.viewTransitionSheen.animate([
            { opacity: 0, transform: 'translate3d(-120%,0,0) skewX(-11deg)' },
            { opacity: .10, offset: .12 },
            { opacity: .62, transform: 'translate3d(-8%,0,0) skewX(-11deg)', offset: .46 },
            { opacity: .20, offset: .70 },
            { opacity: 0, transform: 'translate3d(120%,0,0) skewX(-11deg)' }
          ], {
            duration: 760,
            easing: 'cubic-bezier(.2,.72,.2,1)',
            fill: 'both'
          }));
        }

        this.viewTransitionAnimations = [
          ...(this.viewTransitionAnimations || []),
          ...animations
        ];
      }

      clearViewTransitionAnimations() {
        this.viewTransitionAnimations?.forEach(animation => {
          try { animation.cancel(); } catch (_) {}
        });
        this.viewTransitionAnimations = [];

        this.querySelectorAll('.mx-image-layer-ncx, .mx-image-ncx').forEach(element => {
          element.style.removeProperty('will-change');
          element.style.removeProperty('opacity');
          element.style.removeProperty('transform');
          element.style.removeProperty('clip-path');
          element.style.removeProperty('transform-origin');
          element.style.removeProperty('filter');
        });

        this.viewTransitionSheen?.style.removeProperty('opacity');
        this.viewTransitionDepth?.style.removeProperty('opacity');
      }

      runViewTransition(callback, meta = {}) {
        if (typeof callback !== 'function') return Promise.resolve();
        if (!this.stage || this.reduceMotion) {
          return Promise.resolve(callback());
        }

        const fromView = meta.fromView || this.activeView || 'front';
        const toView = meta.toView || fromView;
        const motion = this.getViewTransitionMotion(fromView, toView);
        const outgoingTargets = this.getViewTransitionVisualTargets();

        this.clearViewTransitionAnimations();
        this.stage.dataset.viewFrom = fromView;
        this.stage.dataset.viewTo = toView;
        this.stage.classList.add('is-view-transitioning', 'is-view-transitioning-3d');
        this.hotspotPlane?.classList.add('is-view-transitioning');
        this.setAttribute('aria-busy', 'true');
        this.animateViewTransitionAtmosphere();

        const outgoingKeyframes = [
          {
            opacity: 1,
            transform: this.buildViewTransform(),
            clipPath: 'inset(0% 0% 0% 0% round 0px)',
            filter: 'blur(0px) brightness(1) saturate(1)',
            offset: 0
          },
          {
            opacity: .94,
            transform: this.buildViewTransform({
              rx: motion.out.rx * .28,
              ry: motion.out.ry * .28,
              tx: motion.out.tx * .24,
              ty: motion.out.ty * .24,
              scale: 1.010
            }),
            clipPath: 'inset(.15% .25% .15% .25% round 8px)',
            filter: 'blur(.35px) brightness(.98) saturate(.98)',
            offset: .42
          },
          {
            opacity: .20,
            transform: this.buildViewTransform(motion.out),
            clipPath: 'inset(1.15% 1.55% 1.15% 1.55% round 14px)',
            filter: 'blur(3.6px) brightness(.88) saturate(.90)',
            offset: 1
          }
        ];

        return this.animateViewElements(outgoingTargets, outgoingKeyframes, {
          duration: 280,
          easing: 'cubic-bezier(.4,0,.2,1)',
          fill: 'forwards'
        })
          .then(() => Promise.resolve(callback()))
          .then(() => new Promise(resolve => {
            window.requestAnimationFrame(() => window.requestAnimationFrame(resolve));
          }))
          .then(() => {
            const incomingTargets = this.getViewTransitionVisualTargets();
            const incomingKeyframes = [
              {
                opacity: .18,
                transform: this.buildViewTransform(motion.incoming),
                clipPath: 'inset(1.15% 1.55% 1.15% 1.55% round 14px)',
                filter: 'blur(3.8px) brightness(.88) saturate(.90)',
                offset: 0
              },
              {
                opacity: .90,
                transform: this.buildViewTransform({
                  rx: motion.incoming.rx * .24,
                  ry: motion.incoming.ry * .24,
                  tx: motion.incoming.tx * .20,
                  ty: motion.incoming.ty * .20,
                  scale: 1.009
                }),
                clipPath: 'inset(.12% .22% .12% .22% round 7px)',
                filter: 'blur(.3px) brightness(.99) saturate(.99)',
                offset: .62
              },
              {
                opacity: 1,
                transform: this.buildViewTransform(),
                clipPath: 'inset(0% 0% 0% 0% round 0px)',
                filter: 'blur(0px) brightness(1) saturate(1)',
                offset: 1
              }
            ];

            return this.animateViewElements(incomingTargets, incomingKeyframes, {
              duration: 430,
              easing: 'cubic-bezier(.16,1,.3,1)',
              fill: 'forwards'
            });
          })
          .then(() => {
            this.positionHotspots();
            if (this.graphicMode) this.replayHotspotCallouts(this.activeCategory);
          })
          .finally(() => {
            this.clearViewTransitionAnimations();
            this.stage?.classList.remove('is-view-transitioning', 'is-view-transitioning-3d');
            this.hotspotPlane?.classList.remove('is-view-transitioning');
            this.stage?.removeAttribute('data-view-from');
            this.stage?.removeAttribute('data-view-to');
            this.removeAttribute('aria-busy');
          });
      }

      applyRestingView() {
        if (!this.viewport || !this.stage) return;

        const width = this.viewport.clientWidth;
        const height = this.viewport.clientHeight;
        if (!width || !height) return;

        const scale = 1;
        const panX = 0;
        const panY = 0;

        this.viewport.style.setProperty('--mx-focus-scale', scale.toFixed(3));
        this.viewport.style.setProperty('--mx-inverse-scale', (1 / scale).toFixed(5));
        this.viewport.style.setProperty('--mx-pan-x', `${panX.toFixed(2)}px`);
        this.viewport.style.setProperty('--mx-pan-y', `${panY.toFixed(2)}px`);
        this.stage.classList.remove('is-zoomed');
      }

      getDetailPreviewSources(hotspot = this.activeHotspot || this.lastSelectedHotspot) {
        const slide = this.getActiveSlide();
        const realImage = slide?.querySelector('[data-real-image]');
        const graphicImage = slide?.querySelector('[data-view-image]');
        const dedicatedDetail = hotspot?.dataset.detail || '';

        const graphicSource = graphicImage?.currentSrc || graphicImage?.src || '';

        return {
          realSource: realImage?.currentSrc || realImage?.src || this.defaultDetailSource || '',
          graphicSource,
          /*
            Para que el detalle coincida exactamente con la fotografía, el overlay
            usa siempre la vista técnica completa de la vista activa. Las imágenes
            de detalle independientes no se usan aquí porque pueden tener otro
            tamaño, perspectiva o encuadre.
          */
          technicalSource: graphicSource,
          dedicatedDetail: false,
          hotspot
        };
      }

      setPreviewImageSource(image, source, alt = '', instant = false) {
        if (!image || !source) return;

        image.alt = alt || '';
        const current = image.currentSrc || image.getAttribute('src') || '';
        if (current === source) return;

        if (!instant) this.detailMedia?.classList.add('is-media-changing');
        let finished = false;
        const finish = () => {
          if (finished) return;
          finished = true;
          window.requestAnimationFrame(() => this.detailMedia?.classList.remove('is-media-changing'));
        };

        image.addEventListener('load', finish, { once: true });
        image.addEventListener('error', finish, { once: true });
        image.src = source;
        window.setTimeout(finish, instant ? 0 : 260);
      }

      clearTechnicalPreview({ clearSource = false } = {}) {
        this.detailMedia?.classList.remove('has-technical-zone', 'is-media-changing');
        this.detailZoneOverlay?.classList.remove('is-active');
        if (clearSource && this.detailZoneOverlay) this.detailZoneOverlay.removeAttribute('src');
        if (this.detailModeLabel) this.detailModeLabel.textContent = 'IMAGEN REAL';
        if (this.infoSyncText) this.infoSyncText.textContent = 'IMAGEN REAL SINCRONIZADA';
      }

      syncDetailMediaToMode(options = {}) {
        if (!this.detailImage) return;

        const hotspot = options.hotspot || this.activeHotspot || this.lastSelectedHotspot || null;
        const { realSource, technicalSource, dedicatedDetail } = this.getDetailPreviewSources(hotspot);
        const instant = Boolean(options.instant);
        const mobileView = window.matchMedia('(max-width: 820px)').matches;
        const x = this.clamp(Number(mobileView
          ? (hotspot?.dataset.mobileX || hotspot?.dataset.x || 50)
          : (hotspot?.dataset.x || 50)), 0, 100);
        const y = this.clamp(Number(mobileView
          ? (hotspot?.dataset.mobileY || hotspot?.dataset.y || 50)
          : (hotspot?.dataset.y || 50)), 0, 100);

        /* La base del preview SIEMPRE es la fotografía real de la vista activa. */
        this.detailImage.style.objectPosition = 'center';
        this.detailImage.style.transformOrigin = 'center';
        this.detailImage.style.setProperty('--mx-detail-scale', '1.02');
        this.detailImage.classList.add('is-active');
        this.setPreviewImageSource(
          this.detailImage,
          realSource,
          hotspot?.dataset.title || this.zone?.textContent || '',
          instant
        );

        /*
          La fotografía permanece completa. El gráfico se muestra como una
          ventana técnica independiente anclada al dot. Así no dependemos de
          que ambas imágenes tengan exactamente el mismo encuadre o tamaño.
          Si el hotspot tiene una imagen de detalle propia, se usa primero.
        */
        const showTechnicalZone = Boolean(hotspot && technicalSource && this.detailZoneOverlay);
        this.detailMedia?.classList.toggle('has-technical-zone', showTechnicalZone);
        this.detailMedia?.classList.add('is-real-source');
        this.detailMedia?.classList.remove('is-graphic-source');

        if (showTechnicalZone) {
          const hotspotZoom = this.clamp(Number(hotspot?.dataset.zoom || 1.5), 1, 2.4);
          const zoneWidth = mobileView
            ? 38
            : this.clamp(28 + (hotspotZoom - 1.4) * 4.5, 27, 34);
          const zoneHeight = mobileView
            ? 48
            : this.clamp(39 + (hotspotZoom - 1.4) * 5.5, 38, 47);

          /* Evita que el marco técnico quede cortado contra los bordes. */
          const safeX = this.clamp(x, zoneWidth / 2 + 2, 100 - zoneWidth / 2 - 2);
          const safeY = this.clamp(y, zoneHeight / 2 + 2, 100 - zoneHeight / 2 - 2);
          const zoneLeft = safeX - zoneWidth / 2;
          const zoneTop = safeY - zoneHeight / 2;
          const zoneRight = 100 - zoneLeft - zoneWidth;
          const zoneBottom = 100 - zoneTop - zoneHeight;

          this.detailMedia.style.setProperty('--mx-zone-x', `${safeX}%`);
          this.detailMedia.style.setProperty('--mx-zone-y', `${safeY}%`);
          this.detailMedia.style.setProperty('--mx-zone-radius-x', `${zoneWidth / 2}%`);
          this.detailMedia.style.setProperty('--mx-zone-radius-y', `${zoneHeight / 2}%`);
          this.detailMedia.style.setProperty('--mx-zone-width', `${zoneWidth}%`);
          this.detailMedia.style.setProperty('--mx-zone-height', `${zoneHeight}%`);
          this.detailMedia.style.setProperty('--mx-zone-left', `${zoneLeft}%`);
          this.detailMedia.style.setProperty('--mx-zone-top', `${zoneTop}%`);
          this.detailMedia.style.setProperty('--mx-zone-right', `${zoneRight}%`);
          this.detailMedia.style.setProperty('--mx-zone-bottom', `${zoneBottom}%`);

          /*
            La capa gráfica ocupa exactamente el mismo canvas que la fotografía.
            CSS revela únicamente el área del hotspot mediante clip-path, por eso
            motor, frenos, ruedas, etc. quedan al mismo nivel que la imagen real.
          */
          this.detailZoneOverlay.style.objectFit = 'cover';
          this.detailZoneOverlay.style.objectPosition = 'center';
          this.detailZoneOverlay.style.transformOrigin = 'center';
          this.detailZoneOverlay.classList.add('is-active');
          this.setPreviewImageSource(
            this.detailZoneOverlay,
            technicalSource,
            '',
            instant
          );

          if (this.detailModeLabel) this.detailModeLabel.textContent = 'DETALLE TÉCNICO DE LA ZONA';
          if (this.infoSyncText) this.infoSyncText.textContent = 'ZONA TÉCNICA SINCRONIZADA';
        } else {
          this.clearTechnicalPreview();
        }
      }

      setGraphicMode(enabled, options = {}) {
        const {
          preserveFocus = false,
          silent = false,
          instant = false,
          afterChange = null
        } = options;

        const targetMode = Boolean(enabled);

        /*
          Antes de ocultar el plano, asegurarse de que la fotografía real de la
          vista actual ya esté cargada. Esto evita que superior/trasera sigan
          mostrando el gráfico por usar una fuente antigua o de respaldo.
        */
        if (!targetMode && options._realImagePrepared !== true) {
          this.ensureActiveRealImage(() => {
            this.setGraphicMode(false, {
              ...options,
              _realImagePrepared: true
            });
          });
          return;
        }

        if (!targetMode) {
          this.activeHotspot = null;
          this.lastSelectedHotspot = null;
          this.hotspots?.forEach(hotspot => hotspot.classList.remove('is-active'));
          this.clearTechnicalPreview({ clearSource: true });
        }

        if (this.modeTransitioning && !instant) return;
        if (targetMode === this.graphicMode && !instant) {
          if (typeof afterChange === 'function') afterChange();
          return;
        }

        const updateControls = () => {
          if (this.modeToggle) {
            this.modeToggle.dataset.mode = this.graphicMode ? 'graphic' : 'image';
          }

          if (this.modeToggleLabel) {
            this.modeToggleLabel.textContent = this.graphicMode ? 'Imagen real' : 'Modo gráfico';
            if (this.modeToggleEyebrow) this.modeToggleEyebrow.textContent = 'VER MODO';
          }

          if (this.modeToggle) {
            this.modeToggle.setAttribute('aria-pressed', this.graphicMode ? 'true' : 'false');
          }

          /*
            El aviso de Modo gráfico es un control permanente: nunca desaparece.
            En modo gráfico cambia de contenido y CSS lo compacta para no tapar el equipo.
          */
          this.classList.remove('is-mode-popup-dismissed');

          if (this.modePopupTitle) {
            this.modePopupTitle.textContent = this.graphicMode ? 'Modo gráfico activo' : 'Modo gráfico';
          }

          if (this.modePopupCopy) {
            this.modePopupCopy.textContent = this.graphicMode
              ? 'Zonas interactivas activadas. Tocá un dot para explorar el equipo.'
              : 'Mostrá las zonas interactivas y explorá los sistemas del equipo.';
          }

          if (this.modePopupActionLabel) {
            this.modePopupActionLabel.textContent = this.graphicMode
              ? 'Volver a imagen real'
              : 'Activar modo gráfico';
          }

          if (this.activateGraphicButton) {
            this.activateGraphicButton.setAttribute('aria-pressed', this.graphicMode ? 'true' : 'false');
          }

          this.syncDetailMediaToMode();
        };

        const finish = () => {
          if (this.graphicMode) {
            this.classList.remove('is-image-mode');
          } else {
            this.classList.add('is-image-mode');
          }

          this.stage?.classList.remove(
            'is-mode-transitioning',
            'is-revealing-graphic',
            'is-revealing-image',
            'is-technical-visible',
            'is-dots-visible',
            'is-technical-hidden'
          );

          const activeSlide = this.getActiveSlide();
          const graphicImage = activeSlide?.querySelector('[data-view-image]');
          if (graphicImage) {
            graphicImage.style.removeProperty('animation');
            graphicImage.style.removeProperty('clip-path');
            graphicImage.style.removeProperty('-webkit-clip-path');
            graphicImage.style.removeProperty('opacity');
            graphicImage.style.removeProperty('visibility');
          }

          this.modeTransitioning = false;
          this.scheduleGeometryUpdate();
          this.syncDetailMediaToMode({ instant: true });

          if (this.graphicMode && preserveFocus && this.activeHotspot) {
            this.zoomToHotspot(this.activeHotspot);
          } else {
            this.applyRestingView();
            if (this.graphicMode && !silent) this.replayHotspotCallouts(this.activeCategory);
          }

          if (typeof afterChange === 'function') afterChange();
        };

        if (instant || this.reduceMotion || !this.stage) {
          this.graphicMode = targetMode;
          this.classList.toggle('is-image-mode', !this.graphicMode);
          updateControls();
          if (!this.graphicMode) this.resetZoom(true);
          this.refreshStageImageForMode(finish);
          return;
        }

        this.modeTransitioning = true;
        this.stage.classList.add('is-mode-transitioning');

        this.refreshStageImageForMode(() => {
          if (targetMode) {
            this.graphicMode = true;
            updateControls();
            this.stage.classList.remove(
              'is-revealing-image',
              'is-technical-hidden',
              'is-technical-visible',
              'is-dots-visible'
            );
            this.stage.classList.add('is-revealing-graphic');
            this.updateVisibleHotspots();

            window.setTimeout(() => {
              this.stage?.classList.add('is-technical-visible');
            }, 620);

            window.setTimeout(() => {
              this.stage?.classList.add('is-dots-visible');
            }, 1180);

            window.setTimeout(finish, 1520);
          } else {
            this.graphicMode = false;
            updateControls();
            this.resetZoom(true);
            this.stage.classList.remove(
              'is-revealing-graphic',
              'is-technical-visible',
              'is-dots-visible',
              'is-technical-hidden'
            );
            this.stage.classList.add('is-revealing-image');

            window.setTimeout(() => {
              this.stage?.classList.add('is-technical-hidden');
            }, 520);

            window.setTimeout(finish, 1100);
          }
        });
      }

      normalizeRequestedView(value) {
        const normalized = this.slugify(value || 'front');
        const aliases = {
          top: 'top',
          superior: 'top',
          arriba: 'top',
          front: 'front',
          frontal: 'front',
          frente: 'front',
          rear: 'rear',
          trasera: 'rear',
          posterior: 'rear'
        };
        return aliases[normalized] || 'front';
      }

      getCategoryButtonFromRoute(value) {
        const requested = this.slugify(value || '');
        if (!requested) return null;

        const aliases = {
          tractor: 'tractores',
          excavadora: 'excavadoras',
          retroexcavadora: 'retroexcavadoras',
          camion: 'camiones',
          forestal: 'maquinaria-forestal',
          agricola: 'maquinaria-agricola',
          repuestos: 'repuestos-y-componentes',
          componentes: 'repuestos-y-componentes',
          'repuestos-componentes': 'repuestos-y-componentes'
        };
        const target = aliases[requested] || requested;

        return this.categoryButtons.find(button => {
          const candidates = [
            button.dataset.category,
            button.dataset.categorySlug,
            button.dataset.categoryName,
            button.querySelector('.mx-category-name-ncx')?.textContent,
            button.textContent
          ]
            .map(candidate => this.slugify(candidate || ''))
            .filter(Boolean);

          return candidates.includes(target) || candidates.includes(requested);
        }) || null;
      }

      initializeFromUrl(options = {}) {
        const { focusExplorer = false } = options;

        let url;
        try {
          url = new URL(window.location.href);
        } catch (_) {
          return false;
        }

        const requestedCategory =
          url.searchParams.get('categoria') ||
          url.searchParams.get('category') ||
          '';
        if (!requestedCategory) return false;

        const button = this.getCategoryButtonFromRoute(requestedCategory);
        if (!button) return false;

        const requestedView = this.normalizeRequestedView(
          url.searchParams.get('vista') || url.searchParams.get('view') || 'front'
        );
        const category = String(button.dataset.category || '1');
        const name = button.dataset.categoryName
          || button.querySelector('.mx-category-name-ncx')?.textContent?.trim()
          || button.textContent.trim();

        this.viewByCategory[category] = requestedView;
        this.setCategory(category, name, true, false);

        if (focusExplorer && !window.Shopify?.designMode) {
          window.setTimeout(() => this.focusExplorerFromRoute(), 90);
        }

        return true;
      }

      focusExplorerFromRoute() {
        const target = this.querySelector('.mx-grid-ncx') || this.stage || this;
        if (!target) return;

        const headerOffset = window.matchMedia('(max-width: 820px)').matches ? 74 : 92;
        const top = Math.max(
          0,
          target.getBoundingClientRect().top + window.scrollY - headerOffset
        );

        window.scrollTo({ top, behavior: 'auto' });
      }

      setCategory(index, name, collapseMenu = true, updateUrl = true) {
        this.activeCategory = String(index || '1');
        this.activeHotspot = null;
        this.lastSelectedHotspot = null;

        if (collapseMenu) {
          this.classList.add('is-category-selected');
          this.classList.remove('is-category-menu-open');
        }

        this.categoryButtons.forEach(btn => {
          const active = btn.dataset.category === this.activeCategory;
          btn.classList.toggle('is-active', active);
          btn.closest('.mx-category-item-ncx')?.classList.toggle('is-active-item', active);
          btn.setAttribute('aria-pressed', active ? 'true' : 'false');
          btn.setAttribute('aria-expanded', 'false');
        });

        this.slides.forEach(slide => {
          slide.classList.toggle('is-active', slide.dataset.slide === this.activeCategory);
        });

        this.viewSets.forEach(set => {
          set.classList.toggle('is-active', set.dataset.viewSet === this.activeCategory);
        });

        this.hotspots.forEach(hotspot => {
          hotspot.classList.remove('is-active', 'is-callout-ready', 'is-visible');
          hotspot.style.display = 'none';
          hotspot.style.placeItems = '';
        });

        if (this.activeCategoryText) this.activeCategoryText.textContent = name || '';

        this.selectedInterest = '';
        this.selectedBrand = '';
        this.components?.querySelectorAll('[data-interest]').forEach(item => item.classList.remove('is-active'));
        this.brands?.querySelectorAll('[data-brand]').forEach(item => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });

        const preferredView = this.viewByCategory[this.activeCategory] || 'front';
        this.setView(preferredView, this.activeCategory, false, false);
        this.refreshStageImageForMode(() => {
          this.scheduleGeometryUpdate();
          this.applyRestingView();
          if (this.graphicMode) this.replayHotspotCallouts(this.activeCategory);
        });
        this.setWhatsApp();

        if (updateUrl) {
          try {
            const url = new URL(window.location.href);
            url.searchParams.set('categoria', this.slugify(name));
            url.searchParams.set('vista', preferredView);
            window.history.replaceState({}, '', url);
          } catch (_) {}
        }
      }

      setView(view, category = this.activeCategory, updateUrl = true, animate = true) {
        const normalizedCategory = String(category || this.activeCategory || '1');
        const normalizedView = ['top', 'front', 'rear'].includes(view) ? view : 'front';

        if (normalizedCategory !== String(this.activeCategory || '1')) {
          return Promise.resolve();
        }

        const targetButton = this.getViewButton(normalizedCategory, normalizedView);
        if (!targetButton) {
          console.warn('[NC GROUP] Vista no encontrada:', normalizedCategory, normalizedView);
          return Promise.resolve();
        }

        const previousView = String(this.activeView || 'front');
        const shouldAnimate = Boolean(
          animate &&
          !this.reduceMotion &&
          this.stage &&
          normalizedView !== previousView
        );

        if (shouldAnimate && this.viewTransitioning) {
          this.queuedViewRequest = {
            view: normalizedView,
            category: normalizedCategory,
            updateUrl
          };
          return Promise.resolve();
        }

        const requestId = ++this.viewImageRequestId;
        const emptyRealImage =
          'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
        const libraryGraphic = this.normalizeImageSource(
          this.graphicViewImageCandidates?.[normalizedCategory]?.[normalizedView]?.[0] || ''
        );
        const libraryReal = this.normalizeImageSource(
          this.realViewImageCandidates?.[normalizedCategory]?.[normalizedView]?.[0] || ''
        );
        const configuredGraphic = this.normalizeImageSource(
          targetButton.dataset.configuredGraphicImage ||
          targetButton.dataset.image ||
          ''
        );
        const configuredReal = this.normalizeImageSource(
          targetButton.dataset.configuredRealImage ||
          targetButton.dataset.realImage ||
          ''
        );

        /*
          Cambio inmediato: usar la fuente exacta de la perspectiva elegida.
          La validación de Shopify se realiza después y no bloquea el click.
        */
        const immediateGraphic = configuredGraphic || libraryGraphic;
        const immediateReal = configuredReal || libraryReal || emptyRealImage;

        const updateUrlState = () => {
          if (!updateUrl) return;
          try {
            const url = new URL(window.location.href);
            url.searchParams.set('vista', normalizedView);
            window.history.replaceState({}, '', url);
          } catch (_) {}
        };

        const swapCurrentImages = (graphicSource, realSource, { updateState = true } = {}) => {
          return new Promise(resolveSwitch => {
            if (updateState) {
              this.activeView = normalizedView;
              this.viewByCategory[normalizedCategory] = normalizedView;
              this.activeHotspot = null;
              this.lastSelectedHotspot = null;

              this.viewButtons.forEach(button => {
                const active =
                  String(button.dataset.category || '') === normalizedCategory &&
                  String(button.dataset.view || 'front') === normalizedView;
                button.classList.toggle('is-active', active);
                button.setAttribute('aria-pressed', active ? 'true' : 'false');
              });

              this.syncStageViewState();
              this.updateVisibleHotspots();
              this.resetZoom(true);

              if (this.activeViewText) {
                this.activeViewText.textContent =
                  targetButton.dataset.viewLabel || normalizedView;
              }
            }

            const activeSlide = this.getActiveSlide();
            const graphicImage = activeSlide?.querySelector('[data-view-image]');
            const realImage = activeSlide?.querySelector('[data-real-image]');
            const alt = targetButton.dataset.alt || '';
            const tasks = [];

            const queueSwap = (image, source, datasetKey) => {
              const normalizedSource = this.normalizeImageSource(source);
              if (!image || !normalizedSource) return;

              const currentSource = this.normalizeImageSource(
                image.currentSrc || image.getAttribute('src') || ''
              );
              image.dataset[datasetKey] = normalizedSource;

              if (currentSource === normalizedSource) {
                if (alt) image.alt = alt;
                return;
              }

              tasks.push(new Promise(done => {
                this.swapStageImage(
                  image,
                  normalizedSource,
                  alt,
                  done,
                  currentSource
                );
              }));
            };

            queueSwap(graphicImage, graphicSource, 'graphicSrc');
            queueSwap(realImage, realSource || emptyRealImage, 'realSrc');

            const finish = () => {
              if (
                requestId !== this.viewImageRequestId ||
                String(this.activeCategory || '') !== normalizedCategory ||
                String(this.activeView || '') !== normalizedView
              ) {
                resolveSwitch();
                return;
              }

              this.positionHotspots();
              this.applyRestingView();
              this.scheduleGeometryUpdate();
              this.detailMedia?.classList.add('is-view-synced');
              this.syncDetailMediaToMode({ instant: true });
              window.setTimeout(
                () => this.detailMedia?.classList.remove('is-view-synced'),
                620
              );
              if (this.graphicMode) this.replayHotspotCallouts(this.activeCategory);
              resolveSwitch();
            };

            if (tasks.length) {
              Promise.allSettled(tasks).then(finish);
            } else {
              finish();
            }
          });
        };

        const resolveExactSourcesInBackground = () => {
          return Promise.all([
            this.resolveGraphicImageSource(
              normalizedCategory,
              normalizedView,
              targetButton
            ).catch(() => ''),
            this.resolveRealImageSource(
              normalizedCategory,
              normalizedView,
              targetButton
            ).catch(() => '')
          ]).then(([resolvedGraphic, resolvedReal]) => {
            if (
              requestId !== this.viewImageRequestId ||
              String(this.activeCategory || '') !== normalizedCategory ||
              String(this.activeView || '') !== normalizedView
            ) return;

            const finalGraphic = resolvedGraphic || immediateGraphic;
            const finalReal = resolvedReal || immediateReal || emptyRealImage;
            return swapCurrentImages(finalGraphic, finalReal, { updateState: false });
          });
        };

        const performImmediateSwitch = () => {
          return swapCurrentImages(immediateGraphic, immediateReal)
            .then(() => {
              updateUrlState();
              resolveExactSourcesInBackground().catch(() => undefined);
            });
        };

        const finishTransition = () => {
          this.viewTransitioning = false;
          this.classList.remove('is-view-loading');

          const queued = this.queuedViewRequest;
          this.queuedViewRequest = null;

          if (
            queued &&
            String(queued.category) === String(this.activeCategory) &&
            String(queued.view) !== String(this.activeView)
          ) {
            window.requestAnimationFrame(() => {
              this.setView(
                queued.view,
                queued.category,
                queued.updateUrl,
                true
              );
            });
          }
        };

        if (shouldAnimate) {
          this.viewTransitioning = true;
          this.classList.add('is-view-loading');

          return this.runViewTransition(
            performImmediateSwitch,
            { fromView: previousView, toView: normalizedView }
          ).finally(finishTransition);
        }

        return performImmediateSwitch();
      }

      openHotspot(btn) {
        if (!btn) return;
        if (!this.graphicMode) {
          this.setGraphicMode(true, {
            preserveFocus: false,
            silent: true,
            afterChange: () => this.openHotspot(btn)
          });
          return;
        }
        if (this.activeHotspot === btn && this.stage?.classList.contains('is-zoomed')) return;

        this.activeHotspot = btn;
        this.lastSelectedHotspot = btn;
        this.hotspots.forEach(hotspot => hotspot.classList.toggle('is-active', hotspot === btn));
        this.positionHotspots();
        this.zoomToHotspot(btn);

        if (this.zone) this.zone.textContent = btn.dataset.title || 'Zona seleccionada';
        if (this.description) {
          this.description.textContent = btn.dataset.description || this.dataset.defaultDescription || '';
        }

        this.selectedInterest = '';
        this.selectedBrand = '';
        this.renderComponents(btn.dataset.components || '');
        this.renderBrands(btn.dataset.brands || '');

        this.syncDetailMediaToMode({ hotspot: btn });

        if (this.infoPanel) {
          this.infoPanel.classList.remove('is-updated');
          void this.infoPanel.offsetWidth;
          this.infoPanel.classList.add('is-updated');
        }

        this.setWhatsApp();
      }

      zoomToHotspot(btn) {
        if (!this.viewport || !this.stage || this.reduceMotion || !this.graphicMode) return;

        const width = this.viewport.clientWidth;
        const height = this.viewport.clientHeight;
        if (!width || !height) return;

        const mobileView = window.matchMedia('(max-width: 820px)').matches;
        const pointX = Number(btn.dataset.anchorX || width / 2);
        const pointY = Number(btn.dataset.anchorY || height / 2);
        const requested = Number(btn.dataset.zoom || 1.6);
        const scale = this.clamp(requested, mobileView ? 1.12 : 1.16, mobileView ? 1.48 : 1.62);

        const targetX = width * .5;
        const targetY = height * (mobileView ? .47 : .50);
        let panX = targetX - pointX * scale;
        let panY = targetY - pointY * scale;

        const minPanX = width - width * scale;
        const minPanY = height - height * scale;
        panX = this.clamp(panX, minPanX, 0);
        panY = this.clamp(panY, minPanY, 0);

        this.viewport.style.setProperty('--mx-focus-scale', scale.toFixed(3));
        this.viewport.style.setProperty('--mx-inverse-scale', (1 / scale).toFixed(5));
        this.viewport.style.setProperty('--mx-pan-x', `${panX.toFixed(2)}px`);
        this.viewport.style.setProperty('--mx-pan-y', `${panY.toFixed(2)}px`);
        this.stage.classList.add('is-zoomed');
      }

      resetZoom(resetDetail = true) {
        this.activeHotspot = null;
        if (resetDetail) this.lastSelectedHotspot = null;
        this.hotspots.forEach(hotspot => hotspot.classList.remove('is-active'));

        if (resetDetail && this.detailImage) {
          this.clearTechnicalPreview({ clearSource: true });
          this.detailImage.style.setProperty('--mx-detail-scale', '1.02');
          this.detailImage.style.transformOrigin = 'center';
          this.detailImage.style.objectPosition = 'center';
          this.syncDetailMediaToMode({ instant: true });
        }

        this.applyRestingView();
      }

      scheduleGeometryUpdate() {
        window.cancelAnimationFrame(this.geometryFrame);
        this.geometryFrame = window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            this.positionHotspots();
            if (this.activeHotspot && this.graphicMode) {
              this.zoomToHotspot(this.activeHotspot);
            } else {
              this.applyRestingView();
            }
          });
        });
      }

      getActiveSlide() {
        return this.slides.find(slide => slide.dataset.slide === this.activeCategory)
          || this.querySelector('.mx-slide-ncx.is-active');
      }

      getImageContentBox() {
        const width = this.viewport?.clientWidth || 0;
        const height = this.viewport?.clientHeight || 0;
        const image = this.getActiveSlide()?.querySelector('[data-view-image]');

        if (!image || !image.naturalWidth || !image.naturalHeight || !width || !height) {
          return { left: 0, top: 0, width, height };
        }

        /* object-fit: cover. El plano llena el escenario completo y los dots
           continúan anclados a la misma imagen, incluso donde existe recorte. */
        const scale = Math.max(width / image.naturalWidth, height / image.naturalHeight);
        const renderedWidth = image.naturalWidth * scale;
        const renderedHeight = image.naturalHeight * scale;

        return {
          left: (width - renderedWidth) / 2,
          top: (height - renderedHeight) / 2,
          width: renderedWidth,
          height: renderedHeight
        };
      }

      positionHotspots() {
        if (!this.viewport) return;
        const box = this.getImageContentBox();
        const viewportWidth = this.viewport.clientWidth;
        const viewportHeight = this.viewport.clientHeight;
        const mobileView = window.matchMedia('(max-width: 820px)').matches;

        this.hotspots.forEach(hotspot => {
          if (!this.isHotspotMatch(hotspot)) return;

          const xPercent = this.clamp(Number(
            mobileView
              ? (hotspot.dataset.mobileX || hotspot.dataset.x || 50)
              : (hotspot.dataset.x || 50)
          ), 0, 100);
          const yPercent = this.clamp(Number(
            mobileView
              ? (hotspot.dataset.mobileY || hotspot.dataset.y || 50)
              : (hotspot.dataset.y || 50)
          ), 0, 100);

          const pointX = box.left + box.width * xPercent / 100;
          const pointY = box.top + box.height * yPercent / 100;

          hotspot.style.left = `${pointX.toFixed(2)}px`;
          hotspot.style.top = `${pointY.toFixed(2)}px`;
          hotspot.dataset.anchorX = pointX.toFixed(3);
          hotspot.dataset.anchorY = pointY.toFixed(3);

          /* Si object-fit: cover recorta la pieza, ocultar también su dot. */
          const visibleMargin = mobileView ? 10 : 14;
          const anchorVisible =
            pointX >= visibleMargin &&
            pointX <= viewportWidth - visibleMargin &&
            pointY >= visibleMargin &&
            pointY <= viewportHeight - visibleMargin;
          hotspot.classList.toggle('is-cropped-out', !anchorVisible);
          hotspot.style.visibility = anchorVisible ? 'visible' : 'hidden';
          hotspot.style.pointerEvents = anchorVisible ? '' : 'none';

          const preferredSide = hotspot.dataset.calloutSide || 'auto';

          /*
            Elegir el lado según el espacio real disponible.
            Incluso una preferencia manual se invierte si produciría un cartel
            cortado contra el borde del viewport.
          */
          const baseLineLength = this.clamp(
            Number(hotspot.dataset.baseLineLength || 66),
            mobileView ? 28 : 34,
            mobileView ? 64 : 96
          );
          const baseLabelWidth = this.clamp(
            Number(hotspot.dataset.baseLabelWidth || (mobileView ? 145 : 210)),
            mobileView ? 96 : 118,
            mobileView ? 160 : 240
          );
          const safeMargin = mobileView ? 16 : 24;
          const calloutGap = mobileView ? 14 : 20;
          const requestedWidth = baseLineLength + baseLabelWidth + calloutGap;
          const roomRight = Math.max(0, viewportWidth - pointX - safeMargin);
          const roomLeft = Math.max(0, pointX - safeMargin);
          const hasRoomRight = roomRight >= requestedWidth;
          const hasRoomLeft = roomLeft >= requestedWidth;

          let calloutToLeft;
          if (preferredSide === 'left' && hasRoomLeft) {
            calloutToLeft = true;
          } else if (preferredSide === 'right' && hasRoomRight) {
            calloutToLeft = false;
          } else if (!hasRoomRight && hasRoomLeft) {
            calloutToLeft = true;
          } else if (!hasRoomLeft && hasRoomRight) {
            calloutToLeft = false;
          } else if (hasRoomLeft !== hasRoomRight) {
            calloutToLeft = hasRoomLeft;
          } else {
            calloutToLeft = roomLeft > roomRight;
          }

          hotspot.classList.toggle('callout-left', calloutToLeft);
          hotspot.classList.toggle('callout-right', !calloutToLeft);
          hotspot.classList.toggle('callout-up', pointY > viewportHeight * .60);
          hotspot.classList.toggle('callout-down', pointY < viewportHeight * .40);

          /*
            Ajustar línea y placa al espacio del lado elegido.
            El texto puede ocupar dos líneas, pero nunca queda oculto.
          */
          const availableSide = calloutToLeft ? roomLeft : roomRight;
          const minimumLine = mobileView ? 26 : 32;
          const minimumLabel = mobileView ? 92 : 112;
          const maximumUsable = Math.max(minimumLine + minimumLabel, availableSide - calloutGap);
          const resolvedLine = this.clamp(
            baseLineLength,
            minimumLine,
            Math.max(minimumLine, maximumUsable - minimumLabel)
          );
          const resolvedLabel = this.clamp(
            maximumUsable - resolvedLine,
            minimumLabel,
            baseLabelWidth
          );
          const resolvedHeight = Number(hotspot.dataset.baseLabelHeight || 34);

          hotspot.style.setProperty('--mx-hotspot-line-length', `${resolvedLine.toFixed(1)}px`);
          hotspot.style.setProperty('--mx-label-max-width', `${resolvedLabel.toFixed(1)}px`);
          hotspot.style.setProperty('--mx-label-min-height', `${resolvedHeight}px`);
        });
      }

      selectInterest(btn) {
        this.components?.querySelectorAll('[data-interest]').forEach(item => item.classList.remove('is-active'));
        btn.classList.add('is-active');
        this.selectedInterest = btn.dataset.interest || btn.textContent.trim();
        this.setWhatsApp();
        this.whatsapp?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      selectBrand(btn) {
        if (!btn) return;
        this.brands?.querySelectorAll('[data-brand]').forEach(item => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        this.selectedBrand = btn.dataset.brand || btn.textContent.trim();
        this.setWhatsApp();
      }

      parseList(value) {
        return String(value || '')
          .split(/[\n,;]+/)
          .map(item => item.trim())
          .filter(Boolean);
      }

      appendOtherOption(items, label) {
        const aliases = label === 'OTRA'
          ? ['otra', 'otra marca', 'otro', 'otro marca']
          : ['otro', 'otro repuesto', 'otra', 'otra opción', 'otra opcion'];
        const cleaned = [];
        const seen = new Set();

        items.forEach(item => {
          const normalized = this.normalizeText(item);
          if (!normalized || aliases.includes(normalized) || seen.has(normalized)) return;
          seen.add(normalized);
          cleaned.push(item);
        });

        cleaned.push(label);
        return cleaned;
      }

      renderComponents(value) {
        if (!this.components) return;
        const items = this.appendOtherOption(this.parseList(value), 'OTRO');
        this.components.innerHTML = '';

        items.forEach((item, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'mx-interest-btn-ncx';
          button.dataset.interest = item === 'OTRO' ? 'otro repuesto' : item;
          button.textContent = item;
          button.style.animationDelay = `${Math.min(index * 45, 270)}ms`;
          this.components.appendChild(button);
        });
      }

      renderBrands(value) {
        if (!this.brands) return;
        const items = this.appendOtherOption(this.parseList(value), 'OTRA');
        this.brands.innerHTML = '';

        items.forEach((item, index) => {
          const button = document.createElement('button');
          const brandValue = item === 'OTRA' ? 'otra marca' : item;
          const logoSource = this.brandLogoMap?.get(this.normalizeText(item)) || '';

          button.type = 'button';
          button.className = 'mx-brand-ncx';
          button.dataset.brand = brandValue;
          button.setAttribute('aria-pressed', 'false');
          button.style.animationDelay = `${Math.min(index * 45, 270)}ms`;

          if (logoSource && item !== 'OTRA') {
            button.classList.add('has-logo');

            const logo = document.createElement('img');
            logo.className = 'mx-brand-logo-ncx';
            logo.src = logoSource;
            logo.alt = '';
            logo.loading = 'lazy';
            logo.decoding = 'async';
            button.appendChild(logo);
          }

          const name = document.createElement('span');
          name.className = 'mx-brand-name-ncx';
          name.textContent = item;
          button.appendChild(name);

          this.brands.appendChild(button);
        });
      }

      updateHotspotDirections() {
        this.positionHotspots();
      }

      replayHotspotCallouts(category) {
        const visibleHotspots = this.hotspots.filter(hotspot => this.isHotspotMatch(hotspot));
        visibleHotspots.forEach(hotspot => hotspot.classList.remove('is-callout-ready'));

        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            this.positionHotspots();
            visibleHotspots.forEach(hotspot => hotspot.classList.add('is-callout-ready'));
          });
        });
      }

      setWhatsApp() {
        if (!this.whatsapp) return;

        const number = this.dataset.whatsappNumber || '';
        const categoryName = this.categoryButtons
          .find(btn => btn.dataset.category === this.activeCategory)?.dataset.categoryName || '';
        const zoneName = this.zone?.textContent || '';
        const typeText = this.selectedInterest || 'un repuesto';
        const brandText = this.selectedBrand ? ` de la marca ${this.selectedBrand}` : '';
        const zoneText = zoneName ? `, relacionado con ${zoneName}` : '';
        const categoryText = categoryName ? ` para la categoría ${categoryName}` : '';

        const consultationMessage = `Hola, ando buscando ${typeText}${brandText}${categoryText}${zoneText}. ¿Me pueden ayudar?`;
        const quotationMessage = `Hola, quiero solicitar una cotización por ${typeText}${brandText}${categoryText}${zoneText}.`;

        this.whatsapp.href = number
          ? `https://wa.me/${number}?text=${encodeURIComponent(consultationMessage)}`
          : '#';

        if (this.quoteButton) {
          this.quoteButton.href = number
            ? `https://wa.me/${number}?text=${encodeURIComponent(quotationMessage)}`
            : '#';
        }
      }

      clamp(value, min, max) {
        return Math.min(max, Math.max(min, Number.isFinite(value) ? value : min));
      }

      normalizeText(text) {
        return String(text || '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .trim()
          .toLowerCase();
      }

      slugify(text) {
        return this.normalizeText(text)
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-|-$/g, '');
      }
    });
  })();


/* ==========================================================
   PARCHE 01 · MAQUINARIA INDUSTRIAL / DOTS MILIMÉTRICOS / PREVIEW
   ========================================================== */
(() => {
  const Explorer = customElements.get('machinery-explorer');
  if (!Explorer) return;
  const proto = Explorer.prototype;

  const industrialHotspotMap = {
    /*
      COORDENADAS NORMALIZADAS SOBRE LA PIEZA FÍSICA DE CADA EQUIPO.
      Importante: x/y apuntan a la máquina, nunca al espacio donde vive la etiqueta.
      La etiqueta puede salir hacia un costado, pero el centro del dot queda sobre
      motor, eje, cilindro, rueda, cabina, cucharón, etc.
    */
    '1': {
      top: {
        'Motor y refrigeración': { x: 32.5, y: 49.5, zoom: 1.78, side: 'right', lift: -6, line: 44 },
        'Filtración y escape': { x: 31.0, y: 39.8, zoom: 1.68, side: 'left', lift: -10, line: 42 },
        'Dirección y eje delantero': { x: 23.5, y: 63.5, zoom: 1.76, side: 'right', lift: 10, line: 44 },
        'Transmisión central': { x: 47.8, y: 52.5, zoom: 1.82, side: 'right', lift: 12, line: 42 },
        'Cabina y controles': { x: 60.5, y: 43.0, zoom: 1.68, side: 'left', lift: -8, line: 42 },
        'Sistema hidráulico': { x: 69.0, y: 52.0, zoom: 1.78, side: 'left', lift: 8, line: 42 },
        'Eje y rodado trasero': { x: 78.5, y: 64.0, zoom: 1.76, side: 'left', lift: 10, line: 42 }
      },
      front: {
        'Filtración y escape': { x: 40.0, y: 26.0, zoom: 1.72, side: 'left', lift: -8, line: 42 },
        'Motor y refrigeración': { x: 40.5, y: 50.5, zoom: 1.86, side: 'left', lift: 6, line: 46 },
        'Dirección y eje delantero': { x: 42.0, y: 71.0, zoom: 1.80, side: 'left', lift: 10, line: 44 },
        'Transmisión': { x: 52.5, y: 57.0, zoom: 1.84, side: 'right', lift: -8, line: 42 },
        'Sistema hidráulico': { x: 52.0, y: 62.0, zoom: 1.82, side: 'left', lift: 8, line: 42 },
        'Cabina y sistema eléctrico': { x: 58.5, y: 30.0, zoom: 1.70, side: 'left', lift: -8, line: 44 },
        'Eje y rodado trasero': { x: 71.0, y: 61.5, zoom: 1.78, side: 'left', lift: 10, line: 42 }
      },
      rear: {
        'Cabina y climatización': { x: 50.0, y: 32.5, zoom: 1.68, side: 'right', lift: -8, line: 44 },
        'Luces y sistema eléctrico': { x: 62.5, y: 41.0, zoom: 1.70, side: 'left', lift: -8, line: 42 },
        'Hidráulica trasera': { x: 50.5, y: 53.5, zoom: 1.86, side: 'left', lift: -8, line: 44 },
        'Eje y diferencial trasero': { x: 50.0, y: 62.5, zoom: 1.88, side: 'right', lift: 4, line: 44 },
        'Enganche de tres puntos': { x: 44.0, y: 70.5, zoom: 1.82, side: 'left', lift: 12, line: 44 },
        'Toma de fuerza': { x: 50.0, y: 68.0, zoom: 1.86, side: 'right', lift: 16, line: 42 },
        'Frenos y rodado trasero': { x: 66.0, y: 63.0, zoom: 1.78, side: 'left', lift: -8, line: 42 }
      }
    },

    '2': {
      top: {
        'Cucharón y acople': { x: 14.5, y: 48.5, zoom: 1.72, side: 'right', lift: 4, line: 44 },
        'Brazo, pluma y cilindros': { x: 31.5, y: 48.0, zoom: 1.80, side: 'right', lift: -10, line: 46 },
        'Corona y sistema de giro': { x: 56.5, y: 50.5, zoom: 1.88, side: 'right', lift: 8, line: 44 },
        'Motor y refrigeración': { x: 81.0, y: 40.0, zoom: 1.82, side: 'left', lift: -10, line: 44 },
        'Cabina y controles': { x: 79.5, y: 66.0, zoom: 1.72, side: 'left', lift: 10, line: 42 },
        'Tren de rodaje': { x: 63.5, y: 29.5, zoom: 1.76, side: 'left', lift: -10, line: 42 },
        'Chasis superior y contrapeso': { x: 72.5, y: 51.5, zoom: 1.74, side: 'left', lift: 10, line: 42 }
      },
      front: {
        'Pluma y cilindros hidráulicos': { x: 45.0, y: 27.5, zoom: 1.80, side: 'right', lift: -10, line: 46 },
        'Cabina y controles': { x: 68.0, y: 45.0, zoom: 1.72, side: 'left', lift: -8, line: 42 },
        'Motor y refrigeración': { x: 82.0, y: 51.5, zoom: 1.84, side: 'left', lift: -6, line: 44 },
        'Bombas y sistema de giro': { x: 58.0, y: 57.0, zoom: 1.88, side: 'right', lift: 8, line: 44 },
        'Tren de rodaje': { x: 66.0, y: 74.0, zoom: 1.78, side: 'left', lift: 12, line: 44 },
        'Cucharón y acople': { x: 19.0, y: 73.0, zoom: 1.74, side: 'right', lift: 10, line: 44 },
        'Sistema eléctrico y sensores': { x: 70.0, y: 37.5, zoom: 1.70, side: 'left', lift: -14, line: 42 }
      },
      rear: {
        'Motor y refrigeración': { x: 38.5, y: 48.0, zoom: 1.82, side: 'right', lift: -8, line: 44 },
        'Cabina y sistema eléctrico': { x: 62.0, y: 46.0, zoom: 1.72, side: 'left', lift: -8, line: 42 },
        'Contrapeso y estructura': { x: 40.5, y: 53.0, zoom: 1.72, side: 'right', lift: 8, line: 42 },
        'Bombas y sistema hidráulico': { x: 49.0, y: 58.5, zoom: 1.88, side: 'left', lift: 8, line: 44 },
        'Corona y reductor de giro': { x: 50.0, y: 65.0, zoom: 1.90, side: 'right', lift: 12, line: 44 },
        'Tren de rodaje': { x: 65.0, y: 76.5, zoom: 1.80, side: 'left', lift: 12, line: 42 },
        'Capot y accesos de servicio': { x: 39.0, y: 43.0, zoom: 1.70, side: 'right', lift: -12, line: 42 }
      }
    },

    '3': {
      top: {
        'Cucharón delantero': { x: 10.5, y: 50.0, zoom: 1.70, side: 'right', lift: 4, line: 42 },
        'Motor y cargador frontal': { x: 28.5, y: 49.5, zoom: 1.82, side: 'right', lift: -8, line: 44 },
        'Cabina y controles': { x: 50.0, y: 49.0, zoom: 1.70, side: 'left', lift: -10, line: 42 },
        'Transmisión y eje trasero': { x: 58.0, y: 61.5, zoom: 1.86, side: 'right', lift: 10, line: 44 },
        'Brazo retro y cucharón': { x: 82.0, y: 43.5, zoom: 1.80, side: 'left', lift: -8, line: 44 },
        'Estabilizadores': { x: 65.0, y: 67.0, zoom: 1.74, side: 'left', lift: 12, line: 42 },
        'Ejes, frenos y rodados': { x: 55.5, y: 65.0, zoom: 1.78, side: 'left', lift: 12, line: 42 }
      },
      front: {
        'Cucharón delantero': { x: 16.5, y: 74.0, zoom: 1.74, side: 'right', lift: 10, line: 44 },
        'Brazos y sistema hidráulico frontal': { x: 36.0, y: 56.0, zoom: 1.82, side: 'right', lift: -8, line: 44 },
        'Motor y refrigeración': { x: 40.0, y: 51.0, zoom: 1.84, side: 'right', lift: -8, line: 44 },
        'Cabina y sistema eléctrico': { x: 55.0, y: 35.0, zoom: 1.70, side: 'left', lift: -10, line: 42 },
        'Transmisión, ejes y rodados': { x: 65.0, y: 66.0, zoom: 1.84, side: 'left', lift: 10, line: 44 },
        'Brazo retro y cucharón': { x: 81.0, y: 37.0, zoom: 1.80, side: 'left', lift: -8, line: 44 },
        'Dirección y eje delantero': { x: 43.0, y: 72.0, zoom: 1.78, side: 'right', lift: 12, line: 42 }
      },
      rear: {
        'Brazo retro y cilindros': { x: 50.5, y: 39.0, zoom: 1.84, side: 'right', lift: -10, line: 44 },
        'Cabina y controles': { x: 39.5, y: 34.0, zoom: 1.70, side: 'right', lift: -10, line: 42 },
        'Distribuidor hidráulico': { x: 50.0, y: 64.0, zoom: 1.88, side: 'left', lift: 8, line: 44 },
        'Eje y diferencial trasero': { x: 50.0, y: 73.0, zoom: 1.88, side: 'right', lift: 12, line: 44 },
        'Estabilizadores': { x: 26.0, y: 80.0, zoom: 1.76, side: 'right', lift: 12, line: 42 },
        'Luces y sistema eléctrico': { x: 31.0, y: 55.0, zoom: 1.70, side: 'right', lift: -10, line: 42 },
        'Frenos y rodados': { x: 64.0, y: 69.0, zoom: 1.78, side: 'left', lift: 10, line: 42 }
      }
    }
  };

  proto.applyIndustrialHotspotRefinement = function() {
    /*
      La biblioteca nueva de Construcción ya contiene sus coordenadas definitivas.
      No permitir que este parche legacy vuelva a pisarlas por coincidencia de títulos.
      Se conserva el parche para cualquier instancia antigua que todavía lo necesite.
    */
    if (this.hotspotPlane?.dataset?.constructionLibraryReady === 'true') {
      this.positionHotspots?.();
      return;
    }

    this.querySelectorAll('[data-hotspot][data-category]').forEach(hotspot => {
      const category = String(hotspot.dataset.category || '');
      if (!['1', '2', '3'].includes(category)) return;

      const view = hotspot.dataset.view || 'front';
      const title = hotspot.dataset.title || '';
      const cfg = industrialHotspotMap?.[category]?.[view]?.[title];
      if (!cfg) return;

      const mobileX = cfg.mobileX ?? cfg.x;
      const mobileY = cfg.mobileY ?? cfg.y;

      hotspot.dataset.x = String(cfg.x);
      hotspot.dataset.y = String(cfg.y);
      hotspot.dataset.mobileX = String(mobileX);
      hotspot.dataset.mobileY = String(mobileY);
      hotspot.dataset.zoom = String(cfg.zoom ?? (hotspot.dataset.zoom || 1.6));
      hotspot.dataset.calloutSide = cfg.side || 'auto';

      hotspot.style.setProperty('--x', `${cfg.x}%`);
      hotspot.style.setProperty('--y', `${cfg.y}%`);
      hotspot.style.setProperty('--mobile-x', `${mobileX}%`);
      hotspot.style.setProperty('--mobile-y', `${mobileY}%`);
      hotspot.style.setProperty('--mx-label-lift', `${Number(cfg.lift || 0)}px`);
      hotspot.style.setProperty('--mx-hotspot-line-length', `${Number(cfg.line || 44)}px`);
    });

    this.positionHotspots?.();
  };

  const originalConnectedCallback = proto.connectedCallback;
  proto.connectedCallback = function() {
    originalConnectedCallback.call(this);
    this.applyIndustrialHotspotRefinement?.();
    this.syncDetailMediaToMode?.({ instant: true });
  };

  const originalSetView = proto.setView;
  proto.setView = function(view, category = this.activeCategory, updateUrl = true, animate = true) {
    return originalSetView.call(this, view, category, updateUrl, animate);
  };

  proto.syncDetailMediaToMode = function(options = {}) {
    if (!this.detailImage) return;

    const hotspot = options.hotspot || this.activeHotspot || this.lastSelectedHotspot || null;
    const { realSource, technicalSource } = this.getDetailPreviewSources(hotspot);
    const instant = Boolean(options.instant);
    const mobileView = window.matchMedia('(max-width: 820px)').matches;
    const x = this.clamp(Number(mobileView
      ? (hotspot?.dataset.mobileX || hotspot?.dataset.x || 50)
      : (hotspot?.dataset.x || 50)), 0, 100);
    const y = this.clamp(Number(mobileView
      ? (hotspot?.dataset.mobileY || hotspot?.dataset.y || 50)
      : (hotspot?.dataset.y || 50)), 0, 100);

    const hasHotspot = Boolean(hotspot);
    const focusPosition = `${x}% ${y}%`;
    const hotspotZoom = this.clamp(Number(hotspot?.dataset.zoom || 1.6), 1, 2.4);
    const previewScale = hasHotspot
      ? this.clamp(hotspotZoom + (mobileView ? 0.10 : 0.16), 1.22, mobileView ? 1.54 : 1.86)
      : 1.02;

    this.detailImage.style.objectPosition = hasHotspot ? focusPosition : 'center';
    this.detailImage.style.transformOrigin = hasHotspot ? focusPosition : 'center';
    this.detailImage.style.setProperty('--mx-detail-scale', String(previewScale));
    this.detailImage.classList.add('is-active');
    this.setPreviewImageSource(
      this.detailImage,
      realSource,
      hotspot?.dataset.title || this.zone?.textContent || '',
      instant
    );

    this.detailMedia?.classList.toggle('is-focused-preview', hasHotspot);
    this.detailMedia?.classList.add('is-real-source');
    this.detailMedia?.classList.remove('is-graphic-source');

    const showTechnicalZone = Boolean(hotspot && technicalSource && this.detailZoneOverlay);
    this.detailMedia?.classList.toggle('has-technical-zone', showTechnicalZone);

    if (showTechnicalZone) {
      const zoneWidth = mobileView
        ? this.clamp(29 + (hotspotZoom - 1.4) * 6.5, 28, 36)
        : this.clamp(22 + (hotspotZoom - 1.4) * 8.5, 22, 31);
      const zoneHeight = mobileView
        ? this.clamp(34 + (hotspotZoom - 1.4) * 7.5, 34, 44)
        : this.clamp(24 + (hotspotZoom - 1.4) * 12.0, 24, 37);

      const safeX = this.clamp(x, zoneWidth / 2 + 2, 100 - zoneWidth / 2 - 2);
      const safeY = this.clamp(y, zoneHeight / 2 + 2, 100 - zoneHeight / 2 - 2);
      const zoneLeft = safeX - zoneWidth / 2;
      const zoneTop = safeY - zoneHeight / 2;
      const zoneRight = 100 - zoneLeft - zoneWidth;
      const zoneBottom = 100 - zoneTop - zoneHeight;

      this.detailMedia.style.setProperty('--mx-zone-x', `${safeX}%`);
      this.detailMedia.style.setProperty('--mx-zone-y', `${safeY}%`);
      this.detailMedia.style.setProperty('--mx-zone-radius-x', `${zoneWidth / 2}%`);
      this.detailMedia.style.setProperty('--mx-zone-radius-y', `${zoneHeight / 2}%`);
      this.detailMedia.style.setProperty('--mx-zone-width', `${zoneWidth}%`);
      this.detailMedia.style.setProperty('--mx-zone-height', `${zoneHeight}%`);
      this.detailMedia.style.setProperty('--mx-zone-left', `${zoneLeft}%`);
      this.detailMedia.style.setProperty('--mx-zone-top', `${zoneTop}%`);
      this.detailMedia.style.setProperty('--mx-zone-right', `${zoneRight}%`);
      this.detailMedia.style.setProperty('--mx-zone-bottom', `${zoneBottom}%`);

      this.detailZoneOverlay.style.objectFit = 'cover';
      this.detailZoneOverlay.style.objectPosition = hasHotspot ? focusPosition : 'center';
      this.detailZoneOverlay.style.transformOrigin = hasHotspot ? focusPosition : 'center';
      this.detailZoneOverlay.style.setProperty(
        '--mx-detail-scale',
        String(this.clamp(previewScale + 0.04, 1.24, mobileView ? 1.62 : 1.92))
      );
      this.detailZoneOverlay.classList.add('is-active');
      this.setPreviewImageSource(this.detailZoneOverlay, technicalSource, '', instant);

      if (this.detailModeLabel) this.detailModeLabel.textContent = 'DETALLE TÉCNICO SINCRONIZADO';
      if (this.infoSyncText) this.infoSyncText.textContent = 'AMPLIACIÓN EN TIEMPO REAL';
    } else {
      this.clearTechnicalPreview();
      if (this.detailModeLabel) this.detailModeLabel.textContent = 'VISTA ACTIVA SINCRONIZADA';
      if (this.infoSyncText) this.infoSyncText.textContent = 'VISTA REAL EN TIEMPO REAL';
    }
  };

  const originalResetZoom = proto.resetZoom;
  proto.resetZoom = function(resetDetail = true) {
    originalResetZoom.call(this, resetDetail);
    this.detailMedia?.classList.remove('is-focused-preview');
  };

  const retuneExisting = (root = document) => {
    root.querySelectorAll('machinery-explorer').forEach(instance => {
      if (!instance || !instance._initialized) return;
      instance.applyIndustrialHotspotRefinement?.();
      instance.scheduleGeometryUpdate?.();
      instance.syncDetailMediaToMode?.({ instant: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => retuneExisting(), { once: true });
  } else {
    retuneExisting();
  }

  window.setTimeout(() => retuneExisting(), 120);
})();


/* ==========================================================
   PARCHE 02 · TRANSICIONES CINEMÁTICAS + ZOOM REAL BLOQUEADO
   Conserva toda la lógica anterior y mejora únicamente:
   - cambio entre vista superior / frontal / trasera;
   - sincronización del preview real al tocar un dot;
   - persistencia del zoom al pasar el mouse por el preview.
   ========================================================== */
(() => {
  const Explorer = customElements.get('machinery-explorer');
  if (!Explorer) return;

  const proto = Explorer.prototype;

  proto.getPremiumTransitionProfile = function(fromView = 'front', toView = 'front') {
    const key = `${fromView}>${toView}`;
    const profiles = {
      'front>top':  { axis: 'x', direction: -1, origin: '50% 18%', sweep: 'vertical' },
      'top>front':  { axis: 'x', direction:  1, origin: '50% 82%', sweep: 'vertical-reverse' },
      'front>rear': { axis: 'y', direction: -1, origin: '18% 50%', sweep: 'horizontal' },
      'rear>front': { axis: 'y', direction:  1, origin: '82% 50%', sweep: 'horizontal-reverse' },
      'top>rear':   { axis: 'xy', direction: -1, origin: '24% 24%', sweep: 'diagonal' },
      'rear>top':   { axis: 'xy', direction:  1, origin: '76% 76%', sweep: 'diagonal-reverse' }
    };

    return profiles[key] || {
      axis: 'y',
      direction: toView === 'rear' ? -1 : 1,
      origin: '50% 50%',
      sweep: 'horizontal'
    };
  };

  proto.runViewTransition = function(callback, meta = {}) {
    if (typeof callback !== 'function') return Promise.resolve();
    if (!this.stage || this.reduceMotion) return Promise.resolve(callback());

    const fromView = meta.fromView || this.activeView || 'front';
    const toView = meta.toView || fromView;
    const motion = this.getViewTransitionMotion(fromView, toView);
    const profile = this.getPremiumTransitionProfile(fromView, toView);
    const outgoingTargets = this.getViewTransitionVisualTargets();
    const durationOut = 390;
    const durationIn = 590;
    const totalDuration = durationOut + durationIn + 90;

    this.clearViewTransitionAnimations();
    this.stage.dataset.viewFrom = fromView;
    this.stage.dataset.viewTo = toView;
    this.stage.dataset.viewSweep = profile.sweep;
    this.stage.classList.add(
      'is-view-transitioning',
      'is-view-transitioning-3d',
      'is-premium-view-transition'
    );
    this.hotspotPlane?.classList.add('is-view-transitioning');
    this.setAttribute('aria-busy', 'true');

    const atmosphereAnimations = [];

    if (this.viewTransitionDepth?.animate) {
      atmosphereAnimations.push(this.viewTransitionDepth.animate([
        { opacity: 0, transform: 'scale(.965) rotate(0deg)', filter: 'blur(1px)' },
        { opacity: .34, transform: 'scale(.988) rotate(.18deg)', filter: 'blur(0px)', offset: .16 },
        { opacity: .76, transform: 'scale(1.012) rotate(0deg)', filter: 'blur(0px)', offset: .47 },
        { opacity: .30, transform: 'scale(1.028) rotate(-.12deg)', filter: 'blur(.4px)', offset: .78 },
        { opacity: 0, transform: 'scale(1.045) rotate(0deg)', filter: 'blur(1.2px)' }
      ], {
        duration: totalDuration,
        easing: 'cubic-bezier(.2,.72,.2,1)',
        fill: 'both'
      }));
    }

    if (this.viewTransitionSheen?.animate) {
      const verticalSweep = profile.sweep.includes('vertical');
      const reverseSweep = profile.sweep.includes('reverse');
      const startTransform = verticalSweep
        ? `translate3d(0,${reverseSweep ? '120%' : '-120%'},0) rotate(${reverseSweep ? '-8deg' : '8deg'})`
        : `translate3d(${reverseSweep ? '120%' : '-120%'},0,0) skewX(${reverseSweep ? '11deg' : '-11deg'})`;
      const endTransform = verticalSweep
        ? `translate3d(0,${reverseSweep ? '-120%' : '120%'},0) rotate(${reverseSweep ? '-8deg' : '8deg'})`
        : `translate3d(${reverseSweep ? '-120%' : '120%'},0,0) skewX(${reverseSweep ? '11deg' : '-11deg'})`;

      atmosphereAnimations.push(this.viewTransitionSheen.animate([
        { opacity: 0, transform: startTransform },
        { opacity: .12, offset: .10 },
        { opacity: .68, transform: 'translate3d(0,0,0)', offset: .46 },
        { opacity: .18, offset: .72 },
        { opacity: 0, transform: endTransform }
      ], {
        duration: totalDuration,
        easing: 'cubic-bezier(.18,.78,.18,1)',
        fill: 'both'
      }));
    }

    if (this.viewport?.animate) {
      atmosphereAnimations.push(this.viewport.animate([
        { filter: 'brightness(1) saturate(1)', transform: 'translateZ(0) scale(1)' },
        { filter: 'brightness(.94) saturate(.92)', transform: 'translateZ(0) scale(.996)', offset: .34 },
        { filter: 'brightness(.90) saturate(.88)', transform: 'translateZ(0) scale(.992)', offset: .48 },
        { filter: 'brightness(1.035) saturate(1.04)', transform: 'translateZ(0) scale(1.003)', offset: .72 },
        { filter: 'brightness(1) saturate(1)', transform: 'translateZ(0) scale(1)' }
      ], {
        duration: totalDuration,
        easing: 'cubic-bezier(.16,1,.3,1)',
        fill: 'both'
      }));
    }

    this.viewTransitionAnimations = [
      ...(this.viewTransitionAnimations || []),
      ...atmosphereAnimations
    ];

    const animateTargets = (targets, phase) => {
      const validTargets = (targets || []).filter(Boolean);
      if (!validTargets.length || typeof validTargets[0]?.animate !== 'function') {
        return Promise.resolve();
      }

      const animations = validTargets.map((element, index) => {
        const depth = 1 + index * .10;
        const stagger = Math.min(index * 22, 66);
        const outgoing = phase === 'out';
        const sourceMotion = outgoing ? motion.out : motion.incoming;
        const direction = profile.direction || 1;
        const rx = sourceMotion.rx * depth;
        const ry = sourceMotion.ry * depth;
        const tx = sourceMotion.tx * depth;
        const ty = sourceMotion.ty * depth;
        const startTransform = outgoing
          ? this.buildViewTransform()
          : this.buildViewTransform({ rx, ry, tx, ty, scale: sourceMotion.scale + index * .003 });
        const endTransform = outgoing
          ? this.buildViewTransform({ rx, ry, tx, ty, scale: sourceMotion.scale + index * .003 })
          : this.buildViewTransform();

        element.style.willChange = 'transform, opacity, filter, clip-path';
        element.style.transformOrigin = profile.origin;

        const middleTransform = this.buildViewTransform({
          rx: outgoing ? rx * .34 : rx * .28,
          ry: outgoing ? ry * .34 : ry * .28,
          tx: outgoing ? tx * .28 : tx * .24,
          ty: outgoing ? ty * .28 : ty * .24,
          scale: 1.012 + index * .002
        });

        const keyframes = outgoing
          ? [
              {
                opacity: 1,
                transform: startTransform,
                clipPath: 'inset(0% 0% 0% 0% round 0px)',
                filter: 'blur(0px) brightness(1) saturate(1)',
                offset: 0
              },
              {
                opacity: .99,
                transform: middleTransform,
                clipPath: 'inset(.1% .14% .1% .14% round 7px)',
                filter: 'blur(.18px) brightness(.99) saturate(.99)',
                offset: .38
              },
              {
                opacity: .72,
                transform: this.buildViewTransform({
                  rx: rx * .72,
                  ry: ry * .72,
                  tx: tx * .72,
                  ty: ty * .72,
                  scale: sourceMotion.scale + .004
                }),
                clipPath: 'inset(.45% .62% .45% .62% round 12px)',
                filter: 'blur(1.4px) brightness(.93) saturate(.94)',
                offset: .72
              },
              {
                opacity: .05,
                transform: endTransform,
                clipPath: profile.axis === 'x'
                  ? `inset(${direction < 0 ? '7%' : '0%'} .9% ${direction < 0 ? '0%' : '7%'} .9% round 18px)`
                  : `inset(.9% ${direction < 0 ? '7%' : '.9%'} .9% ${direction < 0 ? '.9%' : '7%'} round 18px)`,
                filter: 'blur(4.8px) brightness(.82) saturate(.84)',
                offset: 1
              }
            ]
          : [
              {
                opacity: .04,
                transform: startTransform,
                clipPath: profile.axis === 'x'
                  ? `inset(${direction < 0 ? '0%' : '7%'} .9% ${direction < 0 ? '7%' : '0%'} .9% round 18px)`
                  : `inset(.9% ${direction < 0 ? '.9%' : '7%'} .9% ${direction < 0 ? '7%' : '.9%'} round 18px)`,
                filter: 'blur(5px) brightness(.84) saturate(.86)',
                offset: 0
              },
              {
                opacity: .72,
                transform: this.buildViewTransform({
                  rx: rx * .58,
                  ry: ry * .58,
                  tx: tx * .58,
                  ty: ty * .58,
                  scale: 1.018 + index * .002
                }),
                clipPath: 'inset(.42% .58% .42% .58% round 12px)',
                filter: 'blur(1.35px) brightness(.96) saturate(.96)',
                offset: .40
              },
              {
                opacity: 1,
                transform: this.buildViewTransform({
                  rx: -rx * .055,
                  ry: -ry * .055,
                  tx: -tx * .035,
                  ty: -ty * .035,
                  scale: 1.004
                }),
                clipPath: 'inset(.05% .08% .05% .08% round 5px)',
                filter: 'blur(0px) brightness(1.025) saturate(1.025)',
                offset: .82
              },
              {
                opacity: 1,
                transform: endTransform,
                clipPath: 'inset(0% 0% 0% 0% round 0px)',
                filter: 'blur(0px) brightness(1) saturate(1)',
                offset: 1
              }
            ];

        return element.animate(keyframes, {
          duration: outgoing ? durationOut : durationIn,
          delay: stagger,
          easing: outgoing
            ? 'cubic-bezier(.42,0,.22,1)'
            : 'cubic-bezier(.16,1,.3,1)',
          fill: 'forwards'
        });
      });

      this.viewTransitionAnimations = [
        ...(this.viewTransitionAnimations || []),
        ...animations
      ];

      return Promise.all(animations.map(animation => animation.finished.catch(() => undefined)));
    };

    return animateTargets(outgoingTargets, 'out')
      .then(() => Promise.resolve(callback()))
      .then(() => new Promise(resolve => {
        window.requestAnimationFrame(() => window.requestAnimationFrame(resolve));
      }))
      .then(() => animateTargets(this.getViewTransitionVisualTargets(), 'in'))
      .then(() => {
        this.positionHotspots?.();
        if (this.graphicMode) this.replayHotspotCallouts?.(this.activeCategory);
      })
      .finally(() => {
        this.clearViewTransitionAnimations();
        this.stage?.classList.remove(
          'is-view-transitioning',
          'is-view-transitioning-3d',
          'is-premium-view-transition'
        );
        this.hotspotPlane?.classList.remove('is-view-transitioning');
        this.stage?.removeAttribute('data-view-from');
        this.stage?.removeAttribute('data-view-to');
        this.stage?.removeAttribute('data-view-sweep');
        this.removeAttribute('aria-busy');
      });
  };

  const previousSyncDetailMediaToMode = proto.syncDetailMediaToMode;

  proto.syncDetailMediaToMode = function(options = {}) {
    previousSyncDetailMediaToMode.call(this, options);

    if (!this.detailImage || !this.detailMedia) return;

    const hotspot = options.hotspot || this.activeHotspot || this.lastSelectedHotspot || null;
    const mobileView = window.matchMedia('(max-width: 820px)').matches;

    if (!hotspot) {
      this.detailMedia.classList.remove('is-zoom-lock', 'is-detail-zoom-enter');
      this.detailMedia.removeAttribute('data-detail-focus');
      this.detailMedia.style.removeProperty('--mx-detail-focus-position');
      return;
    }

    const x = this.clamp(Number(mobileView
      ? (hotspot.dataset.mobileX || hotspot.dataset.x || 50)
      : (hotspot.dataset.x || 50)), 0, 100);
    const y = this.clamp(Number(mobileView
      ? (hotspot.dataset.mobileY || hotspot.dataset.y || 50)
      : (hotspot.dataset.y || 50)), 0, 100);
    const requestedZoom = this.clamp(Number(hotspot.dataset.zoom || 1.6), 1, 2.4);
    const lockedScale = mobileView
      ? this.clamp(1.40 + (requestedZoom - 1.4) * .42, 1.40, 1.68)
      : this.clamp(1.58 + (requestedZoom - 1.4) * .56, 1.58, 1.96);
    const overlayScale = this.clamp(
      lockedScale + (mobileView ? .025 : .035),
      1.42,
      mobileView ? 1.72 : 2.02
    );
    const focusPosition = `${x}% ${y}%`;

    this.detailMedia.dataset.detailFocus = 'locked';
    this.detailMedia.style.setProperty('--mx-detail-focus-position', focusPosition);
    this.detailMedia.classList.add('is-focused-preview', 'is-zoom-lock');

    this.detailImage.style.objectPosition = focusPosition;
    this.detailImage.style.transformOrigin = focusPosition;
    this.detailImage.style.setProperty('--mx-detail-scale', lockedScale.toFixed(3));

    if (this.detailZoneOverlay) {
      this.detailZoneOverlay.style.objectPosition = focusPosition;
      this.detailZoneOverlay.style.transformOrigin = focusPosition;
      this.detailZoneOverlay.style.setProperty('--mx-detail-scale', overlayScale.toFixed(3));
    }

    this.detailMedia.classList.remove('is-detail-zoom-enter');
    void this.detailMedia.offsetWidth;
    this.detailMedia.classList.add('is-detail-zoom-enter');

    window.clearTimeout(this.detailZoomEnterTimer);
    this.detailZoomEnterTimer = window.setTimeout(() => {
      this.detailMedia?.classList.remove('is-detail-zoom-enter');
    }, 820);
  };

  const previousResetZoomPremium = proto.resetZoom;
  proto.resetZoom = function(resetDetail = true) {
    previousResetZoomPremium.call(this, resetDetail);

    if (resetDetail) {
      window.clearTimeout(this.detailZoomEnterTimer);
      this.detailMedia?.classList.remove(
        'is-zoom-lock',
        'is-detail-zoom-enter'
      );
      this.detailMedia?.removeAttribute('data-detail-focus');
      this.detailMedia?.style.removeProperty('--mx-detail-focus-position');
    }
  };
})();


/* ============================================================
   NC GROUP · SYNC EXACTO DOT -> PANEL TÉCNICO
   La lente usa LA MISMA gráfica activa y LA MISMA coordenada
   porcentual del hotspot. No depende del encuadre de la foto real.
   ============================================================ */
(() => {
  const tag = 'machinery-explorer';
  const Ctor = customElements.get(tag);
  if (!Ctor || Ctor.prototype.__mxExactDetailSyncInstalled) return;

  const proto = Ctor.prototype;
  proto.__mxExactDetailSyncInstalled = true;

  proto.ensureExactDetailLens = function() {
    if (!this.detailMedia) return null;

    let lens = this.detailMedia.querySelector('[data-exact-detail-lens]');
    if (lens) return lens;

    lens = document.createElement('div');
    lens.className = 'mx-exact-detail-lens-ncx';
    lens.dataset.exactDetailLens = '';
    lens.setAttribute('aria-hidden', 'true');

    const image = document.createElement('img');
    image.className = 'mx-exact-detail-lens-image-ncx';
    image.alt = '';
    image.decoding = 'async';
    image.draggable = false;

    const reticle = document.createElement('span');
    reticle.className = 'mx-exact-detail-reticle-ncx';

    const cornerA = document.createElement('span');
    cornerA.className = 'mx-exact-detail-corner-ncx mx-exact-detail-corner-ncx--a';

    const cornerB = document.createElement('span');
    cornerB.className = 'mx-exact-detail-corner-ncx mx-exact-detail-corner-ncx--b';

    lens.append(image, reticle, cornerA, cornerB);
    this.detailMedia.appendChild(lens);

    this.exactDetailLens = lens;
    this.exactDetailLensImage = image;

    return lens;
  };

  proto.hideExactDetailLens = function() {
    const lens = this.exactDetailLens || this.detailMedia?.querySelector('[data-exact-detail-lens]');
    if (!lens) return;
    lens.classList.remove('is-active', 'is-ready');
  };

  proto.positionExactDetailLens = function(hotspot, technicalSource, instant = false) {
    if (!this.detailMedia || !hotspot || !technicalSource) {
      this.hideExactDetailLens?.();
      return;
    }

    const lens = this.ensureExactDetailLens?.();
    const image = this.exactDetailLensImage || lens?.querySelector('.mx-exact-detail-lens-image-ncx');
    if (!lens || !image) return;

    const mobileView = window.matchMedia('(max-width: 820px)').matches;

    const x = this.clamp(Number(
      mobileView
        ? (hotspot.dataset.mobileX || hotspot.dataset.x || 50)
        : (hotspot.dataset.x || 50)
    ), 0, 100);

    const y = this.clamp(Number(
      mobileView
        ? (hotspot.dataset.mobileY || hotspot.dataset.y || 50)
        : (hotspot.dataset.y || 50)
    ), 0, 100);

    const requestedZoom = this.clamp(Number(hotspot.dataset.zoom || 1.6), 1, 2.4);
    const detailZoom = mobileView
      ? this.clamp(1.38 + (requestedZoom - 1.4) * .26, 1.34, 1.60)
      : this.clamp(1.46 + (requestedZoom - 1.4) * .34, 1.42, 1.76);

    lens.dataset.hotspotTitle = hotspot.dataset.title || '';
    lens.style.setProperty('--mx-exact-source-x', `${x}%`);
    lens.style.setProperty('--mx-exact-source-y', `${y}%`);

    const applyGeometry = () => {
      if (!image.naturalWidth || !image.naturalHeight || !this.detailMedia) return;

      const panelW = this.detailMedia.clientWidth;
      const panelH = this.detailMedia.clientHeight;
      const lensW = lens.clientWidth;
      const lensH = lens.clientHeight;

      if (!panelW || !panelH || !lensW || !lensH) return;

      /*
        Replicamos exactamente object-fit: cover.
        Es la misma matemática que usa el escenario principal para ubicar dots.
      */
      const coverScale = Math.max(
        panelW / image.naturalWidth,
        panelH / image.naturalHeight
      );

      const renderedW = image.naturalWidth * coverScale;
      const renderedH = image.naturalHeight * coverScale;
      const renderedLeft = (panelW - renderedW) / 2;
      const renderedTop = (panelH - renderedH) / 2;

      const sourcePointX = renderedLeft + renderedW * (x / 100);
      const sourcePointY = renderedTop + renderedH * (y / 100);

      /*
        La imagen interna conserva el mismo canvas/aspecto del panel.
        Se amplía y se desplaza para que EL PUNTO EXACTO seleccionado
        termine en el centro de la lente.
      */
      const scaledPanelW = panelW * detailZoom;
      const scaledPanelH = panelH * detailZoom;

      const offsetX = lensW / 2 - sourcePointX * detailZoom;
      const offsetY = lensH / 2 - sourcePointY * detailZoom;

      image.style.width = `${scaledPanelW.toFixed(2)}px`;
      image.style.height = `${scaledPanelH.toFixed(2)}px`;
      image.style.left = `${offsetX.toFixed(2)}px`;
      image.style.top = `${offsetY.toFixed(2)}px`;

      lens.style.setProperty('--mx-exact-zoom', detailZoom.toFixed(3));
      lens.classList.add('is-ready');

      if (instant) {
        lens.classList.add('is-active');
      } else {
        lens.classList.remove('is-active');
        void lens.offsetWidth;
        lens.classList.add('is-active');
      }
    };

    const current = image.currentSrc || image.getAttribute('src') || '';

    if (current !== technicalSource) {
      lens.classList.remove('is-ready');

      const onSettled = () => {
        image.removeEventListener('load', onSettled);
        image.removeEventListener('error', onSettled);
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(applyGeometry);
        });
      };

      image.addEventListener('load', onSettled, { once: true });
      image.addEventListener('error', onSettled, { once: true });
      image.src = technicalSource;
    } else if (image.complete && image.naturalWidth) {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(applyGeometry);
      });
    }
  };

  const previousExactSync = proto.syncDetailMediaToMode;

  proto.syncDetailMediaToMode = function(options = {}) {
    previousExactSync.call(this, options);

    const hotspot = options.hotspot || this.activeHotspot || this.lastSelectedHotspot || null;

    if (!hotspot) {
      this.hideExactDetailLens?.();
      return;
    }

    const sources = this.getDetailPreviewSources?.(hotspot) || {};
    const technicalSource = sources.technicalSource || sources.graphicSource || '';

    /*
      Se oculta el overlay antiguo: intentaba calzar la gráfica encima de una
      fotografía con encuadre diferente y era la causa del desfase visual.
    */
    if (this.detailZoneOverlay) {
      this.detailZoneOverlay.classList.remove('is-active');
      this.detailZoneOverlay.style.opacity = '0';
    }

    this.positionExactDetailLens?.(
      hotspot,
      technicalSource,
      Boolean(options.instant)
    );
  };

  const previousExactReset = proto.resetZoom;
  proto.resetZoom = function(resetDetail = true) {
    previousExactReset.call(this, resetDetail);
    if (resetDetail) this.hideExactDetailLens?.();
  };

  const previousExactSetView = proto.setView;
  proto.setView = function(view, category = this.activeCategory, updateUrl = true, animate = true) {
    this.hideExactDetailLens?.();
    return previousExactSetView.call(this, view, category, updateUrl, animate);
  };

  const previousExactSelectCategory = proto.selectCategory;
  if (typeof previousExactSelectCategory === 'function') {
    proto.selectCategory = function(...args) {
      this.hideExactDetailLens?.();
      return previousExactSelectCategory.apply(this, args);
    };
  }

  const previousExactScheduleGeometry = proto.scheduleGeometryUpdate;
  proto.scheduleGeometryUpdate = function() {
    previousExactScheduleGeometry.call(this);

    window.clearTimeout(this.exactDetailGeometryTimer);
    this.exactDetailGeometryTimer = window.setTimeout(() => {
      const hotspot = this.activeHotspot || this.lastSelectedHotspot || null;
      if (!hotspot) return;
      const sources = this.getDetailPreviewSources?.(hotspot) || {};
      const technicalSource = sources.technicalSource || sources.graphicSource || '';
      this.positionExactDetailLens?.(hotspot, technicalSource, true);
    }, 80);
  };
})();
